//#region imports
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, OnDestroy,  OnInit,  Output, ViewChild, QueryList, ViewChildren, HostListener } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ModalDirective } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import { forkJoin, Observable, ReplaySubject, Subject, Subscription } from "rxjs";
import { BOCity } from "../../models/BOCity.model";
import { BOCountry } from "../../models/BOCountry.model";
import { BOIps } from "../../models/BOIps.model";
import { BOItem } from "../../models/BOItem.model";
import { BOPersonOcupation } from "../../models/BOPersonOcupation.model";
import { BOState } from "../../models/BOState.model";


import { BiologicalSexService } from "../../services/biologicalSex.service";
import { CityService } from "../../services/city.service";
import { ConsultationCauseService } from "../../services/consultationCause.service";
import { CountryService } from "../../services/country.service";
import { DiagnosticTypeService } from "../../services/diagnosticType.service";
import { DisabilityCategoryService } from "../../services/disabilityCategory.service";
import { EpsService } from "../../services/eps.service";
import { EthnicCommunityService } from "../../services/ethnicCommunity.service";
import { EthnicityService } from "../../services/ethnicity.service";
import { GenderIdentityService } from "../../services/genderIdentity.service";
import { IdTypeService } from "../../services/idType.service";
import { IpsService } from "../../services/ips.service";
import { PersonOcupationService } from "../../services/personOcupation.service";
import { ResidenceZoneService } from "../../services/residenceZone.service";
import { StateService } from "../../services/state.service";

import { StepperOrientation } from "@angular/cdk/stepper";
import { BreakpointObserver } from '@angular/cdk/layout';
import { finalize, map, takeUntil } from "rxjs/operators";
import { BOClinicHistory } from "../../models/BOClinicHistory.model";
import { BOPerson } from "../../models/BOPerson.model";
import { PersonService } from "../../services/person.service";
import { ClinicHistoryService } from "../../services/clinicHistory.service";
import { ServiceGroupsService } from "../../services/serviceGroups.service";
import { HealthTecnologyModalityService } from "../../services/healthTecnologyModality.service";
import { PlaceOfAttentionService } from "../../services/placeOfAttention.service";
import { RouteOfEntryService } from "../../services/routeOfEntry.service";
import { TriageTypeService } from "../../services/triageType.service";
import { PatientInformationService } from "../../services/patientInformation.service";
import { BOPatientInformation } from "../../models/BOPatientInformation.model";
import { HealthTechnologyFinalityService } from "../../services/healthTechnologyFinality.service";
import { HealthTechnologyTimeUnitService } from "../../services/HealthTechnologyTimeUnit.service";
import { HealthTechnologyService } from "../../services/healthTechnology.service";
import { MatStepper } from "@angular/material/stepper";
import { BOClinicHistoryObservations } from "../../models/BOClinicHistoryObservations.model";
import { PatientConditionService } from "../../services/patientCondition.service";
import { DiseaseService } from "../../services/disease.service";
import { OrphanDiseaseService } from "../../services/orphanDisease.service";
import { BOEps } from "../../models/BOEps.model";
import { BOOrganDonor } from "../../models/BOOrganDonor.model";
import { BOAdvancedDirectiveDocument } from "../../models/BOAdvancedDirectiveDocument.model";
import { BOMedicDiagnostic } from "../../models/BOMedicDiagnostic.model";
import { BOHealthTechnologies } from "../../models/BOHealthTechnologies.model";
import { BOPrescriptionMedicationDose } from "../../models/BOPrescriptionMedicationDose.model";
import { BOHealthTechnologyTerm } from "../../models/BOHealthTechnologyTerm.model";
import { BOHealthTechnologyFrecuency } from "../../models/BOHealthTechnologyFrecuency.model";
import { BOHealthTechnologyMedicamentDoseTaken } from "../../models/BOHealthTechnologyMedicamentDoseTaken.model";
import { BOHealthTechnologyMedicamentDoseDelivered } from "../../models/BOHealthTechnologyMedicamentDoseDelivered.model";
import { BOHealthTecnologyDeliveredUnits } from "../../models/BOHealthTecnologyDeliveredUnits.model";
import { BOHealthTechnologiesResult } from "../../models/BOHealthTechnologiesResult.model";
import { BOPrincipalMedicDiagnostic } from "../../models/BOPrincipalMedicDiagnostic.model";
import { BORelatedMedicDiagnostic } from "../../models/BORelatedMedicDiagnostic.model";
import { BOComplicationMedicDiagnostic } from "../../models/BOComplicationMedicDiagnostic.model";
import { BODeathMedicDiagnostic } from "../../models/BODeathMedicDiagnostic.model";

import { CreateOrEditMedicalFormulaComponent } from "../clinicHistory/createOrEditMedicalFormula.component";

import { BOMedicalFormula } from "../../models/BOMedicalFormula.model";

import { CompanyService } from "../../services/company.service";
import { BOCompany } from "../../models/BOCompany.model";
import { BOHeadQuarters } from "../../models/BOHeadQuarters.model";
import { HeadQuarterService } from "../../services/headQuarter.service";
import { DatePipe } from '@angular/common';

import { ServiceTypeService } from '../../services/service-type.service';
import { SellComponent } from '../sell/sell.component';
import { BOSubServiceType } from "../../models/BOSubServiceType.model";
import { SubServiceTypeService } from "../../services/subServiceType.service";
import { Utilities } from "../../common/utilities";
import { DialogConfirmService } from "../../services/dialog-confirm.service";
import { SellService } from "../../services/sell.service";
import { BOOdontologyBackgroundType } from '../../models/odo/BOOdontologyBackgroundType.model';
import { OdontologyBackgroundTypeService } from "../../services/odo/OdontologyBackgroundType.service";
import { BOOdontologyPatientBackground } from "../../models/odo/BOOdontologyPatientBackground.model";
import { OdontologyPatientBackground } from "../../services/odo/OdontologyPatientBackground.service";
import { OdontologyTissueTypeService } from "../../services/odo/OdontologyTissueType.service";
import { BOOdontologyTissueType } from "../../models/odo/BOOdontologyTissueType.model";
import { BOOdontologyTissuePatient } from "../../models/odo/BOOdontologyTissuePatient.model";
import { OdontologyTissuePatientService } from "../../services/odo/odontologyTissuePatient.service";
import { OdontologyRadiologicExamTypeService } from "../../services/odo/OdontologyRadiologicExamType.service";
import { BOOdontologyRadiologicExamType } from "../../models/odo/BOOdontologyRadiologicExamType.model";
import { BOOdontologyRadiologicExamPatient } from "../../models/odo/BOOdontologyRadiologicExamPatient.model";
import { OdontologyRadiologicExamPatientService } from "../../services/odo/OdontologyRadiologicExamPatient.service";
import { IBasicData, IBasicDataType, IStateDetailGroupByToothId } from "../../interfaces/Igeneral.interface";
import { OdontogramaComponent } from "./odontograma/odontograma.component";
import { Router } from "@angular/router";
import { ToothOdontogramaService } from "../../services/odo/ToothOdontograma.service";
import { ToothStateDetailService } from "../../services/toothStateDetail.service";

import pdfMake from 'pdfmake/build/pdfmake';

import pdfFonts from 'pdfmake/build/vfs_fonts';
import { BloodTypeService } from "../../services/bloodType.service";
import { CustomValidators } from "../../common/customValidators";
import { BOToothStateType } from "../../models/odo/BOToothStateType.model";
import { BOToothStateDetail } from "../../models/odo/BOToothStateDetail.model";
import { ToothStateTypeService } from "../../services/toothStateType.service";
import { ToothQuoteService } from '../../services/odo/toothQuote.service';
import { BOToothQuote } from "../../models/odo/BOToothQuote.model";
import { BOSellDetail } from "../../models/BOSellDtail.model";
import { BOSell } from "../../models/BOSell.model";
import { DentalAdminsModule } from '../../views/dentalAdmins/dental-admins.module';
import { BOChControl } from "../../models/BOChControl.model";
import { ChControlService } from "../../services/chControl.service";
import { ToothStateCategoryService } from "../../services/toothStateCategory.service";
import { BOToothStateCategory } from "../../models/BOToothStateCategory.model";
import { MatTabLink } from '@angular/material/tabs';
import { BOToothType } from "../../models/odo/BOToothType.model";
import { ToothTypeService } from "../../services/toothType.service";
import { MatCheckbox } from "@angular/material/checkbox";
import { BOToothStateDetailToothFace } from "../../models/odo/BOToothStateDetailToothFace.model";
import { BOToothFaceType } from "../../models/odo/BOToothFaceType.model";
import { ToothFaceTypeService } from "../../services/toothFaceType.service";
import { MatSelect } from "@angular/material/select";
import { ClinicHistoryPdfService } from '../../services/clinicHistoryPdf.service';
import { ClinicHistoryObservationsService } from '../../services/clinicHistoryObservations.service';
import { CreateOrEditClinicalOfficeComponent } from '../../../../srccopia/app/views/admins/clinicalOffices/createOrEditClinicalOffice.component';
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;


//#endregion imports
@Component({
    selector: 'createOrEditOdontologyHistoryModal',
    templateUrl: './createOrEditOdontologyHistory.component.html',
    styleUrls: ['./createOrEditOdontologyHistory.component.css'],
    providers: [DatePipe]
})

export class CreateOrEditOdontologyHistoryComponent implements OnDestroy, OnInit, AfterViewInit {

    @ViewChild('createOrEditModalObservation') public createOrEditModalObservation: ModalDirective;
    @ViewChild('createOrEditMedicalFormulaModal') public createOrEditMedicalFormulaModal: CreateOrEditMedicalFormulaComponent;
    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;
    @ViewChild('stepper', { static: true }) stepper: MatStepper;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild('clinicHistoryContainer', { static: true }) clinicHistoryContainer: ElementRef;

    @ViewChild('sellModal') public sellModal: SellComponent;
    @ViewChild('odontogramaModal') public odontogramaModal: OdontogramaComponent;
    @ViewChildren(MatTabLink) tabLinks!: QueryList<MatTabLink>;
    @ViewChildren('toothCb') checkboxes: QueryList<MatCheckbox>;
    @ViewChild('diagnosticSelect') diagnosticSelect!: MatSelect;



  //#region declarations
      busy: Subscription | undefined;
      submitted = false;
      emergencies: boolean = false;
      showOnlyObservations: boolean = false;
      stepperIndex = 0;
      panelOpenState = false;
      childPanelOpenState = false;
      tempObservationId = 0;
      tempObservation: BOClinicHistoryObservations = new BOClinicHistoryObservations();
      tempMedicalFormulaId = 0;

      dentalExamRows: any[] = [];

      cities                        : BOCity[] = [];
      biologicalSexList             : BOItem[] = [];
      consultationCauseList         : BOItem[] = [];
      diagnosticTypeList            : BOItem[] = [];
      disabilityCategoryList        : BOItem[] = [];
      epsList                       : BOEps [] = [];
      ethnicCommunityList           : BOItem[] = [];
      ethnicityList                 : BOItem[] = [];
      genderIdentityList            : BOItem[] = [];
      idTypeList                    : BOItem[] = [];
      ipsList                       : BOIps [] = [];
      residenceZoneList             : BOItem[] = [];
      healthTecnologyModalityList   : BOItem[] = [];
      placeOfAttentionList          : BOItem[] = [];
      routeOfEntryList              : BOItem[] = [];
      triageTypeList                : BOItem[] = [];
      healthTechnologyFinalityList  : BOItem[] = [];
      healthTechnologyList          : BOItem[] = [];
      healthTechnologyTimeUnitList  : BOItem[] = [];
      patientConditionList          : BOItem[] = [];
      diseaseList                   : BOItem[] = [];
      orphanDiseaseList             : BOItem[] = [];
      diseaseListRelated            : BOItem[] = [];
      diseaseListExit               : BOItem[] = [];
      diseaseListComplication       : BOItem[] = [];
      diseaseListDeath              : BOItem[] = [];
      orphanDiseaseRelatedList      : BOItem[] = [];
      orphanDiseaseExitList         : BOItem[] = [];
      orphanDiseaseComplicationList : BOItem[] = [];
      orphanDiseaseDeathList        : BOItem[] = [];
      countries                     : BOCountry[] = [];
      states                        : BOState  [] = [];
      profesionals                  : BOPerson [] = [];
      headQuarterList               : BOHeadQuarters[] = [];
      personOcupationList           : BOPersonOcupation[] = [];
      company                       : BOCompany;
      bloodTypeList                 : BOItem[]=[];


      clinicHistory                 : BOClinicHistory      = new BOClinicHistory();
      clinicHistoryControl          : BOClinicHistory      = new BOClinicHistory();
      patient                       : BOPerson             = new BOPerson();
      patientInformation            : BOPatientInformation = new BOPatientInformation();
      odontologyBackgroundTypesList : BOOdontologyBackgroundType[]=[];
      odontologyPatientBackgroundsList      : BOOdontologyPatientBackground[]=[];
      odontologyTissueTypeList              : BOOdontologyTissueType[]=[];
      odontologyTissuesPatientList          : BOOdontologyTissuePatient[]=[];
      odontologyRadiologicExamTypeList      : BOOdontologyRadiologicExamType[]=[]
      odontologyRadiologicExamPatientList   : BOOdontologyRadiologicExamPatient[]=[]


      toothStateTypeList                    : BOToothStateType[]=[];
      toothStateTypeListShort               : BOToothStateType[]=[];

      toothStateDetailList                  : BOToothStateDetail[]=[]
      toothStateDetailListAgrouped          : IStateDetailGroupByToothId[]=[];

      toothQuoteList                        : BOToothQuote[]=[];

      toothFaceTypeList                     : BOToothFaceType[]=[];


      profesionalSelected     :number;
      areaSelected            :number=2;
      createFirstPayMethod      :number=0;


      categoryService         : string="";
      clinicHistorySended     :number=null;


      serviceGroupsList                     : BOItem                      [] = [];
      serviceTypeList                       : BOItem                      [] = [];
      subServiceTypeList                    : BOSubServiceType            [] = [];
      serviceGroupsListShort                : BOItem                      [] = [];
      serviceTypeListShort                  : BOItem                      [] = [];
      profesionalsListShort                 : BOPerson                    [] = [];
      toothStateCategoryList                : BOToothStateCategory        [] = [];
      toothTypeList                         : BOToothType                 [] = [];
      clinicHistoryObservationsList         : BOClinicHistoryObservations [] = [];


       filteredCountries                : ReplaySubject<BOCountry[]> = new ReplaySubject<BOCountry[]>(1);
      filteredDiseases                  : ReplaySubject<BOItem[]> = new ReplaySubject<BOItem[]>(1);
      filteredDiseasesRelated           : ReplaySubject<BOItem[]> = new ReplaySubject<BOItem[]>(1);
      filteredDiseasesExit              : ReplaySubject<BOItem[]> = new ReplaySubject<BOItem[]>(1);
      filteredDiseasesComplication      : ReplaySubject<BOItem[]> = new ReplaySubject<BOItem[]>(1);
      filteredDiseasesDeath             : ReplaySubject<BOItem[]> = new ReplaySubject<BOItem[]>(1);
      filteredOrphanDiseases            : ReplaySubject<BOItem[]> = new ReplaySubject<BOItem[]>(1);
      filteredOrphanDiseasesRelated     : ReplaySubject<BOItem[]> = new ReplaySubject<BOItem[]>(1);
      filteredOrphanDiseasesExit        : ReplaySubject<BOItem[]> = new ReplaySubject<BOItem[]>(1);
      filteredOrphanDiseasesComplication: ReplaySubject<BOItem[]> = new ReplaySubject<BOItem[]>(1);
      filteredOrphanDiseasesDeath       : ReplaySubject<BOItem[]> = new ReplaySubject<BOItem[]>(1);
      filteredOcupation                 : ReplaySubject<BOPersonOcupation[]> = new ReplaySubject<BOPersonOcupation[]>(1);
      filteredEps                       : ReplaySubject<BOEps[]> = new ReplaySubject<BOEps[]>(1);
      countryFilterCtrl                 : FormControl = new FormControl();
      diseaseFilterCtrl                 : FormControl = new FormControl();
      diseaseRelatedFilterCtrl          : FormControl = new FormControl();
      diseaseExitFilterCtrl             : FormControl = new FormControl();
      diseaseComplicationFilterCtrl     : FormControl = new FormControl();
      diseaseDeathFilterCtrl            : FormControl = new FormControl();
      orphanDiseaseFilterCtrl           : FormControl = new FormControl();
      orphanDiseaseRelatedFilterCtrl    : FormControl = new FormControl();
      orphanDiseaseExitFilterCtrl       : FormControl = new FormControl();
      orphanDiseaseComplicationFilterCtrl: FormControl = new FormControl();
      orphanDiseaseDeathFilterCtrl      : FormControl = new FormControl();
      ocupationFilterCtrl               : FormControl = new FormControl();
      epsFilterCtrl                     : FormControl = new FormControl();
      searchingDisease                  : Boolean = false;
      searchingOrphanDisease            : Boolean = false;
      showOtherProcedureControl         : Boolean = false;

      stepperOrientation: Observable<StepperOrientation>;
      protected _onDestroy = new Subject<void>();

      isSearchPatient: boolean = false;
      isControl:boolean=false;
      clinicHistoryAsignedToSell=0;
      isOdontograma=0;
      isFormModalOpen = false;

      isSaving=false;
      errorMessage = '';
      isLoading=false;

    detailBackgroundFormGroup= this._formBuilder.group({
    itemType: [null,  Validators.required],
    details:  [null,  Validators.required],
    })

    detailTissueFormGroup= this._formBuilder.group({
    itemType: [null,  Validators.required],
    details:  [null,  Validators.required],
    })

    detailRadiologicFormGroup= this._formBuilder.group({
    itemType: [null,  Validators.required],
    details:  [null,  Validators.required],
    });

    showScrollDownArrow: boolean = false;
    isLingual:boolean=false;
    isPalatino:boolean=false;
    isOclusal:boolean=false;
    isIncisal:boolean=false;
    incisal:number[] =[11,12,13,21,22,23,31,32,33,41,42,43,51,52,53,61,62,63,71,72,73,81,82,83];


    toothSelected: number;
    selectedCategory: any = null;
    selectedDiagnostic: any = null;

isChEvolutionPanelOpen:boolean=false;
  //#endregion

  //#region create formsGroups and controls
    firstFormGroup = this._formBuilder.group({
        firstCtrl: ['', Validators.required], //Primer Nombre
        secondCtrl: '',                       //Segundo Nombre
        threeCtrl: ['', Validators.required], //Primer Apellido
        fourCtrl: '',                         //Segundo Apellido
        fifthCtrl: ['', Validators.required], //Tipo de Documento
        sixCtrl: ['', Validators.required],   //Numero de Documento de Identificacion
        sevenCtrl: ['centromedicoservi-vital@gmail.com', Validators.required], //Correo Electronico
        eightCtrl: ['', Validators.required], //Telefono Celular
        nineCtrl: ['Siloe', Validators.required], //Direccion<
        tenCtrl: ['', Validators.required],       //Telefono contacto de emergencia
        elevenCtrl: '',                           //Fecha de Nacimiento
        twelveCtrl: '',                           //Contacto de Emergencia
        bloodTypeCtrl:['09' ]                         //tipo de sangre
    });

    secondFormGroup = this._formBuilder.group({
        firstCtrl: null,
        secondCtrl: null,
        threeCtrl: null,
        fourCtrl: ['06'],
        fifthCtrl: null,
        sixCtrl: null,
        sevenCtrl: ['999999', Validators.required], //EPS
        eightCtrl: null,
        nineCtrl: ['9629'], //ocupación
        tenCtrl: null,
        elevenCtrl: ['76001'], //ciudad
        twelveCtrl: ['76'], //Dpto
        thirteen: null,
        fourtheen: null,
        fiftheen: null,
        sixteen: null
    });
//Datos de ingreso
    thirdFormGroup = this._formBuilder.group({
        firstCtrl: ['', Validators.required],
        secondCtrl: ['', Validators.required],
        threeCtrl: [null, Validators.required],
        fourCtrl: ['', Validators.required],
        fifthCtrl: ['', Validators.required],
        sixCtrl: ['', Validators.required],
        sevenCtrl: ['', Validators.required],
        eightCtrl: null,
        nineCtrl: null,
        thirteenCtrl: [null, Validators.required],
        fourteenCtrl: [0, Validators.required],
        fifteenCtrl: null,
    });

    fourFormGroup = this._formBuilder.group({
        firstCtrl: null,
        secondCtrl: null,
        threeCtrl: null,
        fourCtrl: null,
        fifthCtrl: "0",
        sixCtrl: null,
        sevenCtrl: null,
        eightCtrl: "0",
        nineCtrl: null,
        tenCtrl: "0",
        elevenCtrl: null,
        twelveCtrl: "0",
        thirteenCtrl: null,
        fourteenCtrl: null,
        fiftheenCtrl: "0",
        sixteenCtrl: null,
        seventeenCtrl: "0",
        eighteenCtrl: null,
        nineteenCtrl: null,
        twentyCtrl: null
    });

    odontologyBackgroundForm:FormGroup;
    odontologyTissueForm:FormGroup;
    odontologyRadiologicForm:FormGroup;


    fifthFormGroup = this._formBuilder.group({
        firstCtrl: null,
        secondCtrl: null,
        threeCtrl: null,
        fourCtrl: null,
        fifthCtrl: null,
        sixCtrl: null,
        sevenCtrl: null,
        eightCtrl: null,
        nineCtrl: null,
        tenCtrl: null,
        elevenCtrl: null,
        twelveCtrl: null,
        thirteenCtrl: null,
        fourteenCtrl: "0",
        fiftheenCtrl: "0",
        sixteenCtrl: null,
        seventeenCtrl: null
    });

    sixFormGroup = this._formBuilder.group({
        firstCtrl: null,
        secondCtrl: null,
        threeCtrl: null,
        fourCtrl: null,
        fifthCtrl: null,
        sixCtrl: null,
        sevenCtrl: null,
        eightCtrl: null,
        nineCtrl: null,
        tenCtrl: null,
        elevenCtrl: null,
        twelveCtrl: null,
        thirteenCtrl: null,
        fourteenCtrl: null,
        fiftheenCtrl: null,
        sixteenCtrl: null,
        seventeenCtrl: null,
        eighteenCtrl: null,
        nineteenCtrl: null,
        twentyCtrl: null,
        twentyOneCtrl: null,
        twentyTwoCtrl: null,
        twentyThreeCtrl: null
    });

    toothStateTypeFormGroup= this._formBuilder.group({
       // toothTypeId: ['',Validators.required],
        toothStateCategoryId:[{ value: '', disabled: true }, Validators.required],
        toothStateId: [{ value: '', disabled: true }, Validators.required],
        observations: ['',null],
        fixed:      [false, null],
        price:      [0, null],
        vestibular: [false,null],
        medial:     [false,null],
        distal:     [false,null],
        palatino:   [false,null],
        center:     [false,null],
        lingual:    [false,null],
        incisal:    [false,null],


    })

odontoTabs: string[] = [
  'Datos Básicos',
  'Datos del Paciente',
  'Datos de Ingreso',
  'M.de Pago-Cotización',
  'Antecedentes Médicos',
  'Examen Odontológico',
  'Examen Radiológico',
  'Fórmula Médica',
  'Evolución'
];

currentScreen = 0;

chControlFatherFormGroup= this._formBuilder.group({
    controlDate: ['',Validators.required],
    professionalId: [null, Validators.required],
    details: [null],
})

selectedTooth: BOToothType[] = [];
stateSended: BOToothStateDetail[]=[]
    //#endregion


    constructor(public toastr                       : ToastrService,
          private _biologicalSexService             : BiologicalSexService,
          private _cityService                      : CityService,
          private _consultationCauseService         : ConsultationCauseService,
          private _countryService                   : CountryService,
          private _diagnosticTypeService            : DiagnosticTypeService,
          private _disabilityCategoryService        : DisabilityCategoryService,
          private _epsService                       : EpsService,
          private _ethnicCommunityService           : EthnicCommunityService,
          private _ethnicityService                 : EthnicityService,
          private _genderIdentityService            : GenderIdentityService,
          private _idTypeService                    : IdTypeService,
          private _ipsService                       : IpsService,
          private _personOcupationService           : PersonOcupationService,
          private _residenceZoneService             : ResidenceZoneService,
          private _stateService                     : StateService,
          private _formBuilder                      : FormBuilder, breakpointObserver: BreakpointObserver,
          private _personService                    : PersonService,
          private _clinicHistoryService            : ClinicHistoryService,
          private _serviceGroupsService            : ServiceGroupsService,
          private _healthTecnologyModalityService  : HealthTecnologyModalityService,
          private _placeOfAttentionService         : PlaceOfAttentionService,
          private _routeOfEntryService             : RouteOfEntryService,
          private _triageTypeService               : TriageTypeService,
          private _patientInformationService       : PatientInformationService,
          private _healthTechnologyFinalityService : HealthTechnologyFinalityService,
          private _healthTechnologyTimeUnitService : HealthTechnologyTimeUnitService,
          private _healthTechnologyService         : HealthTechnologyService,
          private _patientConditionService         : PatientConditionService,
          private _diseaseService                  : DiseaseService,
          private _orphanDiseaseService            : OrphanDiseaseService,
          private _companyService                  : CompanyService,
          private _headQuarterService              : HeadQuarterService,
          private datePipe                         : DatePipe,
          private _serviceTypeService              : ServiceTypeService,
          private _subServiceTypeService           : SubServiceTypeService,
          private _dialogConfirm                   : DialogConfirmService,
          private _cdr                             : ChangeDetectorRef,
          private _sellService                     : SellService,
          private _odontologyBackgroundType        : OdontologyBackgroundTypeService,
          private _odontologyPatientBackgrounds    : OdontologyPatientBackground,
          private _odontologyTissueType            : OdontologyTissueTypeService,
          private _odontologyTissuePatient         : OdontologyTissuePatientService,
          private _odontologyRadiologicExamType    : OdontologyRadiologicExamTypeService,
          private _odontologyRadiologicExamPatient : OdontologyRadiologicExamPatientService,
          private _odontogramaService              : ToothOdontogramaService,
          private _toothStateType                  : ToothStateTypeService,
          private _toothStateDetailsService        : ToothStateDetailService,
          private _router                          : Router,
          private _bloodTypeService                : BloodTypeService,
          private _toothQuoteService               : ToothQuoteService,
          private _odontologyPatientBackgroundService: OdontologyPatientBackground,
          private _odontologyTissuePatientService    : OdontologyTissuePatientService,
          private _odontologyRadiologicExamPatientService: OdontologyRadiologicExamPatientService,
          private _toothSateCategoryService         : ToothStateCategoryService,
          private _toothTypeService                 : ToothTypeService,
          private _toothFaceTypeService             : ToothFaceTypeService,

          private _clinicHistoryPdfService          : ClinicHistoryPdfService,
          private _clinicHistoryObservationsService : ClinicHistoryObservationsService,
          )

          {
          this.stepperOrientation = breakpointObserver.observe('(min-width: 800px)')
              .pipe(map(({ matches }) => matches ? 'horizontal' : 'vertical'));
          }

    ngOnInit(): void {

      this.odontologyBackgroundForm = this._formBuilder.group({
        items: this._formBuilder.array([], CustomValidators.atLeastOneCheckboxChecked())
      });

      this.odontologyTissueForm = this._formBuilder.group({
        items: this._formBuilder.array([], CustomValidators.atLeastOneCheckboxChecked())
      });


      this.odontologyRadiologicForm = this._formBuilder.group({
        items: this._formBuilder.array([],CustomValidators.atLeastOneCheckboxChecked())
      });
    }
    ngAfterViewInit() {
        if (this.stepper) {
            this.stepper.selectionChange.subscribe(() => {
                this.scrollToTop();
                setTimeout(() => {
                    this.checkScrollPosition();
                }, 600);
            });
        }

        if (this.clinicHistoryContainer?.nativeElement) {
            this.clinicHistoryContainer.nativeElement.addEventListener('scroll', () => {
                this.checkScrollPosition();
            });
        }
    }


//#region open modal
  openModal(clinicHistoryId: number,showOnlyObservations: boolean, categoryService: string, patientName?:string ): void
  {
        //this.activeTab(this.stepper.selectedIndex);
        this.currentScreen = this.stepper.selectedIndex;
        this._cdr.detectChanges();
        console.log("ENTRA A OPENMODALEN CREATEOREDITODONTOLOGYHISTORY, this.clinicHistoryId es:", clinicHistoryId,
          "SELECTINDEX ES:", this.stepper.selectedIndex );

        this.showOnlyObservations = showOnlyObservations;
        this.submitted = true;
        this.modal.config = { backdrop: "static", keyboard: false };
        this.modal.show();

        this.serviceGroupsListShort=[];
        this.serviceTypeListShort  =[];
        this.profesionalsListShort =[];
        this.odontologyPatientBackgroundsList=[];
        //Ric
        this.categoryService=categoryService;
        this.clinicHistorySended=clinicHistoryId;
        this.firstFormGroup.patchValue({
           fifthCtrl: "CC"
        });
        //end Ric

        //#region  forkjoin

        this.busy = forkJoin({
            resultCountry                 : this._countryService.getCountries(),
            resultBiologicalSex           : this._biologicalSexService.getAll(),
            resultConsultationCause       : this._consultationCauseService.getAll(),
            resultDiagnosticType          : this._diagnosticTypeService.getAll(),
            resultDisabilityCategory      : this._disabilityCategoryService.getAll(),
            resultEps                     : this._epsService.getAll(),
            resultEthnicCommunity         : this._ethnicCommunityService.getAll(),
            resultEthnicity               : this._ethnicityService.getAll(),
            resultGenderIdentity          : this._genderIdentityService.getAll(),
            resultIdType                  : this._idTypeService.getAll(),
            resultIps                     : this._ipsService.getAll(),
            resultCity                    : this._cityService.getCitiesbyState("NN"),
            resultPersonOcupation         : this._personOcupationService.getAll(),
            resultResidenceZone           : this._residenceZoneService.getAll(),
            resultHealthTecnologyModality : this._healthTecnologyModalityService.getAll(),
            resultServiceGroups           : this._serviceGroupsService.getAll(),
            resultPlaceOfAttention        : this._placeOfAttentionService.getAll(),
            resultRouteOfEntry            : this._routeOfEntryService.getAll(),
            resultTriageType              : this._triageTypeService.getAll(),
            resultHealthTechnologyFinality: this._healthTechnologyFinalityService.getAll(),
            resultHealthTechnologyTimeUnit: this._healthTechnologyTimeUnitService.getAll(),
            resultHealthTechnology        : this._healthTechnologyService.getAll(),
            resultPatientCondition        : this._patientConditionService.getAll(),
            resultDisease                 : this._diseaseService.getAll(".n"),
            resultOrphanDisease           : this._orphanDiseaseService.getAll(".n"),
            resultCompany                 : this._companyService.getCompany(),
            resultHeadquarter             : this._headQuarterService.getHeadQuarters(),
            resultProfesionals            : this._personService.getProfesionals(),
            resultServiceType             : this._serviceTypeService.getAll(),
            resultSubServiceTypeService   : this._subServiceTypeService.getAll(),
            resultBackgroundType          : this._odontologyBackgroundType.getAll(),
           // resultPatientBackgroundsList  : this._odontologyPatientBackgrounds.getOdontologyHistoriesByClinicId(clinicHistoryId),
            resultOdontologyTissueType    : this._odontologyTissueType.getAll(),
            //resultOdontologyTissuePatient : this._odontologyTissuePatient.getOdontologyHistoriesByClinicId(clinicHistoryId),
            resultOdontologyRadiologicExamType    : this._odontologyRadiologicExamType.getAll(),
           // resultOdontologyRadiologicExamPatient : this._odontologyRadiologicExamPatient.getOdontologyHistoriesByClinicId(clinicHistoryId),
            resultBloodType                       : this._bloodTypeService.getAll(),

            resultToothStateType                  : this._toothStateType.getAll(),
            resultToothStateDetails               : this._toothStateDetailsService.getToothStateDetailsByClinicHistoryId(clinicHistoryId),
            resultToothQuotes                     : this._toothQuoteService.getAllQuotesByCh(clinicHistoryId),
            resultToothStateCategories            : this._toothSateCategoryService.getAll(),
            resultToothType                       : this._toothTypeService.getAll(),
            resultToothFaceType                   : this._toothFaceTypeService.getAll(),
            resultClinicHistoryObservations       : this._clinicHistoryObservationsService.getAllByClinicHistoryId(clinicHistoryId),

        }).subscribe(({ resultCountry,
                        resultBiologicalSex,
                        resultConsultationCause,
                        resultDiagnosticType,
                        resultDisabilityCategory,
                        resultEps,
                        resultEthnicCommunity,
                        resultEthnicity,
                        resultGenderIdentity,
                        resultIdType,
                        resultIps,
                        resultCity,
                        resultPersonOcupation,
                        resultResidenceZone,
                        resultHealthTecnologyModality,
                        resultServiceGroups,
                        resultPlaceOfAttention,
                        resultRouteOfEntry,
                        resultTriageType,
                        resultHealthTechnologyFinality,
                        resultHealthTechnologyTimeUnit,
                        resultHealthTechnology,
                        resultPatientCondition,
                        resultDisease,
                        resultOrphanDisease,
                        resultCompany,
                        resultHeadquarter,
                        resultProfesionals,
                        resultServiceType,
                        resultSubServiceTypeService,
                      //  resultPatientBackgroundsList,
                        resultBackgroundType,
                        resultOdontologyTissueType,
                        //resultOdontologyTissuePatient,
                        resultOdontologyRadiologicExamType,
                        //resultOdontologyRadiologicExamPatient,
                        resultBloodType,
                        resultToothStateType,
                        resultToothStateDetails,
                        resultToothQuotes,
                        resultToothStateCategories,
                        resultToothType,
                        resultToothFaceType,
                        resultClinicHistoryObservations

                       }) =>
        {

            this.countries              = resultCountry;
            this.biologicalSexList      = resultBiologicalSex;
            this.consultationCauseList  = resultConsultationCause;
            this.sortBOItemxNameAscendent(this.consultationCauseList);

            this.diagnosticTypeList     = resultDiagnosticType;
            this.disabilityCategoryList = resultDisabilityCategory;
            this.sortBOItemxNameAscendent(this.disabilityCategoryList);

            this.epsList                = resultEps;
            this.sortBOEpsByFirstNameAscendent(this.epsList);


            this.cities                 = resultCity;
            this.personOcupationList    = resultPersonOcupation;
            this.serviceTypeList        = resultServiceType;
            this.sortBOItemxNameAscendent(this.serviceTypeList);

            this.subServiceTypeList     = resultSubServiceTypeService;

            this.company                = resultCompany;
            this.headQuarterList        = resultHeadquarter;
            this.profesionals           = resultProfesionals;
            this.sortBOPersonByFirstNameAscendent(this.profesionals);


            this.ethnicCommunityList    = resultEthnicCommunity;
            this.ethnicityList          = resultEthnicity;
            this.genderIdentityList     = resultGenderIdentity;
            this.idTypeList             = resultIdType;
            this.sortBOItemxNameAscendent(this.idTypeList);

            this.ipsList                = resultIps;

            this.residenceZoneList            = resultResidenceZone;
            this.sortBOItemxNameAscendent(this.residenceZoneList);

            this.healthTecnologyModalityList  = resultHealthTecnologyModality;
            this.sortBOItemxNameAscendent(this.healthTecnologyModalityList);

            this.serviceGroupsList            = resultServiceGroups;
            this.sortBOItemxNameAscendent(this.serviceGroupsList);

            this.placeOfAttentionList         = resultPlaceOfAttention;
            this.sortBOItemxNameAscendent(this.placeOfAttentionList);

            this.routeOfEntryList             = resultRouteOfEntry;
            this.triageTypeList               = resultTriageType;
            this.healthTechnologyList         = resultHealthTechnology;
            this.healthTechnologyFinalityList = resultHealthTechnologyFinality;
            this.healthTechnologyTimeUnitList = resultHealthTechnologyTimeUnit;
            this.patientConditionList         = resultPatientCondition;
            this.odontologyBackgroundTypesList= resultBackgroundType;
            this.odontologyTissueTypeList           = resultOdontologyTissueType;
            this.odontologyRadiologicExamTypeList   = resultOdontologyRadiologicExamType;
            this.bloodTypeList                      =  resultBloodType;

            this.toothStateTypeList                = resultToothStateType,
            this.toothStateDetailList              = resultToothStateDetails;
            this.toothQuoteList                    = resultToothQuotes;
            this.toothStateCategoryList            = resultToothStateCategories,
            this.toothTypeList                     = resultToothType,
            this.toothFaceTypeList                 = resultToothFaceType,
            this.clinicHistoryObservationsList     = resultClinicHistoryObservations;

            console.log("En openModal toothStateCategoryList es:",  this.toothStateCategoryList);
            console.log("01 En openModal clinicHistoryObservationsList es:",  this.clinicHistoryObservationsList);

            //código para imprimir pdf -odontograma
              const tsdAgrouped: IStateDetailGroupByToothId[] = Object.values(
              this.toothStateDetailList.reduce
              ((acc, current) =>
                {
                  if (!acc[current.toothTypeId]) {
                      acc[current.toothTypeId] = {
                        toothTypeId: current.toothTypeId,
                        items: []
                      };
                  }
                  acc[current.toothTypeId].items.push(current);
                  return acc;
                },
                {} as { [key: number]: IStateDetailGroupByToothId }
              )
            );

            // Paso 2: Dividir en chunks de 3
            const chunkArray = <T>(arr: T[], size: number): T[][] =>
              Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
                arr.slice(i * size, i * size + size)
              );

            const rowsOfGroups = chunkArray(tsdAgrouped, 3);

          this.toothStateDetailList.sort((a,b)=>a.toothTypeId - b.toothTypeId);


            // ✅ ASIGNAR A LA PROPIEDAD DE LA CLASE
            this.dentalExamRows = rowsOfGroups.flatMap(rowGroups =>
            {
              // Fila de títulos - CADA DIENTE OCUPA 2 COLUMNAS
              const titleRow = rowGroups.flatMap(group => [
                {
                  colSpan: 2,
                  fillColor: '#e3f2fe',
                  text: [{ text: `Diente No: ${group.toothTypeId}`, bold: true, fontSize: 9 }]
                },
                {} // celda vacía por el colSpan
              ]);

              // Rellenar hasta 6 celdas si hay menos de 3 dientes
              while (titleRow.length < 6) {
                titleRow.push({});
              }

              // Fila de contenido - CADA DIENTE OCUPA 2 COLUMNAS
              const contentRow = rowGroups.flatMap(group => {
                const content = group.items.map(item => {
                  const stateName = this.toothStateTypeList?.find(x => x.id === item.toothStateId)?.name || 'N/A';

                  return [
                    { text: `Estado: ${stateName},`,bold:true,fontSize: 8 },
                    //{ text: `\n Arreglado: ${item.fixed ? 'Sí' : 'No'}`, fontSize: 8 },
                    { text: `\nDetalle: ${item.observations || '-'}`, fontSize: 8 },
                    //{ text: `\nTratamiento: ${item.treatment || '-'}`, fontSize: 8 },
                    { text: '\n\n', fontSize: 6 }
                  ];
                });

                return [
                  {
                    colSpan: 2,
                    text: content.flat()
                  },
                  {} // celda vacía por el colSpan
                ];
              });

              // Rellenar hasta 6 celdas si hay menos de 3 dientes
              while (contentRow.length < 6) {
                contentRow.push({});
              }

              return [titleRow, contentRow];
            });

            this.orphanDiseaseRelatedList     = resultOrphanDisease;
            this.orphanDiseaseList            = resultOrphanDisease;

            this.filteredOrphanDiseases.next(this.orphanDiseaseList.slice());
            this.filteredOrphanDiseasesRelated.next(this.orphanDiseaseRelatedList.slice());
            this.orphanDiseaseExitList        = resultOrphanDisease;
            this.filteredOrphanDiseasesExit.next(this.orphanDiseaseExitList.slice());
            this.orphanDiseaseComplicationList= resultOrphanDisease;
            this.filteredOrphanDiseasesComplication.next(this.orphanDiseaseComplicationList.slice());
            this.orphanDiseaseDeathList       = resultOrphanDisease;
            this.filteredOrphanDiseasesDeath.next(this.orphanDiseaseDeathList.slice());
          //#region filter

            this.filteredCountries.next(this.countries.slice());
            // listen for search field value changes
              this.countryFilterCtrl.valueChanges
                .pipe(takeUntil(this._onDestroy))
                .subscribe(() => {
                    this.filterCountries();
                });

            this.filteredEps.next(this.epsList.slice());
              this.epsFilterCtrl.valueChanges
                .pipe(takeUntil(this._onDestroy))
                .subscribe(() => {
                    this.filterEps();
                });
            this.filteredOcupation.next(this.personOcupationList.slice());
                this.ocupationFilterCtrl.valueChanges
                    .pipe(takeUntil(this._onDestroy))
                    .subscribe(() => {
                        this.filterOcupation();
                    });

            this.orphanDiseaseFilterCtrl.valueChanges
                .pipe(takeUntil(this._onDestroy))
                .subscribe(() => {
                    this.filterOrphanDiseases();
                });
            this.orphanDiseaseRelatedFilterCtrl.valueChanges
                .pipe(takeUntil(this._onDestroy))
                .subscribe(() => {
                    this.filterOrphanDiseasesRelated();
                });
            this.orphanDiseaseExitFilterCtrl.valueChanges
                .pipe(takeUntil(this._onDestroy))
                .subscribe(() => {
                    this.filterOrphanDiseasesExit();
                });
            this.orphanDiseaseComplicationFilterCtrl.valueChanges
                .pipe(takeUntil(this._onDestroy))
                .subscribe(() => {
                    this.filterOrphanDiseasesComplication();
                });
            this.orphanDiseaseDeathFilterCtrl.valueChanges
                .pipe(takeUntil(this._onDestroy))
                .subscribe(() => {
                    this.filterOrphanDiseasesDeath();
                });

            this.diseaseList = resultDisease;
            this.filteredDiseases.next(this.diseaseList.slice());
            this.diseaseListRelated = resultDisease;
            this.filteredDiseasesRelated.next(this.diseaseListRelated.slice());
            this.diseaseListExit = resultDisease;
            this.filteredDiseasesExit.next(this.diseaseListExit.slice());
            this.diseaseListComplication = resultDisease;
            this.filteredDiseasesComplication.next(this.diseaseListComplication.slice());
            this.diseaseListDeath = resultDisease;
            this.filteredDiseasesDeath.next(this.diseaseListDeath.slice());
            this.diseaseFilterCtrl.valueChanges
                .pipe(takeUntil(this._onDestroy))
                .subscribe(() => {
                    this.filterDiseases();
                });
            this.diseaseRelatedFilterCtrl.valueChanges
                .pipe(takeUntil(this._onDestroy))
                .subscribe(() => {
                    this.filterDiseasesRelated();
                });
            this.diseaseExitFilterCtrl.valueChanges
                .pipe(takeUntil(this._onDestroy))
                .subscribe(() => {
                    this.filterDiseasesExit();
                });
            this.diseaseComplicationFilterCtrl.valueChanges
                .pipe(takeUntil(this._onDestroy))
                .subscribe(() => {
                    this.filterDiseasesComplication();
                });
            this.diseaseDeathFilterCtrl.valueChanges
                .pipe(takeUntil(this._onDestroy))
                .subscribe(() => {
                    this.filterDiseasesDeath();
                });
            this._stateService.getStatesbyCountry(this.countries[0].id).subscribe(data => {
                this.states = data;
            });

            //#endregion filter

            //Crear casos para cmg, cmc y edi
            this.serviceGroupsListShort=Utilities.getGroupsByAreaId(2, this.serviceGroupsList);
            this.profesionalsListShort=Utilities.getProfessionalssByAreaId(2, this.profesionals);

             if (clinicHistoryId > 0)
             {
              console.log("ENTRA A OPENMODAL AL IF CLINICHISTORY MAYOR 0");

                this._clinicHistoryService.getClinicHistory(clinicHistoryId)
                .subscribe( data =>
                {
                  this.clinicHistory = data;
                  console.log("EN CHID>0, clinicHistory es:", this.clinicHistory);

                  this.isOdontograma=this.clinicHistory.isOdontograma;
                  let dataTemp= JSON.parse(JSON.stringify(data));
                  this.clinicHistoryControl=dataTemp;
                  this.patient = this.clinicHistory.patient;
                  this.profesionalSelected = this.profesionals.find(x => x.id == this.clinicHistory.profesional?.id)?.id;
                  this.areaSelected=this.clinicHistory.area;
                  this.serviceTypeListShort=Utilities.getServicesByGroupId(this.clinicHistory.serviceGroups, this.serviceTypeList)
                    this._sellService.getSellByClinicHistoryId(this.clinicHistory.id).subscribe(data=>{
                    this.clinicHistoryAsignedToSell=data.clinicHistoryId;
                    this._cdr.detectChanges();

                  });

                  this._odontologyTissuePatientService.getAllByPatientId(this.patient.id).subscribe({
                    next:(data)=>
                      {
                        this.odontologyTissuesPatientList=data;
                      },
                    error:(err)=>{
                      console.log("Error en capturar items");
                    }
                  });

                  this._odontologyPatientBackgroundService.getAllByPatientId(this.patient.id).subscribe({
                    next:(data)=>
                      {
                        this.odontologyPatientBackgroundsList=data;
                      },
                    error:(err)=>{
                      console.log("Error en capturar items");
                    }
                  });

                  this._odontologyRadiologicExamPatientService.getAllByPatientId(this.patient.id).subscribe({
                    next:(data)=>
                      {
                        this.odontologyRadiologicExamPatientList=data;
                      },
                    error:(err)=>{
                      console.log("Error en capturar items");
                    }
                  })

                  if (this.patient.patientInformationId != null)
                  {
                      this._patientInformationService.getPatientInformation(this.patient.patientInformationId).subscribe(data => {
                      this.patientInformation = data;
                      });
                  }

                  this.firstFormGroup.patchValue({
                    firstCtrl: this.patient.firstName,
                    secondCtrl: this.patient.secondName,
                    threeCtrl: this.patient.firtsSurName,
                    fourCtrl: this.patient.secondSurName,
                    fifthCtrl: this.idTypeList.find(x => x.code == this.patient.idType).code,
                    sixCtrl: this.patient.personId,
                    sevenCtrl: this.patient.email,
                    nineCtrl: this.patient.address,
                    eightCtrl: this.patient.cellPhoneNumber,
                    tenCtrl: this.patient.emergencyContact,
                    twelveCtrl: this.patient.emergencyContactName,
                    elevenCtrl: this.patient.birthDate.toString(),
                    bloodTypeCtrl:this.bloodTypeList.find(x => x.code==this.patient.bloodType).code
                    });

                      this.isSearchPatient = true;
                });
             }
             else
             {

                this.clinicHistory.id = 0;
                    this.patient.id = 0;

             }


          })

   //#endregion  forKjOIN

  }

  openSellModalFromClinicHistory():void
  {
      console.log("Entra en osmFCH, ch es:", this.clinicHistory);
      this.isFormModalOpen = true;

     let ch= this.clinicHistory;
     let bsell:BOSell= new BOSell();
     let idTypeConverted= this.idTypeList.find(x=>x.code==ch.patient.idType).id;
     bsell.sellDetails=[];

     let nameTemp=this.getNameFromClinichistory();
     bsell.userId=parseInt(ch.patient.personId);
    // bsell.idTypeIdentification=parseInt(ch.patient.idType),
     bsell.idTypeIdentification=idTypeConverted,

     bsell.userName=nameTemp;
     bsell.userEmail=ch.patient.email;
     bsell.dateSell=ch.consultationDate;
     bsell.clinicHistoryId=ch.id;
     bsell.total=ch.servicePrice;
     bsell.areaId=ch.area;
     bsell.userIdString=ch.patient.personId;
     console.log("En openSmFCH,bsell.userId es:", ch.patient.personId);


     let bsellDetail:BOSellDetail=new BOSellDetail();
     //let profesionalTemp=this.profesionals.find(x=>x.id==ch.profesionalId);
     bsellDetail.profesionalId=ch.profesionalId;
     bsellDetail.serviceGroupId=parseInt(ch.serviceGroups);
     bsellDetail.serviceTypeId=parseInt(ch.serviceType);
     bsellDetail.price= ch.servicePrice;
     bsellDetail.sellDetailIdTemp=0;
     bsellDetail.subServicesDetails=[];
     bsell.sellDetails.push(bsellDetail)
     bsell.sellDetails[0].itemSaved=true;

     console.log("ClinicH enviada desde openSellModalFromCH es:", bsell);

     this.sellModal.openSellModal(bsell, 1);

  }

  openSellModalEmptyFromClinicHistory():void
   {
    this.isFormModalOpen = true;

    let ch= this.clinicHistory;
    let bsell:BOSell= new BOSell();
    let idTypeConverted= this.idTypeList.find(x=>x.code==ch.patient.idType).id;
    bsell.sellDetails=[];

    let nameTemp=this.getNameFromClinichistory();
    //bsell.userId=parseInt(ch.patient.personId);
    bsell.userIdString=ch.patient.personId;

   // bsell.idTypeIdentification=parseInt(ch.patient.idType),
    bsell.idTypeIdentification=idTypeConverted,

    bsell.userName=nameTemp;
    bsell.userEmail=ch.patient.email;
    bsell.dateSell=ch.consultationDate;
    bsell.clinicHistoryId=ch.id;
   // bsell.total=ch.servicePrice;
    bsell.total=0;

    bsell.areaId=ch.area;


    let bsellDetail:BOSellDetail=new BOSellDetail();
    bsellDetail.subServicesDetails=[];
    bsell.sellDetails.push(bsellDetail)
    bsell.sellDetails[0].itemSaved=false;

    this.sellModal.openSellModal(bsell,2 );

  }

   onCloseFormModal() {
    this.isFormModalOpen = false;
  }

  //#endregion open modal

    searchPatient(): void
    {
        const patientInput: BOPerson = {
            id: 0,
            idType: this.firstFormGroup.get('fifthCtrl')!.value,        //Id type
            personId: this.firstFormGroup.get('sixCtrl')!.value.trim(), //num Id
            personType: 3,
            isClient: true
        };
        this.busy = this._personService.getPersonIdNumber(patientInput).subscribe(data => {
            if (data.id > 0)
            {
              this.confirmCreateCopyPerson(data);
            }

            this.isSearchPatient = true;
        });
    }

    confirmCreateCopyPerson(data:BOPerson):void
    {
      let confirm:boolean=false;

      this._dialogConfirm.openConfirmDialog('Este paciente ya está registrado.Si continua, creará una nueva historia con los datos de ese paciente.¿Desea crear una nueva historia? ')
      .afterClosed().subscribe(res=>{
        confirm=res;

        if(confirm)
        {
          this.patient = data;
          this.firstFormGroup.patchValue({
              firstCtrl: this.patient.firstName,
              secondCtrl: this.patient.secondName,
              threeCtrl: this.patient.firtsSurName,
              fourCtrl: this.patient.secondSurName,
              fifthCtrl: this.patient.idType,
              sixCtrl: this.patient.personId, //num Id
              sevenCtrl: this.patient.email,
              nineCtrl: this.patient.address,
              eightCtrl: this.patient.cellPhoneNumber,
              tenCtrl: this.patient.emergencyContact,
              twelveCtrl: this.patient.emergencyContactName,
              elevenCtrl: this.patient.birthDate.toString().split('T')[0]
          });

        }
        else
        {
          this.close();
        }
      });

    }

    createOrUpdatePerson(next: boolean): void
    {
      this.currentScreen=this.stepper.selectedIndex+1;
      if( this.categoryService=='cmg')
      {
              this.clinicHistory.clinicHistoryObservations=[];
              this.clinicHistory.medicalFormula=[];
      }

      if(this.categoryService =='edi')
           {

                this.sixFormGroup.patchValue({
                firstCtrl: this.clinicHistory.pathologicalRecord,
                secondCtrl: this.clinicHistory.consultationMotive,
                threeCtrl: this.clinicHistory.anamnesis,
                fourCtrl: this.clinicHistory.arterialPressure,
                fifthCtrl:this.clinicHistory.temperature,
                sixCtrl:this.clinicHistory.pulse,
                sevenCtrl:this.clinicHistory.weight,
                eightCtrl:this.clinicHistory.size,
                nineCtrl:this.clinicHistory.breathing,
                tenCtrl:this.clinicHistory.head,
                elevenCtrl:this.clinicHistory.neck,
                twelveCtrl:this.clinicHistory.chest,
                thirteenCtrl:this.clinicHistory.belly,
                fourteenCtrl:this.clinicHistory.pelvis,
                fiftheenCtrl:this.clinicHistory.extremities,
                sixteenCtrl:this.clinicHistory.skin,
                seventeenCtrl:this.clinicHistory.centralNervousSystem,
                eighteenCtrl:this.clinicHistory.diagnosticImpression,
                nineteenCtrl:this.clinicHistory.laboratoryControl,
                twentyCtrl:this.clinicHistory.treatmentPlan,

                });
          }

      if(this.categoryService =='cmc')
      {

                    this.sixFormGroup.patchValue({
                    firstCtrl: this.clinicHistory.pathologicalRecord,
                    secondCtrl: this.clinicHistory.consultationMotive,
                    threeCtrl: this.clinicHistory.anamnesis,
                    fourCtrl: this.clinicHistory.arterialPressure,
                    fifthCtrl:this.clinicHistory.temperature,
                    sixCtrl:this.clinicHistory.pulse,
                    sevenCtrl:this.clinicHistory.weight,
                    eightCtrl:this.clinicHistory.size,
                    nineCtrl:this.clinicHistory.breathing,
                    tenCtrl:this.clinicHistory.head,
                    elevenCtrl:this.clinicHistory.neck,
                    twelveCtrl:this.clinicHistory.chest,
                    thirteenCtrl:this.clinicHistory.belly,
                    fourteenCtrl:this.clinicHistory.pelvis,
                    fiftheenCtrl:this.clinicHistory.extremities,
                    sixteenCtrl:this.clinicHistory.skin,
                    seventeenCtrl:this.clinicHistory.centralNervousSystem,
                    eighteenCtrl:this.clinicHistory.diagnosticImpression,
                    nineteenCtrl:this.clinicHistory.laboratoryControl,
                    twentyCtrl:this.clinicHistory.treatmentPlan,
                    });
          }


      let secondNameTested="";
      let secondNameTest=this.firstFormGroup.get('secondCtrl')!.value;
      if(typeof secondNameTest=="string") secondNameTest.trim();
      secondNameTest==null
        || secondNameTest==""
        || secondNameTest==undefined?secondNameTested="":(secondNameTested=secondNameTest.toUpperCase()).trim();

      let secondSurNameTest=(this.firstFormGroup.get('fourCtrl')!.value);
      if(typeof secondSurNameTest=="string") secondSurNameTest.trim();

      let secondSurNameTested="";
      secondSurNameTest ==null
        || secondSurNameTest ==""
        || secondSurNameTest==undefined?secondSurNameTested="":(secondSurNameTested=secondSurNameTest.toUpperCase()).trim();

        this.patient.id = this.patient.id;

        this.patient.firstName = this.firstFormGroup.get('firstCtrl')!.value;
        this.patient.firstName=this.patient.firstName.toUpperCase().trim();
        this.patient.secondName = secondNameTested;

        this.patient.firtsSurName = this.firstFormGroup.get('threeCtrl')!.value;
        this.patient.firtsSurName=this.patient.firtsSurName.toUpperCase().trim();

        this.patient.secondSurName = secondSurNameTested;
        this.patient.idType = this.firstFormGroup.get('fifthCtrl')!.value;
        this.patient.personId = (this.firstFormGroup.get('sixCtrl')!.value).trim().toUpperCase();
        this.patient.email = (this.firstFormGroup.get('sevenCtrl')!.value).trim().toLowerCase();
        this.patient.address = this.firstFormGroup.get('nineCtrl')!.value;
        this.patient.cellPhoneNumber = String(this.firstFormGroup.get('eightCtrl')!.value);
        this.patient.emergencyContact = String(this.firstFormGroup.get('tenCtrl')!.value);
        this.patient.emergencyContactName = String(this.firstFormGroup.get('twelveCtrl')!.value);
        this.patient.birthDate = new Date(this.firstFormGroup.get('elevenCtrl')!.value);
        this.patient.personType = 3;
        this.patient.isClient = true;
        this.patient.bloodType=  String(this.firstFormGroup.get('bloodTypeCtrl')!.value);


        if(this.categoryService=='cmc')
        {
            this.clinicHistory.id=0;
            this.clinicHistory.clinicHistoryObservations?.forEach(x => { x.id = 0; x.creationUserId = parseInt(localStorage?.getItem('Id')) });
            this.clinicHistory.medicalFormula?.forEach(x => { x.id = 0; x.creationUserId = parseInt(localStorage?.getItem('Id'))  });
        }


        this.busy = this._personService.addOrUpdatePerson(this.patient).subscribe(data =>
        {
            this.patient.id = data;

            if (this.clinicHistory.id == 0)
            {
                this._clinicHistoryService.createClinicHistory(this.patient.id,2).subscribe(data =>
                {
                    this.clinicHistory.id = data;

                    if (this.patient.patientInformationId != null)
                    {
                        var stateCodeTemp = null;
                        this._patientInformationService.getPatientInformation(this.patient.patientInformationId).subscribe(data => {
                            this.patientInformation = data;

                            if (this.cities.find(ci => ci.id == this.patientInformation.residenceCityId) != undefined)
                            {
                                stateCodeTemp = this.cities.find(ci => ci.id == this.patientInformation.residenceCityId).code.substring(0, 2);
                                this._cityService.getCitiesbyState(stateCodeTemp).subscribe(data => {
                                    this.cities = data;
                                })
                            }
                            else
                            {
                                this.cities = [];
                            }

        //crear odontograma si no existe

                            this.secondFormGroup.patchValue({
                                firstCtrl: this.patientInformation.sexType,
                                secondCtrl: this.patientInformation.genderIdentity,
                                threeCtrl: this.patientInformation.disabilityCategory != null ? this.patientInformation.disabilityCategory : "08",
                                fourCtrl: this.patientInformation.ethnicity,
                                fifthCtrl: this.patientInformation.ethnicCommunity,
                                sixCtrl: this.patientInformation.residenceZone,
                                sevenCtrl: this.epsList.find(x => x.id == this.patientInformation.epsId)?.code,
                                nineCtrl: this.personOcupationList.find(p => p.id == this.patientInformation.personOcupationId)?.code,
                                eightCtrl: this.countries.find(c => c.id == this.patientInformation.birthCountryId)?.code,
                                tenCtrl: this.countries.find(co => co.id == this.patientInformation.residenceCountryId)?.code,
                                elevenCtrl: this.cities.find(ci => ci.id == this.patientInformation.residenceCityId)?.code,
                                twelveCtrl: this.cities.find(ci => ci.id == this.patientInformation.residenceCityId)?.code.substring(0, 2),
                                thirteen: this.patientInformation.organDonor?.organDonorAnswer,
                                fourtheen: this.patientInformation.organDonor?.organDonorDocumentDate?.toString().split('T')[0],
                                fiftheen: this.patientInformation.advancedDirectiveDocument?.advancedDirectiveDocumentAnswer,
                                sixteen: this.patientInformation.advancedDirectiveDocument?.advancedDirectiveDocumentDate?.toString().split('T')[0]
                            });

                        this.thirdFormGroup.patchValue({
                            secondCtrl:"7600108820",
                            threeCtrl: "01",
                            fourCtrl: "05"
                        });

                            if (this.epsList.find(x => x.id == this.patientInformation.epsId)?.code != undefined) {
                                this.epsFilterCtrl.setValue(this.epsList.find(x => x.id == this.patientInformation.epsId).name);
                            }
                            if (this.personOcupationList.find(p => p.id == this.patientInformation.personOcupationId)?.code != undefined) {
                                this.ocupationFilterCtrl.setValue(this.personOcupationList.find(p => p.id == this.patientInformation.personOcupationId).description);
                            }
                            if (this.countries.find(co => co.id == this.patientInformation.residenceCountryId)?.code != undefined) {
                                this.countryFilterCtrl.setValue(this.countries.find(co => co.id == this.patientInformation.residenceCountryId).name);
                            }
                            if (next) this.stepper.next();
                            else this.close();
                        });

                    }
                    else
                    {


                        this.patientInformation.id = 0;
                        this.secondFormGroup.patchValue({
                        firstCtrl:  "02",
                        secondCtrl: "02",
                        threeCtrl:  "08",
                        fourCtrl:   "06",
                        fifthCtrl:  "",
                        sixCtrl: "01",
                        sevenCtrl:"999999",
                        nineCtrl: "9629",
                        eightCtrl: "170",
                        tenCtrl: "170",
                        elevenCtrl: "",
                        twelveCtrl: "",

                        });

                        this.thirdFormGroup.patchValue({
                        secondCtrl:"7600108820",
                        threeCtrl: "01",
                        fourCtrl: "05"
                        });

                        this.cities = [];
                        if (next)
                          {
                            this.stepper.next();

                          }
                        else this.close();
                    }


                    this._odontogramaService.createOdontograma(this.clinicHistory.id, this.patient.id).subscribe
                    ({
                      next:(data)=>{
                        this.clinicHistory.isOdontograma=data;
                        this.toastr.success("Exito", "Se ha creado el odontograma");
                      },
                      error:(err)=>{
                        this.toastr.error("Fracaso", "No se creó el odontograma");
                      }
                    })

                });
            }

            else
            {
                if (this.patient.patientInformationId != null)
                {
                    var stateCodeTemp = null;
                    this._patientInformationService.getPatientInformation(this.patient.patientInformationId).subscribe(data => {
                        this.patientInformation = data;
                        if (this.cities.find(ci => ci.id == this.patientInformation.residenceCityId) != undefined)
                        {
                            stateCodeTemp = this.cities.find(ci => ci.id == this.patientInformation.residenceCityId).code.substring(0, 2);
                            this._cityService.getCitiesbyState(stateCodeTemp).subscribe(data => {
                                this.cities = data;
                            })
                        }
                        else {
                            this.cities = [];
                        }
                        this.secondFormGroup.patchValue({
                            firstCtrl: this.patientInformation.sexType,
                            secondCtrl: this.patientInformation.genderIdentity,
                            threeCtrl: this.patientInformation.disabilityCategory != null ? this.patientInformation.disabilityCategory : "08",
                            fourCtrl: this.patientInformation.ethnicity,
                            fifthCtrl: this.patientInformation.ethnicCommunity,
                            sixCtrl: this.patientInformation.residenceZone,
                            sevenCtrl: this.epsList.find(x => x.id == this.patientInformation.epsId)?.code,
                            nineCtrl: this.personOcupationList.find(p => p.id == this.patientInformation.personOcupationId)?.code,
                            eightCtrl: this.countries.find(c => c.id == this.patientInformation.birthCountryId)?.code,
                            tenCtrl: this.countries.find(co => co.id == this.patientInformation.residenceCountryId)?.code,
                            elevenCtrl: this.cities.find(ci => ci.id == this.patientInformation.residenceCityId)?.code,
                            twelveCtrl: this.cities.find(ci => ci.id == this.patientInformation.residenceCityId)?.code.substring(0, 2),
                            thirteen: this.patientInformation.organDonor?.organDonorAnswer,
                            fourtheen: this.patientInformation.organDonor?.organDonorDocumentDate?.toString().split('T')[0],
                            fiftheen: this.patientInformation.advancedDirectiveDocument?.advancedDirectiveDocumentAnswer,
                            sixteen: this.patientInformation.advancedDirectiveDocument?.advancedDirectiveDocumentDate?.toString().split('T')[0]
                        });
                        if (this.epsList.find(x => x.id == this.patientInformation.epsId)?.code != undefined) {
                            this.epsFilterCtrl.setValue(this.epsList.find(x => x.id == this.patientInformation.epsId).name);
                        }
                        if (this.personOcupationList.find(p => p.id == this.patientInformation.personOcupationId)?.code != undefined) {
                            this.ocupationFilterCtrl.setValue(this.personOcupationList.find(p => p.id == this.patientInformation.personOcupationId).description);
                        }
                        if (this.countries.find(co => co.id == this.patientInformation.residenceCountryId)?.code != undefined) {
                            this.countryFilterCtrl.setValue(this.countries.find(co => co.id == this.patientInformation.residenceCountryId).name);
                        }
                        if (next) this.stepper.next();
                        else this.close();
                    });

                }
                // End of if (this.patient.patientInformationId != null)
                else
                {
                  this.patientInformation.id = 0;
                  this.secondFormGroup.patchValue({
                        firstCtrl:  "02",
                        secondCtrl: "02",
                        threeCtrl:  "08",
                        fourCtrl:   "06",
                        fifthCtrl:  "",
                        sixCtrl: "01",
                        nineCtrl: "9997",
                        eightCtrl: "170",
                        tenCtrl: "170",
                        elevenCtrl: "76001",
                    });


                this.thirdFormGroup.patchValue({
                    firstCtrl: new Date(), //Fecha de la Atencion
                    secondCtrl: "7600108820", //Prestador de Servicios
                    threeCtrl: null,   //>Grupo de Servicios
                    fourCtrl: "01",// Modalidad de la Tecnologia de Salud
                    fifthCtrl:"05",   //Lugar de Atención
                    sixCtrl:"01", //Ruta de Entrada
                    sevenCtrl:"38", //Causa de Atención
                    thirteenCtrl: "01", //Tipo de servicio
                    fourteenCtrl: 0, //Precio
                });




                    this.cities = [];
                    if (next) this.stepper.next();
                    else this.close();
                }
            }

        });
    }
//#region CreateOrUpdatePatienInformation
    createOrUpdatePatientInformation(next: boolean): void
    {
      console.log("ENTRA A COUPI, this.categoryService es: ", this.categoryService);
            this.currentScreen=this.stepper.selectedIndex +1;

        const patientInformationInput: BOPatientInformation =
        {
            id: this.patientInformation.id,
            sexType: this.secondFormGroup.get('firstCtrl')!.value,
            genderIdentity: this.secondFormGroup.get('secondCtrl').value,
            disabilityCategory: this.secondFormGroup.get('threeCtrl').value,
            ethnicity: this.secondFormGroup.get('fourCtrl').value,
            ethnicCommunity: this.secondFormGroup.get('fifthCtrl').value,
            residenceZone: this.secondFormGroup.get('sixCtrl').value,
            epsId: this.secondFormGroup.get('sevenCtrl').value != undefined ? this.epsList.find(e => e.code == this.secondFormGroup.get('sevenCtrl').value)?.id : undefined,
            birthCountryId: this.secondFormGroup.get('eightCtrl').value != undefined ? this.countries.find(e => e.code == this.secondFormGroup.get('eightCtrl').value)?.id : undefined,
            personOcupationId: this.secondFormGroup.get('nineCtrl').value != undefined ? this.personOcupationList.find(e => e.code == this.secondFormGroup.get('nineCtrl').value)?.id : undefined,
            residenceCountryId: this.secondFormGroup.get('tenCtrl').value != undefined ? this.countries.find(e => e.code == this.secondFormGroup.get('tenCtrl').value)?.id : undefined,
            residenceCityId: this.secondFormGroup.get('elevenCtrl').value != undefined ? this.cities.find(e => e.code == this.secondFormGroup.get('elevenCtrl').value)?.id : undefined
        };

        if (this.patientInformation.organDonor != null) {
            patientInformationInput.organDonor = this.patientInformation.organDonor;
            patientInformationInput.organDonor.organDonorAnswer = this.secondFormGroup.get('thirteen').value;
            patientInformationInput.organDonor.organDonorDocumentDate = this.secondFormGroup.get('fourtheen').value != undefined ? new Date(this.secondFormGroup.get('fourtheen').value) : null;
        }
        else {
            patientInformationInput.organDonor = new BOOrganDonor();
            patientInformationInput.organDonor.id = 0;
            patientInformationInput.organDonor.organDonorAnswer = this.secondFormGroup.get('thirteen').value;
            patientInformationInput.organDonor.organDonorDocumentDate = this.secondFormGroup.get('fourtheen').value != undefined ? new Date(this.secondFormGroup.get('fourtheen').value) : null;
        }
        if (this.patientInformation.advancedDirectiveDocument != null) {
            patientInformationInput.advancedDirectiveDocument = this.patientInformation.advancedDirectiveDocument;
            patientInformationInput.advancedDirectiveDocument.advancedDirectiveDocumentAnswer = this.secondFormGroup.get('fiftheen').value;
            patientInformationInput.advancedDirectiveDocument.advancedDirectiveDocumentDate = this.secondFormGroup.get('sixteen').value != undefined ? new Date(this.secondFormGroup.get('sixteen').value) : null;
        }
        else
        {
            patientInformationInput.advancedDirectiveDocument = new BOAdvancedDirectiveDocument();
            patientInformationInput.advancedDirectiveDocument.id = 0;
            patientInformationInput.advancedDirectiveDocument.advancedDirectiveDocumentAnswer = this.secondFormGroup.get('fiftheen').value;
            patientInformationInput.advancedDirectiveDocument.advancedDirectiveDocumentDate = this.secondFormGroup.get('sixteen').value != undefined ? new Date(this.secondFormGroup.get('sixteen').value) : null;
        }

        this.busy = this._patientInformationService.addOrUpdatePatientInformation(patientInformationInput).subscribe(data =>
        {

            if (this.categoryService=="cmg")
            {
              this.profesionalSelected=null;
              this.areaSelected=2;

                this.thirdFormGroup.patchValue({
                    firstCtrl: new Date(),
                    secondCtrl: "7600108820",
                    threeCtrl: null,
                    fourCtrl: "01",
                    fifthCtrl:"05",
                    sixCtrl:"01",
                    sevenCtrl:"38",
                    thirteenCtrl: "01",
                    fourteenCtrl: 0,
                });

            }

            if (this.categoryService=="cmc")
            {
              let ipsTemp=this.ipsList.find(x => x.id == this.clinicHistory.ipsId)?.code;
                this.thirdFormGroup.patchValue({

                    firstCtrl: null,
                    secondCtrl: '7600108820',
                    threeCtrl: "01",
                    fourCtrl: this.clinicHistory.healthTechnologyModality,
                    fifthCtrl: this.clinicHistory.placeOfAttention,
                    sixCtrl: this.clinicHistory.routeOfEntry,
                    sevenCtrl: this.clinicHistory.consultationCause,
                    eightCtrl: this.clinicHistory.triageDate,
                    nineCtrl: this.clinicHistory.triageType,
                    thirteenCtrl: "37",
                    fourteenCtrl: "0",
                    fifteenCtrl: "Consulta de control médico"

                });

            }

            if (this.categoryService=="edi")
            {
              console.log("ENTRA A COUPI THIS.CATERGORYSERVICE==EDI ch es:", this.clinicHistory);
            //   this.thirdFormGroup.patchValue({
            //     firstCtrl: this.clinicHistory.consultationDate?.toString()?? Date.now(),
            //     secondCtrl: this.ipsList.find(x => x.id == this.clinicHistory.ipsId)?.code,
            //     threeCtrl: this.clinicHistory.serviceGroups,
            //     fourCtrl: this.clinicHistory.healthTechnologyModality,
            //     fifthCtrl: this.clinicHistory.placeOfAttention,
            //     sixCtrl: this.clinicHistory.routeOfEntry,
            //     sevenCtrl: this.clinicHistory.consultationCause,
            //     eightCtrl: this.clinicHistory.triageDate,
            //     nineCtrl: this.clinicHistory.triageType,
            //     thirteenCtrl: this.clinicHistory.serviceType,
            //     fourteenCtrl: this.clinicHistory.servicePrice,
            //     fifteenCtrl: this.clinicHistory.procedureDescription,
            // });

              const conDate=this.clinicHistory.consultationDate?.toString();
              const code =this.ipsList.find(x => x.id == this.clinicHistory.ipsId)?.code;

                  this.thirdFormGroup.patchValue({
                  firstCtrl: conDate?? new Date(),
                  secondCtrl: code?? "7600108820",
                  threeCtrl: this.clinicHistory.serviceGroups,
                  fourCtrl: this.clinicHistory.healthTechnologyModality?? "01",
                  fifthCtrl: this.clinicHistory.placeOfAttention?? "05",
                  sixCtrl: this.clinicHistory.routeOfEntry?? "01",
                  sevenCtrl: this.clinicHistory.consultationCause?? "38",
                  eightCtrl: this.clinicHistory.triageDate,
                  nineCtrl: this.clinicHistory.triageType,
                  thirteenCtrl: this.clinicHistory.serviceType?? "01",
                  fourteenCtrl: this.clinicHistory.servicePrice?? 0,
                  fifteenCtrl: this.clinicHistory.procedureDescription,
                  seventeenCtrl:this.clinicHistory.area
              });
     //       this._cdr.detectChanges();

            }

            if (this.patientInformation.id > 0) {
                if (next) this.stepper.next();
                 else this.close();
            }
            else
            {
              this.patientInformation.id = data;
              this.patient.patientInformationId = data;

              this._personService.addOrUpdatePerson(this.patient).subscribe(data => {

                  if (next)
                  {
                    this.stepper.next();
                  }
                  else this.close();

              });

            }
        });
    }

//#endregion

//#region updateClinicHistory

    updateClinicHistory(next: boolean, step: string): void
    {
      this.activeTab( parseInt(step) +1);
        if (this.isSaving) {
          this.toastr.warning('Operación en curso', 'Por favor espere a que se complete el guardado');
          return;
        }

        if(step=="2")
        {
            if(this.profesionalSelected==null || this.profesionalSelected==undefined  )
            {
             this.toastr.error('Profesional no seleccionado', 'Debe elegir un profesional');
            }
            else{
            this.updateClinicHistoryBody(next,step);
            }
        }
        else
        {
          this.updateClinicHistoryBody(next,step);
        }

    }

    updateClinicHistoryBody(next: boolean, step: string):void
    {
       this.clinicHistory.clinicHistoryObservations?.forEach(x => { if (x.id < 0) { x.id = 0; x.creationUserId = parseInt(localStorage?.getItem('Id')) } });
      this.clinicHistory.medicalFormula?.forEach(x => { if (x.id < 0) { x.id = 0; x.creationUserId = parseInt(localStorage?.getItem('Id')) } });
      this.isOdontograma=this.clinicHistory.isOdontograma;
       try
       {
           // console.log("Inicia rutina para averiguar si tiene recibos de pago en sellService");
            this._sellService.getSellByClinicHistoryId(this.clinicHistory.id).subscribe({
              next:(data)=>{
                //console.log("ENTRA AL SERVICE , data es:", data);
              this.clinicHistoryAsignedToSell=data.clinicHistoryId;
              this._cdr.detectChanges();
              },
              error:(err)=>{
              console.log("Ocurrió un error al averiguar si tiene recibos de pago");

              }
            });


          if (this.showOnlyObservations)
          {
              this.busy = this._clinicHistoryService.updateClinicHistory(this.clinicHistory, this.stepper.selectedIndex.toString())

              .pipe(
                  finalize(() => {
                    //console.log("Entra al finalize de GUARDAR Y CERRAR");
                    //STOP
                    //this.isLoading = false;
                    this.isSaving = false;
                    this._cdr.detectChanges();
                  })
               )

              .subscribe({
                next:(data) => {
                  this.close();
               },
                error:(err)=>{
                    console.log("Ocurrió un error subscribe onlyObservations");
                }
              });
          }
          else
          {


            if(this.categoryService=="cmg" || this.categoryService=="cmc")
            {
              var servicePriceFormatted=0.00;
              if(this.categoryService=='cmg')
              {
                const value = this.thirdFormGroup.get('fourteenCtrl')!.value;
                var numericValue = parseFloat(value); // Convertir a número

                if (!isNaN(numericValue)) {
                  console.log("En chOdontology Entra a !isNaN(numericValue)");
                  servicePriceFormatted = parseFloat(numericValue.toFixed(2));
                } else {
                  this.toastr.error('Error', 'Error de formato en el número');
                  return;
                }
              }

              const clnicHistoryInput: BOClinicHistory = {
                  id: this.clinicHistory.id,
                  patientId: this.patient.id,
                  profesional:this.profesionals.find(x => x.id == this.profesionalSelected),
                  area:this.areaSelected,
                  isOdontograma:this.clinicHistory.isOdontograma,
                  isPaidMethod:this.clinicHistory.isPaidMethod,

                  consultationDate: new Date(this.thirdFormGroup.get('firstCtrl')!.value),
                  ipsId: this.ipsList.find(x => x.code == this.thirdFormGroup.get('secondCtrl')!.value).id,
                  serviceGroups: this.thirdFormGroup.get('threeCtrl')!.value,
                  healthTechnologyModality: this.thirdFormGroup.get('fourCtrl')!.value,
                  placeOfAttention: this.thirdFormGroup.get('fifthCtrl')!.value,
                  routeOfEntry: this.thirdFormGroup.get('sixCtrl')!.value,
                  consultationCause: this.thirdFormGroup.get('sevenCtrl')!.value,
                  triageDate: new Date(this.thirdFormGroup.get('eightCtrl')!.value),
                  triageType: this.thirdFormGroup.get('nineCtrl')!.value,
                  clinicHistoryObservations: this.clinicHistory.clinicHistoryObservations,
                  medicalFormula: this.clinicHistory.medicalFormula,
                  serviceType: this.thirdFormGroup.get('thirteenCtrl')!.value,
                  servicePrice:servicePriceFormatted,
                  procedureDescription: this.thirdFormGroup.get('fifteenCtrl')!.value,

                  pathologicalRecord: this.sixFormGroup.get('firstCtrl')!.value,
                  consultationMotive: this.sixFormGroup.get('secondCtrl')!.value,
                  anamnesis: this.sixFormGroup.get('threeCtrl')!.value,
                  arterialPressure: this.sixFormGroup.get('fourCtrl')!.value,
                  temperature: this.sixFormGroup.get('fifthCtrl')!.value,
                  pulse: this.sixFormGroup.get('sixCtrl')!.value,
                  weight: this.sixFormGroup.get('sevenCtrl')!.value,
                  size: this.sixFormGroup.get('eightCtrl')!.value,
                  breathing: this.sixFormGroup.get('nineCtrl')!.value,
                  head: this.sixFormGroup.get('tenCtrl')!.value,
                  neck: this.sixFormGroup.get('elevenCtrl')!.value,
                  chest: this.sixFormGroup.get('twelveCtrl')!.value,
                  belly: this.sixFormGroup.get('thirteenCtrl')!.value,
                  pelvis: this.sixFormGroup.get('fourteenCtrl')!.value,
                  extremities: this.sixFormGroup.get('fiftheenCtrl')!.value,
                  skin: this.sixFormGroup.get('sixteenCtrl')!.value,
                  centralNervousSystem: this.sixFormGroup.get('seventeenCtrl')!.value,
                  diagnosticImpression: this.sixFormGroup.get('eighteenCtrl')!.value,
                  laboratoryControl: this.sixFormGroup.get('nineteenCtrl')!.value,
                  treatmentPlan: this.sixFormGroup.get('twentyCtrl')!.value,
                  //
                  controlConsultation: 0,
              }

              if(this.categoryService=='cmc')
              {
                this.clinicHistoryControl.controlConsultation=1;

              this.busy = this._clinicHistoryService.updateClinicHistory(clnicHistoryInput, this.stepper.selectedIndex.toString())

              .pipe(
                  finalize(() => {
                    //console.log("Entra al finalize primer if(this.categoryService==cmc)");
                    //STOP
                    this.isSaving = false;
                    this._cdr.detectChanges();
                  })
               )
              .subscribe({
                next:(data) =>
                {
                    this._clinicHistoryService.getClinicHistory(this.clinicHistory.id)
                    .pipe(
                        finalize(() => {
                          //console.log("Entra al finalize segundo subscribe de if(this.categoryService==cmc)");
                          //STOP
                          this.isSaving = false;
                          this._cdr.detectChanges();
                        })
                    )
                    .subscribe({
                      next:(data) =>
                      {
                            this.clinicHistory = data;
                            this._clinicHistoryService.updateClinicHistory(this.clinicHistoryControl, this.stepper.selectedIndex.toString())
                            .pipe(
                                finalize(() => {
                                  //console.log("Entra al finalize tercer subscribe de  if(this.categoryService==cmc)");
                                  //STOP
                                  this.isSaving = false;
                                  this._cdr.detectChanges();
                                })
                            )
                            .subscribe({
                              next:(data)=>
                              {
                                if (next)
                                {
                                    if (this.stepper.selectedIndex != 8  && this.stepper.selectedIndex < 9)
                                    {
                                      this.isSaving = false;
                                        this.stepper.next();
                                    }
                                }
                                else{

                                      this.isSaving = false;
                                      this.close();
                                }
                            },
                              error:(err)=>{
                              console.log("error en tercer subscribe f(this.categoryService==cmc)");
                            }

                          })
                      },
                      error:(err)=>{
                        console.log("error en segundo subscribe f(this.categoryService==cmc)");
                      }
                    })

                    //2222

                },
                error:(err)=>{
                console.log("error en subscribe exterior de primer if(this.categoryService==cmc)");
                }
              });
//////


              }

              if(this.categoryService=='cmg')//consulta médica general
              {

                this.busy = this._clinicHistoryService.updateClinicHistory(clnicHistoryInput, this.stepper.selectedIndex.toString())
                .pipe(
                    finalize(() => {
                      //console.log("Entra al finalize primer if(this.categoryService==CMG)");
                      //STOP
                      this.isSaving = false;
                      this._cdr.detectChanges();
                    })
                )
                .subscribe({
                  next:(data) =>
                  {
                      this._clinicHistoryService.getClinicHistory(this.clinicHistory.id)
                      .pipe(
                          finalize(() => {
                           // console.log("Entra al finalize segundo de if(this.categoryService==CMG)");
                            //STOP
                            this.isSaving = false;
                            this._cdr.detectChanges();
                          })
                      )
                      .subscribe({
                        next:(data) =>
                          {
                            this.clinicHistory = data;

                                if (next)
                                {
                                      if (this.stepper.selectedIndex != 8 && this.stepper.selectedIndex < 9)
                                      {
                                         this.isSaving = false;
                                         this.stepper.next();
                                      }
                                 }
                                 else {
                                    this.isSaving = false;
                                    this.close();
                                 }

                        },
                        error:(err)=>{
                          console.log("error en tercer subscribe f(this.categoryService==CMG)");
                        }
                      })

                  },
                  error:(err)=>{
                  console.log("error en subscribe exterior de primer if(this.categoryService==CMG)");
                  }

                });
              }

            }

            else //entra a edit
            {
    //          const servicePriceFormatted = parseFloat(this.thirdFormGroup.get('fourteenCtrl')!.value.toFixed(2));
              const servicePriceFormatted = this.thirdFormGroup.get('fourteenCtrl')!.value;

              const clnicHistoryInput: BOClinicHistory = {
                    id: this.clinicHistory.id,
                    patientId: this.patient.id,
                    profesional:this.profesionals.find(x => x.id == this.profesionalSelected),
                    area:this.areaSelected,
                    isOdontograma:this.clinicHistory.isOdontograma,
                    isPaidMethod:this.clinicHistory.isPaidMethod,

                    consultationDate: new Date(this.thirdFormGroup.get('firstCtrl')!.value),
                    ipsId: this.ipsList.find(x => x.code == this.thirdFormGroup.get('secondCtrl')!.value).id,
                    serviceGroups: this.thirdFormGroup.get('threeCtrl')!.value,
                    healthTechnologyModality: this.thirdFormGroup.get('fourCtrl')!.value,
                    placeOfAttention: this.thirdFormGroup.get('fifthCtrl')!.value,
                    routeOfEntry: this.thirdFormGroup.get('sixCtrl')!.value,
                    consultationCause: this.thirdFormGroup.get('sevenCtrl')!.value,
                    triageDate: new Date(this.thirdFormGroup.get('eightCtrl')!.value),
                    triageType: this.thirdFormGroup.get('nineCtrl')!.value,
                    clinicHistoryObservations: this.clinicHistory.clinicHistoryObservations,
                    medicalFormula: this.clinicHistory.medicalFormula,
                    serviceType: this.thirdFormGroup.get('thirteenCtrl')!.value,

                    servicePrice: servicePriceFormatted,

                    procedureDescription: this.thirdFormGroup.get('fifteenCtrl')!.value,
                    pathologicalRecord: this.sixFormGroup.get('firstCtrl')!.value,
                    consultationMotive: this.sixFormGroup.get('secondCtrl')!.value,
                    anamnesis: this.sixFormGroup.get('threeCtrl')!.value,
                    arterialPressure: this.sixFormGroup.get('fourCtrl')!.value,
                    temperature: this.sixFormGroup.get('fifthCtrl')!.value,
                    pulse: this.sixFormGroup.get('sixCtrl')!.value,
                    weight: this.sixFormGroup.get('sevenCtrl')!.value,
                    size: this.sixFormGroup.get('eightCtrl')!.value,
                    breathing: this.sixFormGroup.get('nineCtrl')!.value,
                    head: this.sixFormGroup.get('tenCtrl')!.value,
                    neck: this.sixFormGroup.get('elevenCtrl')!.value,
                    chest: this.sixFormGroup.get('twelveCtrl')!.value,
                    belly: this.sixFormGroup.get('thirteenCtrl')!.value,
                    pelvis: this.sixFormGroup.get('fourteenCtrl')!.value,
                    extremities: this.sixFormGroup.get('fiftheenCtrl')!.value,
                    skin: this.sixFormGroup.get('sixteenCtrl')!.value,
                    centralNervousSystem: this.sixFormGroup.get('seventeenCtrl')!.value,
                    diagnosticImpression: this.sixFormGroup.get('eighteenCtrl')!.value,
                    laboratoryControl: this.sixFormGroup.get('nineteenCtrl')!.value,
                    treatmentPlan: this.sixFormGroup.get('twentyCtrl')!.value,
                    controlConsultation:this.clinicHistory.controlConsultation,
                }

                this.busy = this._clinicHistoryService
                .updateClinicHistory(clnicHistoryInput, this.stepper.selectedIndex.toString())
                .pipe(
                    finalize(() => {
                      //console.log("Entra al finalize primer EDI)");
                      this.isSaving = false;
                      this._cdr.detectChanges();
                    })
                )
                .subscribe({
                  next:(data) =>
                  {
                    this._clinicHistoryService.getClinicHistory(this.clinicHistory.id)
                    .pipe(
                        finalize(() => {
                          //console.log("Entra al finalize del segundo subscribe de  EDI)");
                          this.isSaving = false;
                          this._cdr.detectChanges();
                        })
                    )
                    .subscribe({
                      next:(data) =>
                      {
                        this.clinicHistory = data;

                          this._sellService.getSellByClinicHistoryId(this.clinicHistory.id)
                          .pipe(
                              finalize(() => {
                               // console.log("Entra al finalize del tercer subscribe de  EDI)");
                                this.isSaving = false;
                                this._cdr.detectChanges();
                              })
                          )
                          .subscribe({
                            next:(data)=>
                            {
                            this.clinicHistoryAsignedToSell=data.clinicHistoryId;
                            this._cdr.detectChanges();
                            },
                            error:(err)=>{
                              console.log("error en tercer subscribe f(this.categoryService==EDI)");
                            }

                          });

                        if (next)
                        {
                              if (this.stepper.selectedIndex != 8 && this.stepper.selectedIndex < 9)
                              {
                                 this.isSaving = false;
                                  this.stepper.next();
                              }
                        }
                        else
                        {
                          this.isSaving = false;
                          this.close();
                        }
                      },
                      error:(err)=>{
                       console.log("error en segundo subscribe f(this.categoryService==EDI)");
                      }

                    })

                  },
                  error:(err)=>{
                   //console.log("error en primer subscribe f(this.categoryService==EDI)");
                   this.toastr.error("Error", "Revise los campos obligatorios")

                  }

                });

            }

          }



      }
      catch(error)
      {
          this.isSaving = false;
          this.errorMessage = "Error al procesar los datos";
          this.toastr.error('Error al procesar los datos', 'Error', { timeOut: 1500 });
          console.error('Error en saveSell:', error);
          this._cdr.detectChanges();
      }


    }


    updateClinicHistoryUpNavigation(step: number, guardar?:boolean): void
    {
        if(step==2)
        {
            if(this.profesionalSelected==null || this.profesionalSelected==undefined  )
            {

             this.toastr.error('Profesional no seleccionado', 'Debe elegir un profesional');
            }
            else{
            this.updateClinicHistoryBodyUpNavigation(step);

            }
        }
        else
        {
          this.updateClinicHistoryBodyUpNavigation(step, guardar);
        }

    }




    updateClinicHistoryBodyUpNavigation(currentStep: number, guardar?:boolean):void
    {
      this.activeTab(currentStep);

      this.clinicHistory.clinicHistoryObservations?.forEach(x => { if (x.id < 0) { x.id = 0; x.creationUserId = parseInt(localStorage?.getItem('Id')) } });
      this.clinicHistory.medicalFormula?.forEach(x => { if (x.id < 0) { x.id = 0; x.creationUserId = parseInt(localStorage?.getItem('Id')) } });
      this.isOdontograma=this.clinicHistory.isOdontograma;

            this._sellService.getSellByClinicHistoryId(this.clinicHistory.id).subscribe(data=>{
              this.clinicHistoryAsignedToSell=data.clinicHistoryId;
              this._cdr.detectChanges();

             });
      if (currentStep==8)
      {
          this.busy = this._clinicHistoryService.updateClinicHistory(this.clinicHistory, currentStep.toString()).subscribe(data => {
          this._cdr.detectChanges();
          });

          if(guardar==true)
            {
              //console.log('Entra al if (guardar==true');

              this.close();

            }

      }
      else
      {
          //const servicePriceFormatted = parseFloat(this.thirdFormGroup.get('fourteenCtrl')!.value.toFixed(2));
          const servicePriceFormatted = this.thirdFormGroup.get('fourteenCtrl')!.value;

          const clnicHistoryInput: BOClinicHistory = {
                id: this.clinicHistory.id,
                patientId: this.patient.id,
                profesional:this.profesionals.find(x => x.id == this.profesionalSelected),
                area:this.areaSelected,
                isOdontograma:this.clinicHistory.isOdontograma,
                isPaidMethod:this.clinicHistory.isPaidMethod,

                consultationDate: new Date(this.thirdFormGroup.get('firstCtrl')!.value),
                ipsId: this.ipsList.find(x => x.code == this.thirdFormGroup.get('secondCtrl')!.value).id,
                serviceGroups: this.thirdFormGroup.get('threeCtrl')!.value,
                healthTechnologyModality: this.thirdFormGroup.get('fourCtrl')!.value,
                placeOfAttention: this.thirdFormGroup.get('fifthCtrl')!.value,
                routeOfEntry: this.thirdFormGroup.get('sixCtrl')!.value,
                consultationCause: this.thirdFormGroup.get('sevenCtrl')!.value,
                triageDate: new Date(this.thirdFormGroup.get('eightCtrl')!.value),
                triageType: this.thirdFormGroup.get('nineCtrl')!.value,
                clinicHistoryObservations: this.clinicHistory.clinicHistoryObservations,
                medicalFormula: this.clinicHistory.medicalFormula,
                serviceType: this.thirdFormGroup.get('thirteenCtrl')!.value,

                servicePrice: servicePriceFormatted,

                procedureDescription: this.thirdFormGroup.get('fifteenCtrl')!.value,
                pathologicalRecord: this.sixFormGroup.get('firstCtrl')!.value,
                consultationMotive: this.sixFormGroup.get('secondCtrl')!.value,
                anamnesis: this.sixFormGroup.get('threeCtrl')!.value,
                arterialPressure: this.sixFormGroup.get('fourCtrl')!.value,
                temperature: this.sixFormGroup.get('fifthCtrl')!.value,
                pulse: this.sixFormGroup.get('sixCtrl')!.value,
                weight: this.sixFormGroup.get('sevenCtrl')!.value,
                size: this.sixFormGroup.get('eightCtrl')!.value,
                breathing: this.sixFormGroup.get('nineCtrl')!.value,
                head: this.sixFormGroup.get('tenCtrl')!.value,
                neck: this.sixFormGroup.get('elevenCtrl')!.value,
                chest: this.sixFormGroup.get('twelveCtrl')!.value,
                belly: this.sixFormGroup.get('thirteenCtrl')!.value,
                pelvis: this.sixFormGroup.get('fourteenCtrl')!.value,
                extremities: this.sixFormGroup.get('fiftheenCtrl')!.value,
                skin: this.sixFormGroup.get('sixteenCtrl')!.value,
                centralNervousSystem: this.sixFormGroup.get('seventeenCtrl')!.value,
                diagnosticImpression: this.sixFormGroup.get('eighteenCtrl')!.value,
                laboratoryControl: this.sixFormGroup.get('nineteenCtrl')!.value,
                treatmentPlan: this.sixFormGroup.get('twentyCtrl')!.value,
                controlConsultation:this.clinicHistory.controlConsultation,

            }

            this.busy = this._clinicHistoryService
            .updateClinicHistory(clnicHistoryInput, currentStep.toString())
            .subscribe(data => {
                this._clinicHistoryService.getClinicHistory(this.clinicHistory.id).subscribe(data => {
                    this.clinicHistory = data;
                })

            });



      }

    }

//#endregion


//#region updateHealthTechnologies

    updateHealthTechnologies(next: boolean): void
    {
        this.activeTab(this.stepper.selectedIndex+1);
        if (this.clinicHistory.healthTechnologies == null) {
            this.clinicHistory.healthTechnologies = new BOHealthTechnologies();
            this.clinicHistory.healthTechnologies.id = 0;
        }
        this.clinicHistory.healthTechnologies.healthTechnology = this.fourFormGroup.get('firstCtrl')!.value;
        this.clinicHistory.healthTechnologies.healthTecnologyFinality = this.fourFormGroup.get('secondCtrl')!.value;
        this.clinicHistory.healthTechnologies.prescriptionDate = this.fourFormGroup.get('threeCtrl').value != undefined ? new Date(this.fourFormGroup.get('threeCtrl').value) : null;
        this.clinicHistory.healthTechnologies.healthTecnologyMedicamentDescription = this.fourFormGroup.get('fourCtrl')!.value;
        if (this.clinicHistory.healthTechnologies.prescriptionMedicationDose == null) {
            this.clinicHistory.healthTechnologies.prescriptionMedicationDose = new BOPrescriptionMedicationDose();
            this.clinicHistory.healthTechnologies.prescriptionMedicationDose.id = 0;
        }
        this.clinicHistory.healthTechnologies.prescriptionMedicationDose.quantity = this.fourFormGroup.get('fifthCtrl')!.value;
        this.clinicHistory.healthTechnologies.prescriptionMedicationDose.measurementMedicationUnits = this.fourFormGroup.get('sixCtrl')!.value;
        this.clinicHistory.healthTechnologies.healthTechnologyVad = this.fourFormGroup.get('sevenCtrl')!.value;

        if (this.clinicHistory.healthTechnologies.healthTechnologyTerm == null) {
            this.clinicHistory.healthTechnologies.healthTechnologyTerm = new BOHealthTechnologyTerm();
            this.clinicHistory.healthTechnologies.healthTechnologyTerm.id = 0;
        }
        this.clinicHistory.healthTechnologies.healthTechnologyTerm.quantity = this.fourFormGroup.get('eightCtrl')!.value;
        this.clinicHistory.healthTechnologies.healthTechnologyTerm.timeUnit = this.fourFormGroup.get('nineCtrl')!.value;

        if (this.clinicHistory.healthTechnologies.healthTechnologyFrecuency == null) {
            this.clinicHistory.healthTechnologies.healthTechnologyFrecuency = new BOHealthTechnologyFrecuency();
            this.clinicHistory.healthTechnologies.healthTechnologyFrecuency.id = 0;
        }
        this.clinicHistory.healthTechnologies.healthTechnologyFrecuency.quantity = this.fourFormGroup.get('tenCtrl')!.value;
        this.clinicHistory.healthTechnologies.healthTechnologyFrecuency.timeUnit = this.fourFormGroup.get('elevenCtrl')!.value;

        if (this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseTaken == null) {
            this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseTaken = new BOHealthTechnologyMedicamentDoseTaken();
            this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseTaken.id = 0;
        }
        this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseTaken.quantity = this.fourFormGroup.get('twelveCtrl')!.value;
        this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseTaken.measurementMedicationUnits = this.fourFormGroup.get('thirteenCtrl')!.value;

        if (this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseDelivered == null) {
            this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseDelivered = new BOHealthTechnologyMedicamentDoseDelivered();
            this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseDelivered.id = 0;
        }
        this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseDelivered.quantity = this.fourFormGroup.get('fiftheenCtrl')!.value;
        this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseDelivered.measurementMedicationUnits = this.fourFormGroup.get('sixteenCtrl')!.value;

        if (this.clinicHistory.healthTechnologies.healthTecnologyDeliveredUnits == null) {
            this.clinicHistory.healthTechnologies.healthTecnologyDeliveredUnits = new BOHealthTecnologyDeliveredUnits();
            this.clinicHistory.healthTechnologies.healthTecnologyDeliveredUnits.id = 0;
        }
        this.clinicHistory.healthTechnologies.healthTecnologyDeliveredUnits.quantity = this.fourFormGroup.get('seventeenCtrl')!.value;
        this.clinicHistory.healthTechnologies.healthTecnologyDeliveredUnits.measurementMedicationUnits = this.fourFormGroup.get('eighteenCtrl')!.value;

        this.clinicHistory.healthTechnologies.healthTecnologyDeliveredDate = this.fourFormGroup.get('fourteenCtrl').value != undefined ? new Date(this.fourFormGroup.get('fourteenCtrl').value) : null;

     this.busy = this._clinicHistoryService.updateClinicHistory(this.clinicHistory, this.stepper.selectedIndex.toString().trim()).subscribe(data =>
     {
            this._clinicHistoryService.getClinicHistory(this.clinicHistory.id).subscribe(data => {
                this.clinicHistory = data;

                let allowed=["01","08","09", "13","37","38","44"];
                 let passElement=false;

                 passElement=this.verifyServiceNumber(allowed);

                 if (!passElement)
                 {
                       this.close();
                 }

                 if (next) this.stepper.next();
                 else this.close();
            })

        });
    }
//#endregion

//#region updateHealthTechologiesResult


    updateHealthTechnologiesResult(next: boolean): void {
              this.activeTab(this.stepper.selectedIndex+1);

        if (this.clinicHistory.healthTechnologiesResult == null) {
            this.clinicHistory.healthTechnologiesResult = new BOHealthTechnologiesResult();
            this.clinicHistory.healthTechnologiesResult.id = 0;
        }

        if (this.clinicHistory.healthTechnologiesResult.principalMedicDiagnostic == null) {
            this.clinicHistory.healthTechnologiesResult.principalMedicDiagnostic = new BOPrincipalMedicDiagnostic();
            this.clinicHistory.healthTechnologiesResult.principalMedicDiagnostic.id = 0;
        }
        this.clinicHistory.healthTechnologiesResult.principalMedicDiagnostic.diseaseCode = this.fifthFormGroup.get('firstCtrl')!.value;
        this.clinicHistory.healthTechnologiesResult.principalMedicDiagnostic.orphanDisease = this.fifthFormGroup.get('secondCtrl')!.value;
        this.clinicHistory.healthTechnologiesResult.principalMedicDiagnostic.diagnosticType = this.fifthFormGroup.get('threeCtrl')!.value;

        if (this.clinicHistory.healthTechnologiesResult.relatedMedicDiagnostic == null) {
            this.clinicHistory.healthTechnologiesResult.relatedMedicDiagnostic = new BORelatedMedicDiagnostic();
            this.clinicHistory.healthTechnologiesResult.relatedMedicDiagnostic.id = 0;
        }
        this.clinicHistory.healthTechnologiesResult.relatedMedicDiagnostic.diseaseCode = this.fifthFormGroup.get('fourCtrl')!.value;
        this.clinicHistory.healthTechnologiesResult.relatedMedicDiagnostic.orphanDisease = this.fifthFormGroup.get('fifthCtrl')!.value;

        if (this.clinicHistory.healthTechnologiesResult.complicationMedicDiagnostic == null) {
            this.clinicHistory.healthTechnologiesResult.complicationMedicDiagnostic = new BOComplicationMedicDiagnostic();
            this.clinicHistory.healthTechnologiesResult.complicationMedicDiagnostic.id = 0;
        }
        this.clinicHistory.healthTechnologiesResult.complicationMedicDiagnostic.diseaseCode = this.fifthFormGroup.get('sixCtrl')!.value;
        this.clinicHistory.healthTechnologiesResult.complicationMedicDiagnostic.orphanDisease = this.fifthFormGroup.get('sevenCtrl')!.value;

        this.clinicHistory.healthTechnologiesResult.patientCondition = this.fifthFormGroup.get('eightCtrl')!.value;

        if (this.clinicHistory.healthTechnologiesResult.deathMedicDiagnostic == null) {
            this.clinicHistory.healthTechnologiesResult.deathMedicDiagnostic = new BODeathMedicDiagnostic();
            this.clinicHistory.healthTechnologiesResult.deathMedicDiagnostic.id = 0;
        }
        this.clinicHistory.healthTechnologiesResult.deathMedicDiagnostic.diseaseCode = this.fifthFormGroup.get('nineCtrl')!.value;
        this.clinicHistory.healthTechnologiesResult.deathMedicDiagnostic.orphanDisease = this.fifthFormGroup.get('tenCtrl')!.value;

        this.clinicHistory.healthTechnologiesResult.medicalAttentionFinalizationDate = this.fifthFormGroup.get('elevenCtrl').value != undefined ? new Date(this.fifthFormGroup.get('elevenCtrl').value) : null;
        this.clinicHistory.healthTechnologiesResult.medicIncapacityType = this.fifthFormGroup.get('thirteenCtrl')!.value;
        this.clinicHistory.healthTechnologiesResult.medicIncapacityDays = this.fifthFormGroup.get('fourteenCtrl')!.value;
        this.clinicHistory.healthTechnologiesResult.medicMaternityLicense = this.fifthFormGroup.get('fiftheenCtrl')!.value;

        this.busy = this._clinicHistoryService.updateClinicHistory(this.clinicHistory, this.stepper.selectedIndex.toString().trim()).subscribe(data => {
            this._clinicHistoryService.getClinicHistory(this.clinicHistory.id).subscribe(data => {
                this.clinicHistory = data;
                if (next) this.stepper.next();
                else this.close();
            })

        });
    }

    //#endregion


    close(): void {
        this.modalSave.emit(null);
        this.modal.hide();
        this.stepper.reset();
        this.firstFormGroup.reset();
        this.secondFormGroup.reset();
        this.thirdFormGroup.reset();
        this.fourFormGroup.reset();
        this.patient = new BOPerson();
        this.patientInformation = new BOPatientInformation();
        this.clinicHistory = new BOClinicHistory();
        this.isSearchPatient = false;
        this.showOnlyObservations = false;
        this.submitted = false;
        this.stepperIndex = 0;
        this.panelOpenState = false;
    }


  closeAndSaveHandle():void{
   //console.log("Entra a closeAndSaveHandle, stepIndex es:",this.stepper.selectedIndex.toString() );
                     //STOP
                    this.updateClinicHistory(false, this.stepper.selectedIndex.toString());
                    // this.isLoading = false;
                    // this.isSaving = false;
                    this._cdr.detectChanges();
}
//#region ObservationModal - - medicalFormula
    closeObservationModalTemp(): void {
        var observation = this.clinicHistory.clinicHistoryObservations.find(x => x.id == this.tempObservation.id);
        this.createOrEditModalObservation.hide();    }

        closeObservationModal(): void {
        var observation = this.clinicHistory.clinicHistoryObservations.find(x => x.id == this.tempObservation.id);
        var index = this.clinicHistory.clinicHistoryObservations.indexOf(observation);
         this.clinicHistory.clinicHistoryObservations[index] = this.tempObservation;
        this.createOrEditModalObservation.hide();
    }

    openObservationModal(): void {
        this.tempObservationId--;
        this.clinicHistory.clinicHistoryObservations.push({ id: this.tempObservationId, observation: null });
        this.tempObservation = this.clinicHistory.clinicHistoryObservations.find(x => x.id == this.tempObservationId);
        this.createOrEditModalObservation.config = { backdrop: "static", keyboard: false };
        this.createOrEditModalObservation.show();
    }

    openMedicalFormulaModal(): void {
        this.tempMedicalFormulaId--;
        var medicalFormula = new BOMedicalFormula();
        medicalFormula.id = this.tempMedicalFormulaId;

        this.createOrEditMedicalFormulaModal.openModal(this.healthTechnologyTimeUnitList, medicalFormula, true);
    }

    viewObservationModal(observationId: number): void {
        this.tempObservation = this.clinicHistory.clinicHistoryObservations.find(x => x.id == observationId);
        this.createOrEditModalObservation.config = { backdrop: "static", keyboard: false };
        this.createOrEditModalObservation.show();
    }

    deleteObservation(observationId: number): void {
        var deleteField = this.clinicHistory.clinicHistoryObservations.find(x => x.id == observationId);
        var index = this.clinicHistory.clinicHistoryObservations.indexOf(deleteField);
        if (index > -1) {
            this.clinicHistory.clinicHistoryObservations.splice(index, 1);
        }
    }

    deleteMedicalFormula(formulaId: number): void {
        var deleteField = this.clinicHistory.medicalFormula.find(x => x.id == formulaId);
        var index = this.clinicHistory.medicalFormula.indexOf(deleteField);
        if (index > -1) {
            this.clinicHistory.medicalFormula.splice(index, 1);
        }
    }
//#endregion ObservationModal - medicalFormula

//#region filters

    protected filterCountries() {
        if (!this.countries) {
            return;
        }
        let search = this.countryFilterCtrl.value;
        if (!search) {
            this.filteredCountries.next(this.countries.slice());
            return;
        } else {
            search = search.toLowerCase();
        }
        // filter the banks
        this.filteredCountries.next(
            this.countries.filter(country => country.name.toLowerCase().indexOf(search) > -1)
        );
    }

    protected filterOrphanDiseases() {
        if (!this.orphanDiseaseList) {
            return;
        }
        let search = this.orphanDiseaseFilterCtrl.value;
        if (!search) {
            this.filteredOrphanDiseases.next(this.orphanDiseaseList.slice());
            return;
        } else {
            this.searchingOrphanDisease = true;
            this._orphanDiseaseService.getAll(search).subscribe(data => {
                this.orphanDiseaseList = data;
                this.filteredOrphanDiseases.next(data);
                this.searchingOrphanDisease = false;
            }, error => {
                this.filteredOrphanDiseases.next(this.orphanDiseaseList.slice());
                this.searchingOrphanDisease = false;
            });
        }
    }

    protected filterOrphanDiseasesRelated() {
        if (!this.orphanDiseaseRelatedList) {
            return;
        }
        let search = this.orphanDiseaseRelatedFilterCtrl.value;
        if (!search) {
            this.filteredOrphanDiseasesRelated.next(this.orphanDiseaseRelatedList.slice());
            return;
        } else {
            this.searchingOrphanDisease = true;
            this._orphanDiseaseService.getAll(search).subscribe(data => {
                this.orphanDiseaseRelatedList = data;
                this.filteredOrphanDiseasesRelated.next(data);
                this.searchingOrphanDisease = false;
            }, error => {
                this.filteredOrphanDiseasesRelated.next(this.orphanDiseaseRelatedList.slice());
                this.searchingOrphanDisease = false;
            });
        }
    }

    protected filterOrphanDiseasesExit() {
        if (!this.orphanDiseaseExitList) {
            return;
        }
        let search = this.orphanDiseaseExitFilterCtrl.value;
        if (!search) {
            this.filteredOrphanDiseasesExit.next(this.orphanDiseaseExitList.slice());
            return;
        } else {
            this.searchingOrphanDisease = true;
            this._orphanDiseaseService.getAll(search).subscribe(data => {
                this.orphanDiseaseExitList = data;
                this.filteredOrphanDiseasesExit.next(data);
                this.searchingOrphanDisease = false;
            }, error => {
                this.filteredOrphanDiseasesExit.next(this.orphanDiseaseExitList.slice());
                this.searchingOrphanDisease = false;
            });
        }
    }

    protected filterOrphanDiseasesComplication() {
        if (!this.orphanDiseaseComplicationList) {
            return;
        }
        let search = this.orphanDiseaseComplicationFilterCtrl.value;
        if (!search) {
            this.filteredOrphanDiseasesComplication.next(this.orphanDiseaseComplicationList.slice());
            return;
        } else {
            this.searchingOrphanDisease = true;
            this._orphanDiseaseService.getAll(search).subscribe(data => {
                this.orphanDiseaseComplicationList = data;
                this.filteredOrphanDiseasesComplication.next(data);
                this.searchingOrphanDisease = false;
            }, error => {
                this.filteredOrphanDiseasesComplication.next(this.orphanDiseaseComplicationList.slice());
                this.searchingOrphanDisease = false;
            });
        }
    }

    protected filterOrphanDiseasesDeath() {
        if (!this.orphanDiseaseDeathList) {
            return;
        }
        let search = this.orphanDiseaseDeathFilterCtrl.value;
        if (!search) {
            this.filteredOrphanDiseasesDeath.next(this.orphanDiseaseDeathList.slice());
            return;
        } else {
            this.searchingOrphanDisease = true;
            this._orphanDiseaseService.getAll(search).subscribe(data => {
                this.orphanDiseaseDeathList = data;
                this.filteredOrphanDiseasesDeath.next(data);
                this.searchingOrphanDisease = false;
            }, error => {
                this.filteredOrphanDiseasesDeath.next(this.orphanDiseaseDeathList.slice());
                this.searchingOrphanDisease = false;
            });
        }
    }

    protected filterDiseases() {
        if (!this.diseaseList) {
            return;
        }
        let search = this.diseaseFilterCtrl.value;
        if (!search) {
            this.filteredDiseases.next(this.diseaseList.slice());
            return;
        } else {
            this.searchingDisease = true;
            this._diseaseService.getAll(search).subscribe(data => {
                this.diseaseList = data;
                this.filteredDiseases.next(data);
                this.searchingDisease = false;
            }, error => {
                this.filteredDiseases.next(this.diseaseList.slice());
                this.searchingDisease = false;
            });
        }
    }

    protected filterDiseasesRelated() {
        if (!this.diseaseListRelated) {
            return;
        }
        let search = this.diseaseRelatedFilterCtrl.value;
        if (!search) {
            this.filteredDiseasesRelated.next(this.diseaseListRelated.slice());
            return;
        } else {
            this.searchingDisease = true;
            this._diseaseService.getAll(search).subscribe(data => {
                this.diseaseListRelated = data;
                this.filteredDiseasesRelated.next(data);
                this.searchingDisease = false;
            }, error => {
                this.filteredDiseasesRelated.next(this.diseaseListRelated.slice());
                this.searchingDisease = false;
            });
        }
    }

    protected filterDiseasesExit() {
        if (!this.diseaseListExit) {
            return;
        }
        let search = this.diseaseExitFilterCtrl.value;
        if (!search) {
            this.filteredDiseasesExit.next(this.diseaseListExit.slice());
            return;
        } else {
            this.searchingDisease = true;
            this._diseaseService.getAll(search).subscribe(data => {
                this.diseaseListExit = data;
                this.filteredDiseasesExit.next(data);
                this.searchingDisease = false;
            }, error => {
                this.filteredDiseasesExit.next(this.diseaseListExit.slice());
                this.searchingDisease = false;
            });
        }
    }

    protected filterDiseasesComplication() {
        if (!this.diseaseListComplication) {
            return;
        }
        let search = this.diseaseComplicationFilterCtrl.value;
        if (!search) {
            this.filteredDiseasesComplication.next(this.diseaseListComplication.slice());
            return;
        } else {
            this.searchingDisease = true;
            this._diseaseService.getAll(search).subscribe(data => {
                this.diseaseListComplication = data;
                this.filteredDiseasesComplication.next(data);
                this.searchingDisease = false;
            }, error => {
                this.filteredDiseasesComplication.next(this.diseaseListComplication.slice());
                this.searchingDisease = false;
            });
        }
    }

    protected filterDiseasesDeath() {
        if (!this.diseaseListDeath) {
            return;
        }
        let search = this.diseaseDeathFilterCtrl.value;
        if (!search) {
            this.filteredDiseasesDeath.next(this.diseaseListDeath.slice());
            return;
        } else {
            this.searchingDisease = true;
            this._diseaseService.getAll(search).subscribe(data => {
                this.diseaseListDeath = data;
                this.filteredDiseasesDeath.next(data);
                this.searchingDisease = false;
            }, error => {
                this.filteredDiseasesDeath.next(this.diseaseListDeath.slice());
                this.searchingDisease = false;
            });
        }
    }

    protected filterEps() {
        if (!this.epsList) {
            return;
        }
        let search = this.epsFilterCtrl.value;
        if (!search) {
            this.filteredEps.next(this.epsList.slice());
            return;
        } else {
            search = search.toLowerCase();
        }
        this.filteredEps.next(
            this.epsList.filter(eps => eps.name.toLowerCase().indexOf(search) > -1)
        );
    }

    protected filterOcupation() {
        if (!this.personOcupationList) {
            return;
        }
        let search = this.ocupationFilterCtrl.value;
        if (!search) {
            this.filteredOcupation.next(this.personOcupationList.slice());
            return;
        } else {
            search = search.toLowerCase();
        }
        this.filteredOcupation.next(
            this.personOcupationList.filter(ocupation => ocupation.description.toLowerCase().indexOf(search) > -1)
        );
    }

    //#endregion filters

//#region onOptionSelect
    // onOptionStateSelected(state: any) {
    //     if (state != null) {
    //         this.busy = this._cityService.getCitiesbyState(state).subscribe(data => { this.cities = data });
    //     }
    // }
    onOptionStateSelected(state: any)
    {
      console.log("state es :", state, " and type of state is:", typeof state);
        if (state != null) {
            this.busy = this._cityService.getCitiesbyState(state).subscribe({
              next:(data) =>
              {
                if (state=='76')
                {
                  this.secondFormGroup.patchValue({
                    elevenCtrl:"76001"
                  })
                }
                this.cities = data;

              },
              error:(err)=>{

              }

            });
        }
    }
    onOptionAreaSelected(area: any)
    {
     if (area != null)
      {
          this.serviceGroupsListShort=[];
          this.profesionalsListShort =[];
          this.serviceGroupsListShort=Utilities.getGroupsByAreaId(area, this.serviceGroupsList);
          this.profesionalsListShort =Utilities.getProfessionalssByAreaId(area, this.profesionals);
      }
      else{
        this.toastr.error('Error','No se ha seleccionado un área');
      }
  }


  onOptionGroupSelected(groupId: any)
  {
    if (groupId != null)
      {
          this.serviceTypeListShort=[];
          this.serviceTypeListShort=Utilities.getServicesByGroupId(groupId, this.serviceTypeList);
      }
      else{
        this.toastr.error('Error','No se ha seleccionado un grupo');
      }
  }

  onOptionServiceTypeSelected(service: any)
  {
    let converted= parseInt(service);

    if(converted ==37)
    {
      this.toastr.show('servicio seleccionado es', `seleccionó ${converted}`);
      this.isControl=true;

     // this.thirdFormGroup.get('fourteenCtrl')?.disable();
      this.thirdFormGroup.patchValue({
        fourteenCtrl: 0,
      });
    }
    else{
      this.isControl=false;
      this.thirdFormGroup.get('fourteenCtrl')?.enable();
    }

  }

  //#endregion onOptionSelect


    processMedicalFormula(medicalFormulaInput) {
          if (medicalFormulaInput != null)
          {
              if (medicalFormulaInput.id == 0)
              {
                  this.tempMedicalFormulaId--;
                  medicalFormulaInput.id = this.tempMedicalFormulaId;
              }
              this.clinicHistory.medicalFormula.push(medicalFormulaInput);
          }
    }
    //#region print

  seePDF()
  {
      const documentDefinition = this.getDocumentDefinition();
      pdfMake.createPdf(documentDefinition).open();

  }


dataInutil2()
{

}


dataInutil()
{

}
  generatePDF()
  {
      const documentDefinition = this.getDocumentDefinition();
      pdfMake.createPdf(documentDefinition).open();
  }

  getDocumentDefinition()
  {
      let dateTemp=this.datePipe.transform(Date.now(), 'dd /MM/YYYY');
       let hourTemp = this.datePipe.transform(this.clinicHistory.consultationDate, 'HH:mm');

      const logoshort='data:image/png;base64,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';

        return {
          pageSize: 'A4',
          pageMargins: [10, 120, 20, 30],

          header:[
                {
                  columns:
                  [
                    {
                      margin: [35, 0, 0, 0],
                      image: logoshort +',', alignment: 'center', width: 200, height:74,
                    },
                    //blank space
                    {
                      fontSize:10,
                      text:
                      [
                      ],
                      margin: [15, 25, 0, 0],
                      width: '30%'
                    },
                      // Dirección
                    {

                      fontSize:10,
                      text:
                      [
                        {text:'Calle 5 Oeste Nª D-50-03\n' },
                        {text:'B/El Cortijo -Cali- Valle-Colombia\n' },
                        {text:'Telf: 316 4071420\n' },
                      ],
                      margin: [15, 25, 0, 0],
                      width: '30%'

                    },
                  ]
                },

                {
                  fontSize: 10,
                  columns:
                  [
                      {
                          text: 'NIT '+ this.company.nit,
                          margin: [35, 0, 0, 0],
                          width: '50%'
                      }
                  ]
                },
                {
                  fontSize: 10,
                  columns: [
                      {
                          text: this.company.email,
                          width: '40%',
                          margin: [35, 0, 0,0],
                          alignment: 'left',


                      },
                      {
                        text:'',
                        width: '5%',
                        margin: [15, 0, 0, 5],

                      },
                      {
                        text: 'www.servivitalcentromedico.com.co',
                        margin: [0, 0, -50, 5],
                          alignment: 'right',
                        width: '40%'
                    },


                  ]
              },

          ],



          content:
          [
            {
              margin: [20, 0, 20, 40],
              stack:
              [

          //#region title: Historia Odontológica
                {
                  columns:
                  [
                    {
                      fontSize:10,
                      text:
                      [

                      ],
                      margin: [15, 10, 15, 0],
                      width: '20%'
                    },
                    {
                      fontSize:18,
                      text:
                      [
                        {text:'HISTORIA ODONTOLÓGICA' },

                      ],
                      margin: [25, 10, 15, 0],
                      alignment: 'center',
                      width: '60%'
                    },

                    {

                      fontSize:10,
                      text:
                      [

                      ],
                      margin: [15, 10, 15, 0],
                      width: '20%'

                    },

                  ]
                },
////
                {
                  columns:
                  [
                    {
                      fontSize:10,
                      text:
                      [

                      ],
                      margin: [15, 10, 15, 0],
                      width: '5%'
                    },
                    {
                      fontSize:10,
                      text:
                      [
                        {text:'FECHA:',bold:true, }, dateTemp, {text:' HORA:',bold:true}, hourTemp,
                       // {text:' -  HISTORIA CLÍNICA No.:',bold:true, }, this.clinicHistory.id

                      ],
                      margin: [25, 10, 15, 0],
                      alignment: 'center',
                      width: '90%'
                    },

                    {

                      fontSize:10,
                      text:
                      [

                      ],
                      margin: [15, 10, 15, 0],
                      width: '5%'

                    },

                  ]
                },



          //#endregion title: Historia Odontológica

                //space
                { text: ' ', margin: [0, 0, 0, 4] },

                { //Obj 1 Datos Fecha -Profesional - No. HC
                      columns:
                      [

                        {
                          fontSize: 10,
                          table:
                          {
                            widths: [80,80,80,80,80,80],
                            body:
                            [
                                [ //row 1: Profesional-No. HC

                                  //PROFESIONAL
                                  {

                                    colSpan:3,
                                    text:
                                        [
                                            {text:'PROFESIONAL:\n', bold:true },
                                            {text: this.clinicHistory.profesional.firstName    +' '
                                                + this.clinicHistory.profesional.secondName   + ' '
                                                + this.clinicHistory.profesional.firtsSurName + ' '
                                                + this.clinicHistory.profesional.secondSurName

                                            },

                                        ]
                                  },
                                  {},{},
                                  //Número HC
                                  {
                                    colSpan:3,
                                    fontSize: 12,
                                    text:
                                        [
                                          {text:'HC No.\n', bold:true },
                                          {text: this.clinicHistory.id}

                                        ]
                                  },
                                  {},{},


                                ], //end row1

                            ],
                          }
                        }, //End columns

                      ]

                }, //End obj1

                { text: ' ', margin: [0, 0, 0, 4] },


                { //obj2 DATOS PERSONALES -inicia la tabla
                      columns:
                      [
                        //First Column
                        {
                          fontSize: 10,
                          table:
                          {
                          // widths: [80,80,80,80,80,80],
                            widths: [80,80,80,80,80,80],

                            body:
                            [

                                [ //row 0 DATOS PERSONALES

                                {
                                  colSpan: 6,
                                  fillColor: '#FFF',
                                  color: '#000',
                                  text: [
                                    { text: 'A. DATOS PERSONALES', bold: true }
                                  ]
                                },
                                {},{},{},{},{}
                                ], //end row1

                                [ //row 1 Nombres-PrimerApellido-SegundoApellido-
                                  //Nombres
                                  {
                                    colSpan:2,

                                    text:[
                                            {text:'NOMBRE:\n', bold:true},
                                            {text: this.patient.firstName+" " +this.patient.secondName}
                                        ]
                                  },
                                  {},
                                  //Primer apellido
                                  {

                                    colSpan:2,
                                    text:
                                        [
                                            {text:'PRIMER APELLIDO:\n', bold:true},
                                            {text: this.patient.firtsSurName}

                                        ]
                                  },
                                  {},
                                  //Segundo apellido
                                  {
                                    colSpan:2,

                                    text:
                                        [
                                          {text:'SEGUNDO APELLIDO:\n', bold:true },
                                          {text: this.patient.secondSurName}

                                        ]
                                  },
                                  {},


                                ], //end row1

                                [ //row 2 FecHaNacimiento-Sexo-FechaIngreso
                                  //FECHA DE NACIMIENTO
                                  {
                                    //
                                    colSpan:2,
                                      text:[
                                        {text:'FECHA NACIMIENTO:\n', bold:true},
                                        {text: Utilities.convertDateToString(this.patient.birthDate)}
                                      ]

                                  },
                                  {},
                                  //SEXO
                                  {
                                    colSpan:2,
                                      text:[
                                        {text:'SEXO:\n', bold:true},
                                        {text:this.genderIdentityList.find(x => x.code == this.patientInformation.genderIdentity).name, bold:true},{text:'\n'},
                                      ]
                                  },
                                  {},
                                  //FECHA INGRESO
                                  {
                                    colSpan:2,
                                      text:[
                                        {text:'FECHA INGRESO:\n', bold:true},
                                        {text: Utilities.convertDateToString(this.clinicHistory.consultationDate)}
                                      ]
                                  },
                                  {},

                                ], //end row2

                                [ //row 3 RH-Dirección-Teléfono
                                  //RH
                                  {
                                    //
                                      text:[
                                        {text:'RH:\n', bold:true},
                                      // {text: this.patient.bloodType}
                                        {text:this.bloodTypeList.find(x => x.code == this.patient.bloodType).name, bold:true},{text:'\n'},

                                      ]

                                  },
                                  //DIRECCIÓN
                                  {
                                    colSpan:3,
                                      text:[
                                        {text:'DIRECCIÓN:\n', bold:true},
                                        {text: this.patient.address}
                                      ]
                                  }, {},{},
                                  //TELÉFONO
                                  {
                                    colSpan:2,
                                      text:[
                                        {text:'No. TELÉFONO:\n', bold:true},
                                        {text: this.patient.cellPhoneNumber}
                                      ]
                                  },
                                  {},

                                ], //end row3

                                [ //row 4 DocumentoID-Email
                                  //DOCUMENTO IDENTIDAD
                                  {
                                    colSpan:3,
                                      text:[
                                        {text:'DOCUMENTO IDENTIDAD:', bold:true},
                                        {text:this.idTypeList.find(x => x.code == this.patient.idType).code, bold:true},{text:'\n'},
                                        {text: 'No:'},{text: this.patient.personId}
                                      ]

                                  },{},{},
                                  //EMAIL
                                  {
                                    colSpan:3,
                                      text:[
                                        {text:'EMAIL:\n', bold:true},
                                        {text: this.patient.email}
                                      ]
                                  },{},{},

                                ], //end row4

                                [ //row 5 EPS

                                    {
                                      //
                                      colSpan:6,
                                        text:[
                                          {text:'EPS:\n', bold:true},
                                          //{text: this.patientInformation.epsId}
                                        {text:this.epsList.find(x => x.id == this.patientInformation.epsId).name, bold:true},{text:'\n'},

                                        ]

                                    },{},{},{},{},{},
                                ],

                                [ //row TITLE B.ANTECEDENTES MÉDICOS

                                  // B.ANTECEDENTES MÉDICOS
                                {
                                  colSpan: 6,
                                  fillColor: '#FFF',
                                  color: '#000',
                                  text: [
                                    { text: 'B.ANTECEDENTES MÉDICOS', bold: true }
                                  ]
                                },
                                {},{},{},{},{},
                                ],


                                  ...this.odontologyPatientBackgroundsList.map(sub => {
                                    const backgroundType = this.odontologyBackgroundTypesList?.find(x => x.code === sub.itemType);

                                    return [
                                      {
                                        colSpan: 3,
                                        text: backgroundType?.name || 'Tipo no especificado',
                                        bold: true
                                      },
                                      {}, {},
                                      {
                                        colSpan: 3,
                                        text: sub.details || ''
                                      },
                                      {}, {}
                                    ];
                                  }),
  ////////////
                                [ //row TITLE C. EXAMEN ODONTOLOGICO

                                  // C. EXAMEN ODONTOLOGICO
                                {
                                  colSpan: 6,
                                  fillColor: '#FFF',
                                  color: '#000',
                                  text: [
                                    { text: 'C.EXAMEN ODONTOLÓGICO', bold: true }
                                  ]
                                },
                                {},{},{},{},{},
                                ], //end row


                                  ...this.odontologyTissuesPatientList.map(sub => {
                                    const backgroundType = this.odontologyTissueTypeList?.find(x => x.code === sub.itemType);

                                    return [
                                      {
                                        colSpan: 3,
                                        text: backgroundType?.name || 'Tipo no especificado',
                                        bold: true
                                      },
                                      {}, {},
                                      {
                                        colSpan: 3,
                                        text: sub.details || ''
                                      },
                                      {}, {}
                                    ];
                                  }),

                                [ //row TITLE D. EXAMEN RADIOLÓGICO

                                  // D. EXAMEN RADIOLÓGICO
                                {
                                  colSpan: 6,
                                  fillColor: '#FFF',
                                  color: '#000',
                                  text: [
                                    { text: 'D.EXAMEN RADIOLÓGICO', bold: true }
                                  ]
                                },
                                {},{},{},{},{},
                                ],


                                  ...this.odontologyRadiologicExamPatientList.map(sub => {
                                    const backgroundType = this.odontologyRadiologicExamTypeList?.find(x => x.code === sub.itemType);

                                    return [
                                      {
                                        colSpan: 3,
                                        text: backgroundType?.name || 'Tipo no especificado',
                                        bold: true
                                      },
                                      {}, {},
                                      {
                                        colSpan: 3,
                                        text: sub.details || ''
                                      },
                                      {}, {}
                                    ];
                                  }),

                                [ //row TITLE E. EXAMEN DENTAL INICIAL

                                // E. EXAMEN DENTAL INICIAL

                                {
                                  colSpan: 6,
                                  fillColor: '#FFF',
                                  color: '#000',
                                  text: [
                                    { text: 'E.EXAMEN DENTAL INICIAL', bold: true }
                                  ]
                                },
                                {},{},{},{},{},
                                ], //end row

                                ...this.dentalExamRows,

                              [ //row TITLE F. PROCEDIMIENTOS

                                  // F. PROCEDIMIENTOS
                                {
                                  colSpan: 6,
                                  fillColor: '#FFF',
                                  color: '#000',
                                  text: [
                                    { text: 'F. EVOLUCIONES', bold: true }
                                  ]
                                },
                                {},{},{},{},{},
                                ], //end row


                                  ...this.clinicHistory.clinicHistoryObservations.map(sub => {

                                    return [
                                      {
                                        text:Utilities.convertDateToString(sub.creationDate),
                                        bold: true
                                      },
                                      {
                                        colSpan: 5,
                                        text: sub.observation || ''
                                      },
                                      {}, {},{},{},
                                    ];
                                  }),
  //SALTO DE PÁGINA
  // [
  //   {
  //   colSpan: 6,
  //   text: '',
  //   pageBreak: 'after'
  //   },
  //   {}, {}, {}, {}, {}
  // ],


  //                               [ //row TITLE F. COTIZACIÓN(ES)

  //                               // F. COTIZACIÓN(ES)

  //                               {
  //                                 colSpan: 6,
  //                                 fillColor: '#FFF',
  //                                 color: '#000',
  //                                 text: [
  //                                   { text: 'G.COTIZACION(ES)', bold: true }
  //                                 ]
  //                               },
  //                               {},{},{},{},{},
  //                               ], //end row


  // // Después del título F. COTIZACIÓN(ES)
  // ...this.toothQuoteList.flatMap
  // (
  //   (quote, quoteIndex) =>
  //      [

  //       ...(quoteIndex > 0 ? [[
  //     { colSpan: 6, text: '', margin: [0, 10, 0, 0] },
  //     {}, {}, {}, {}, {}
  //   ]] : []),

  //   // Encabezado de cotización
  //   [
  //     {
  //       colSpan: 6,
  //       fillColor: '#F0F4FA',
  //       margin: [0, 5, 0, 5],
  //       text: `📋 COTIZACIÓN #${quote.id || ''}   |   Fecha: ${quote.date ? Utilities.convertDateToString(quote.date) : 'N/A'}   |   Historia Clínica: ${quote.clinicHistoryId || 'N/A'}`


  //     },
  //     {}, {}, {}, {}, {}
  //   ],

  //   // Encabezados de tabla
  //   [
  //     { text: 'DIENTE', bold: true, alignment: 'center', fillColor: '#E8EAF6' },
  //     { text: 'TRATAMIENTO', bold: true, alignment: 'center', fillColor: '#E8EAF6', colSpan: 3 }, {}, {},
  //     { text: 'FIN', bold: true, alignment: 'center', fillColor: '#E8EAF6' },
  //     { text: 'VALOR', bold: true, alignment: 'center', fillColor: '#E8EAF6' }
  //   ],

  //   // Detalles
  //   ...(quote.toothQuoteDetails?.length
  //     ? quote.toothQuoteDetails.flatMap(detail => [[
  //         { text: detail.toothTypeId || '—', alignment: 'center' },
  //         { text: detail.observations || '—', alignment: 'left', colSpan: 3 }, {}, {},
  //         { text: detail.fixed ? '✓' : '✗', alignment: 'center' },
  //         { text: `$${(detail.price || 0).toFixed(2)}`, alignment: 'right' }
  //       ]])
  //     : [[
  //         { text: 'Sin detalles', alignment: 'center', colSpan: 6, italics: true },
  //         {}, {}, {}, {}, {}
  //       ]]
  //   ),

  //   // Total
  //   [
  //     { text: '', border: [true, true, true, true] },
  //     { text: 'TOTAL', bold: true, alignment: 'right', colSpan: 3 }, {}, {},
  //     { text: '', border: [true, true, true, true] },
  //     {
  //       text: `$${this.obtenerTotalCotizacion(quote).toFixed(2)}`,
  //       bold: true,
  //       alignment: 'right',
  //       fillColor: '#F5F5F5'
  //     }
  //   ]
  // ])


                            ], //table end body
                          }
                        }, //Obj2.columns.First Column End columns

                      ] //obj 2 end Columns

                }, //End obj2

              //Separador
            // { text: ' ', margin: [0, 10, 0, 10] },

          ] }
          ],

          styles: {
            header: {
              fontSize: 18,
              bold: true,
              margin: [0, 0, 0, 10]
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5]
            },
            tableExample: {
              margin: [0, 5, 0, 15]
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black'
            }
          },
          defaultStyle: {
          }
        }




  }




  getGeneralDiagnosticReport() {
      if (this.clinicHistory.healthTechnologies != null) {
          return [
              {
                  fontSize: 14,
                  bold: true,
                  margin: [0, 10, 0, 10],
                  alignment: 'center',
                  pageBreak: "before",
                  text: 'Diagnostico General',
              },
              {
                  columns: [
                      {
                          fontSize: 10,
                          text: [{ text: 'Antecedentes Patologicos: ', bold: true }, this.clinicHistory.pathologicalRecord],
                          margin: [0, 5, 0, 0],
                          width: '100%'
                      }
                  ]
              },
              {
                  columns: [
                      {
                          fontSize: 10,
                          text: [{ text: 'Motivo de Consulta: ', bold: true }, this.clinicHistory.consultationMotive],
                          margin: [0, 5, 0, 0],
                          width: '100%'
                      }
                  ]
              },
              {
                  columns: [
                      {
                          fontSize: 10,
                          text: [{ text: 'Anamnesis: ', bold: true }, this.clinicHistory.anamnesis],
                          margin: [0, 10, 0, 0],
                          width: '100%'
                      }
                  ]
              },
              {
                  columns: [
                      {
                          fontSize: 10,
                          text: [{ text: 'Impresión Diagnostica: ', bold: true }, this.clinicHistory.diagnosticImpression],
                          margin: [0, 10, 0, 0],
                          width: '100%'
                      }
                  ]
              },
              {
                  columns: [
                      {
                          fontSize: 10,
                          text: [{ text: 'Contol de Laboratorio: ', bold: true }, this.clinicHistory.laboratoryControl],
                          margin: [0, 10, 0, 0],
                          width: '100%'
                      }
                  ]
              },
              {
                  columns: [
                      {
                          fontSize: 10,
                          text: [{ text: 'Plan de Tratamiento: ', bold: true }, this.clinicHistory.treatmentPlan],
                          margin: [0, 10, 0, 0],
                          width: '100%'
                      }
                  ]
              },
              {
                  fontSize: 12,
                  bold: true,
                  margin: [0, 10, 0, 0],
                  text: 'Examen Fisico',
              },
              {
                  canvas: [
                      { type: 'line', x1: 0, y1: 0, x2: 595 - 300, y2: 0, lineWidth: 0.5 }
                  ]

              },
              {
                  columns: [
                      {
                          fontSize: 10,
                          text: [{ text: 'Presion Arterial: ', bold: true }, this.clinicHistory.arterialPressure],
                          margin: [0, 5, 0, 0],
                          width: '50%'
                      },
                      {
                          fontSize: 10,
                          text: [{ text: 'Temperatura: ', bold: true }, this.clinicHistory.temperature],
                          margin: [0, 5, 0, 0],
                          width: '50%'
                      }
                  ]
              },
              {
                  columns: [
                      {
                          fontSize: 10,
                          text: [{ text: 'Pulso: ', bold: true }, this.clinicHistory.pulse],
                          margin: [0, 5, 0, 0],
                          width: '50%'
                      },
                      {
                          fontSize: 10,
                          text: [{ text: 'Peso: ', bold: true }, this.clinicHistory.weight],
                          margin: [0, 5, 0, 0],
                          width: '50%'
                      }
                  ]
              },
              {
                  columns: [
                      {
                          fontSize: 10,
                          text: [{ text: 'Talla: ', bold: true }, this.clinicHistory.size],
                          margin: [0, 5, 0, 0],
                          width: '50%'
                      },
                      {
                          fontSize: 10,
                          text: [{ text: 'Respiración: ', bold: true }, this.clinicHistory.breathing],
                          margin: [0, 5, 0, 0],
                          width: '50%'
                      }
                  ]
              },
              {
                  fontSize: 12,
                  bold: true,
                  margin: [0, 10, 0, 0],
                  text: 'Organos',
              },
              {
                  canvas: [
                      { type: 'line', x1: 0, y1: 0, x2: 595 - 300, y2: 0, lineWidth: 0.5 }
                  ]

              },
              {
                  columns: [
                      {
                          fontSize: 10,
                          text: [{ text: 'Cabeza: ', bold: true }, this.clinicHistory.head],
                          margin: [0, 5, 0, 0],
                          width: '50%'
                      },
                      {
                          fontSize: 10,
                          text: [{ text: 'Cuello: ', bold: true }, this.clinicHistory.neck],
                          margin: [0, 5, 0, 0],
                          width: '50%'
                      }
                  ]
              },
              {
                  columns: [
                      {
                          fontSize: 10,
                          text: [{ text: 'Torax: ', bold: true }, this.clinicHistory.chest],
                          margin: [0, 5, 0, 0],
                          width: '50%'
                      },
                      {
                          fontSize: 10,
                          text: [{ text: 'Abdomen: ', bold: true }, this.clinicHistory.belly],
                          margin: [0, 5, 0, 0],
                          width: '50%'
                      }
                  ]
              },
              {
                  columns: [
                      {
                          fontSize: 10,
                          text: [{ text: 'Pelvis: ', bold: true }, this.clinicHistory.pelvis],
                          margin: [0, 5, 0, 0],
                          width: '50%'
                      },
                      {
                          fontSize: 10,
                          text: [{ text: 'Extremidades: ', bold: true }, this.clinicHistory.extremities],
                          margin: [0, 5, 0, 0],
                          width: '50%'
                      }
                  ]
              },
              {
                  columns: [
                      {
                          fontSize: 10,
                          text: [{ text: 'Piel: ', bold: true }, this.clinicHistory.skin],
                          margin: [0, 5, 0, 0],
                          width: '50%'
                      },
                      {
                          fontSize: 10,
                          text: [{ text: 'Sistema Nervioso Central: ', bold: true }, this.clinicHistory.centralNervousSystem],
                          margin: [0, 5, 0, 0],
                          width: '50%'
                      }
                  ]
              },
          ]
      }
      else return "";
  }

    getHealthTecnologiesForReport() {
        if (this.clinicHistory.healthTechnologies != null) {
            return [
                {
                    fontSize: 12,
                    bold: true,
                    margin: [0, 10, 0, 0],
                    text: 'Tecnologias de la Salud',
                },
                {
                    canvas: [
                        { type: 'line', x1: 0, y1: 0, x2: 595 - 300, y2: 0, lineWidth: 0.5 }
                    ]

                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Tecnologia de la Salud: ', bold: true }, this.healthTechnologyList.find(x => x.code == this.clinicHistory.healthTechnologies.healthTechnology)?.name],
                            margin: [0, 5, 0, 0],
                            width: '100%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Finalidad de la Tecnologia de la Salud: ', bold: true }, this.healthTechnologyFinalityList.find(x => x.code == this.clinicHistory.healthTechnologies.healthTecnologyFinality)?.name],
                            margin: [0, 5, 0, 0],
                            width: '100%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Fecha de Prescripción: ', bold: true }, this.datePipe.transform(this.clinicHistory.healthTechnologies.prescriptionDate, 'dd/MM/yyyy HH:mm')],
                            margin: [0, 10, 0, 0],
                            width: '100%'
                        }
                    ]
                },
            ]
        }
        else return "";
    }

    getHealthTecnologiesResultForReport() {
        if (this.clinicHistory.healthTechnologiesResult != null) {
            return [
                {
                    fontSize: 12,
                    bold: true,
                    margin: [0, 10, 0, 0],
                    text: 'Resultado Tecnologias de la Salud',
                },
                {
                    canvas: [
                        { type: 'line', x1: 0, y1: 0, x2: 595 - 300, y2: 0, lineWidth: 0.5 }
                    ]

                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Diagnostico Egreso: ', bold: true }, this.diseaseListExit.find(x => x.code == this.clinicHistory.healthTechnologiesResult.principalMedicDiagnostic?.diseaseCode)?.name],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Enfermedad Huerfana: ', bold: true }, this.orphanDiseaseExitList.find(x => x.code == this.clinicHistory.healthTechnologiesResult.principalMedicDiagnostic?.orphanDisease)?.name],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Diagnostico Relacionado: ', bold: true }, this.diseaseListRelated.find(x => x.code == this.clinicHistory.healthTechnologiesResult.relatedMedicDiagnostic?.diseaseCode)?.name],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Enfermedad Huerfana: ', bold: true }, this.orphanDiseaseRelatedList.find(x => x.code == this.clinicHistory.healthTechnologiesResult.relatedMedicDiagnostic?.orphanDisease)?.name],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Diagnostico Complicación: ', bold: true }, this.diseaseListComplication.find(x => x.code == this.clinicHistory.healthTechnologiesResult.complicationMedicDiagnostic?.diseaseCode)?.name],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Enfermedad Huerfana: ', bold: true }, this.orphanDiseaseComplicationList.find(x => x.code == this.clinicHistory.healthTechnologiesResult.complicationMedicDiagnostic?.orphanDisease)?.name],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Condicion de Egreso: ', bold: true }, this.patientConditionList.find(x => x.code == this.clinicHistory.healthTechnologiesResult.patientCondition)?.name],
                            margin: [0, 5, 0, 0],
                            width: '100%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Diagnostico Muerte: ', bold: true }, this.diseaseListDeath.find(x => x.code == this.clinicHistory.healthTechnologiesResult.deathMedicDiagnostic?.diseaseCode)?.name],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Enfermedad Huerfana: ', bold: true }, this.orphanDiseaseDeathList.find(x => x.code == this.clinicHistory.healthTechnologiesResult.deathMedicDiagnostic?.orphanDisease)?.name],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Fecha de Egreso: ', bold: true }, this.datePipe.transform(this.clinicHistory.healthTechnologiesResult.medicalAttentionFinalizationDate, 'dd/MM/yyyy HH:mm')],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Tipo de Incapacidad: ', bold: true }, ""],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Dias de Incapacidad: ', bold: true }, this.clinicHistory.healthTechnologiesResult.medicIncapacityDays.toString()],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Dias de LMA: ', bold: true }, this.clinicHistory.healthTechnologiesResult.medicMaternityLicense.toString()],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        }
                    ]
                },
            ]
        }
        else return "";
    }

    getMedicalFormulaForReport() {
        if (this.clinicHistory.medicalFormula.length > 0) {
            /*this.clinicHistory.medicalFormula.forEach(x => {
                x.doseDescription = x.dose.toString() + " " + x.doseType;
                x.doseFrecuencyQuantityDescription = x.doseFrecuencyQuantity.toString() + " " + this.healthTechnologyTimeUnitList.find(h => h.code == x.doseFrecuency).name;
                x.doseDurationDescription = x.doseDurationQuantity.toString() + " " + this.healthTechnologyTimeUnitList.find(h => h.code == x.doseDuration).name;
            });*/
            return [
                {
                    fontSize: 14,
                    bold: true,
                    margin: [0, 10, 0, 4],
                    alignment: 'center',
                    pageBreak: "before",
                    text: 'FÓRMULA MÉDICA',
                },
                {
                    columns: [
                        {
                            fontSize: 12,
                            text: [{ text: 'Fecha: ', bold: true }, this.datePipe.transform(this.clinicHistory.consultationDate, 'dd/MM/yyyy')],
                            margin: [0, 4, 0, 10],
                            alignment: 'center',
                            width: '100%'
                        },
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Información del Paciente', bold: true }, ""],
                            margin: [0, 5, 0, 0],
                            width: '55%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Profesional de la Salud', bold: true }, ""],
                            margin: [0, 5, 0, 0],
                            width: '45%'
                        }
                    ]
                },
                {
                    canvas: [
                        { type: 'line', x1: 10, y1: 0, x2: 595 - 10, y2: 0, lineWidth: 0.5 }
                    ]

                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Nombre: ', bold: true }, this.patient.firstName + " " + this.patient.secondName + " " + this.patient.firtsSurName + " " + this.patient.secondSurName],
                            margin: [0, 5, 0, 0],
                            width: '55%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Nombre: ', bold: true }, this.profesionals.find(x=> x.id == this.profesionalSelected)?.firstName + " " + this.profesionals.find(x=> x.id == this.profesionalSelected)?.secondName + " " + this.profesionals.find(x=> x.id == this.profesionalSelected)?.firtsSurName + " " + this.profesionals.find(x=> x.id == this.profesionalSelected)?.secondSurName],
                            margin: [0, 5, 0, 0],
                            width: '45%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Tipo de Documento: ', bold: true }, this.idTypeList.find(x => x.code == this.patient.idType).name],
                            margin: [0, 5, 0, 0],
                            width: '55%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Numero de Registro: ', bold: true }, this.profesionals.find(x=> x.id == this.profesionalSelected)?.registerNumber],
                            margin: [0, 5, 0, 0],
                            width: '45%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'No.: ', bold: true }, this.patient.personId],
                            margin: [0, 5, 0, 0],
                            width: '55%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Rethus: ', bold: true }, this.profesionals.find(x=> x.id == this.profesionalSelected)?.rethus],
                            margin: [0, 5, 0, 0],
                            width: '45%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Fecha de Nacimiento: ', bold: true }, this.datePipe.transform(this.patient.birthDate, 'dd/MM/yyyy')],
                            margin: [0, 5, 0, 10],
                            width: '70%'
                        }
                    ]
                },
                {
                    table: {
                        widths: ['20%', '15%', '20%', '45%'],
                        body: [
                            [{
                                text: 'Medicamento',
                                style: 'tableHeader'
                            },
                            {
                                text: 'Presentación',
                                style: 'tableHeader'
                            },
                            {
                                text: 'Concentración',
                                style: 'tableHeader'
                            },
                            {
                                text: 'Descripción',
                                style: 'tableHeader'
                            }
                            ],
                            ...this.clinicHistory.medicalFormula.map(ed => {
                            return [ed.medicationName, ed.presentation, ed.concentration, ed.doseDescription + " " + ed.doseFrecuency  + ", " + ed.indications+". Total:" + ed.doseDuration];
                            })
                        ]
                    }
                }
            ]
        }
        else return "";
    }

    getObservationsForReport() {
        if (this.clinicHistory.clinicHistoryObservations.length > 0) {
            return [
                {
                    fontSize: 14,
                    bold: true,
                    margin: [0, 10, 0, 10],
                    alignment: 'center',
                    pageBreak: "before",
                    text: 'Observaciones',
                },
                {
                    table: {
                        widths: ['75%', '25%'],
                        body: [
                            [{
                                text: 'Observación',
                                style: 'tableHeader'
                            },
                            {
                                text: 'Fecha',
                                style: 'tableHeader'
                            },
                            ],
                            ...this.clinicHistory.clinicHistoryObservations.map(ed => {
                                return [ed.observation, this.datePipe.transform(ed.creationDate, 'dd/MM/yyyy HH:mm')];
                            })
                        ]
                    }
                }
            ]
        }
        else return "";
    }

    //#endregion print


    ngOnDestroy(): void {
        this.busy?.unsubscribe();
    }

    formValid(): boolean {
        switch (this.stepper.selectedIndex) {
            case 0:
                return this.firstFormGroup.valid;
            case 1:
                return this.secondFormGroup.valid;
            case 2:
                return this.thirdFormGroup.valid;
            case 3:
                return this.fourFormGroup.valid;
            case 4:
              return this.odontologyBackgroundForm.valid;
            case 5:
                return this.odontologyTissueForm.valid;
            case 6:
                return this.odontologyRadiologicForm.valid;
            case 7:
                return true;
           case 8:
                return true;




        }

    }

    next(next: boolean): void {
        if (this.showOnlyObservations) {
                  this.updateClinicHistory(next,"8");
        }
        else {
            switch (this.stepper.selectedIndex) {
                case 0:
                    this.createOrUpdatePerson(next);
                    break;
                case 1:
                    this.createOrUpdatePatientInformation(next);
                    break;
                case 2:
                    this.updateClinicHistory(next,"2");
                    break;
                case 3:
                    this.passNext(next)

                    break;
                case 4:
                  // this.saveOrupdateOdontologyPatientBackgrounds(next);
                  //console.log("paso 4: guardar simbólico");
                  this.passNext(next)
                    break;
                case 5:
                   // this.saveOrupdateOdontologyTissuePatient(next);
                  this.passNext(next)
                    break;
                case 6:
                   // this.saveOrUpdateOdontologyRadiologicExamPatient(next);
                    this.passNext(next)
                    break;
                case 7:
                     this.updateClinicHistory(next,"7");
                    break;
                case 8:
                     this.updateClinicHistory(next,"8");
                    break;
            }
        }
        this.panelOpenState = false;
    }

    previous(): void {
        this.stepper.previous();
        this.panelOpenState = false;
        this.activeTab(this.stepper.selectedIndex);
    }

    verifyServiceNumber(data:string[]):boolean
    {
        let result:boolean=false;
          if (data.includes(this.clinicHistory.serviceType)) result=true;

        return result;
    }

    getNameFromClinichistory():string
    {
      console.log("EN GETNAMEFROMCLINICHISTORY, this.clinicHistory es:", this.clinicHistory);
     let result='';
      let sname=this.clinicHistory.patient.secondName?? 'DATA';
      let sn='';
      sname.length>0?sn=sname:sn='';
      let name=this.clinicHistory.patient.firstName +' '+sn;


      let ssname= this.clinicHistory.patient.secondSurName;
      let secondsn='';
      ssname.length>0?secondsn=ssname: secondsn='';
      let lastname=this.clinicHistory.patient.firtsSurName +' '+secondsn;
      result= name+' '+lastname;


      return result;
    }

//#region clipboard
    copyToClipboardAll(): void {
      const firstN = this.firstFormGroup.get('firstCtrl')?.value;
      const secondN = this.firstFormGroup.get('secondCtrl')?.value;
      const firstS = this.firstFormGroup.get('threeCtrl')?.value;
      const secondS = this.firstFormGroup.get('fourCtrl')?.value;
      const userName=Utilities.getNameFromPersonByData(firstN, secondN, firstS,secondS)
      const userDocumentId= this.firstFormGroup.get('sixCtrl')?.value;
      const userEmail= this.firstFormGroup.get('sevenCtrl')?.value;
      const userAddress= this.firstFormGroup.get('nineCtrl')?.value;


      const clipboardContent = `${userName}\n ${userDocumentId}\n ${userEmail}\n ${userAddress}`;

      navigator.clipboard.writeText(clipboardContent).then(() => {
        console.log('Datos copiados al portapapeles:', clipboardContent);
      }).catch((err) => {
        console.error('Error al copiar al portapapeles:', err);
      });
    }

    copyToClipboardName(): void {
      const firstN = this.firstFormGroup.get('firstCtrl')?.value;
      const secondN = this.firstFormGroup.get('secondCtrl')?.value;
      const firstS = this.firstFormGroup.get('threeCtrl')?.value;
      const secondS = this.firstFormGroup.get('fourCtrl')?.value;
      const userName=Utilities.getNameFromPersonByData(firstN, secondN, firstS,secondS)

      const clipboardContent = `${userName}`;

      navigator.clipboard.writeText(clipboardContent).then(() => {
        console.log('Datos copiados al portapapeles:', clipboardContent);
      }).catch((err) => {
        console.error('Error al copiar al portapapeles:', err);
      });
    }

    copyToClipboardDocument(): void {
      const userDocumentId= this.firstFormGroup.get('sixCtrl')?.value;
      const clipboardContent =`${userDocumentId}`;

      navigator.clipboard.writeText(clipboardContent).then(() => {
        console.log('Datos copiados al portapapeles:', clipboardContent);
      }).catch((err) => {
        console.error('Error al copiar al portapapeles:', err);
      });
    }

    copyToClipboardEmail(): void {
      const userEmail= this.firstFormGroup.get('sevenCtrl')?.value;
      const clipboardContent =`${userEmail}`;

      navigator.clipboard.writeText(clipboardContent).then(() => {
        console.log('Datos copiados al portapapeles:', clipboardContent);
      }).catch((err) => {
        console.error('Error al copiar al portapapeles:', err);
      });
    }

    copyToClipboardAddress(): void {
      const userAddress= this.firstFormGroup.get('nineCtrl')?.value;
      const clipboardContent =`${userAddress}`;

      navigator.clipboard.writeText(clipboardContent).then(() => {
        console.log('Datos copiados al portapapeles:', clipboardContent);
      }).catch((err) => {
        console.error('Error al copiar al portapapeles:', err);
      });
    }

//#endregion clipboard

    openCreateReport(clinicHistoryId)
    {

      this.getSellByClinicHistoryId(clinicHistoryId);


    }

     private scrollToTop() {
        // Scroll suave en el contenedor del modal (modal-content)
        if (this.clinicHistoryContainer?.nativeElement) {
            this.smoothScrollTo(this.clinicHistoryContainer.nativeElement, 0, 1000);
        }

        // También hacer scroll suave al modal-body
        const modalBody = document.querySelector('.modal.show .modal-body');
        if (modalBody) {
            this.smoothScrollTo(modalBody as HTMLElement, 0, 1000);
        }
    }

    // Método auxiliar para scroll suave personalizado
    private smoothScrollTo(element: HTMLElement, target: number, duration: number) {
        const start = element.scrollTop;
        const change = target - start;
        const startTime = performance.now();

        const animateScroll = (currentTime: number) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);

            // Función de easing para suavizar la animación (ease-out)
            const easeOutCubic = 1 - Math.pow(1 - progress, 3);

            element.scrollTop = start + (change * easeOutCubic);

            if (progress < 1) {
                requestAnimationFrame(animateScroll);
            }
        };

        requestAnimationFrame(animateScroll);
    }

    getSellByClinicHistoryId(clinicHistoryId:number)
    {
      this._sellService.getSellByClinicHistoryId(clinicHistoryId).subscribe(data=>{

        this.clinicHistoryAsignedToSell=data.clinicHistoryId;
        this._cdr.detectChanges();

      this.stepper.linear = false;
      this.showOnlyObservations=false;
      this._cdr.detectChanges();
      this.stepper.selectedIndex=3;
      this.stepper.linear = true; // Reactiva el modo lineal si es necesario
      })
    }
    sortBOItemxNameAscendent(list:BOItem[]): void {
      list.sort((a, b) =>
        a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })
      );
    }

    sortBOPersonByFirstNameAscendent(list:BOPerson[]): void {
      list.sort((a, b) =>
        a.firstName.localeCompare(b.firstName, 'es', { sensitivity: 'base' })
      );
    }

    sortBOEpsByFirstNameAscendent(list:BOEps[]): void {
      list.sort((a, b) =>
        a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })
      );
    }
  //new forms
    get itemsFormArray(): FormArray {
      return this.odontologyBackgroundForm.get('items') as FormArray;
    }

    get itemsTissueArray(): FormArray {
      return this.odontologyTissueForm.get('items') as FormArray;
    }

    get itemsRadiologicArray(): FormArray {
      return this.odontologyRadiologicForm.get('items') as FormArray;
    }


    showDetailTextArea(item: any): void {
      let showDetailsTemp= item.get('showDetails').value;
      item.get('showDetails').setValue(!showDetailsTemp);

    }


    //#region ODONTOLOGYPATIENTBACKGROUND

    handlePosSendedOdontologyPatientBackground(event: {uniqueId:string})
    {
      this.odontologyPatientBackgroundsList = this.odontologyPatientBackgroundsList.filter(
        item => item.tempId !== event.uniqueId
      );
    }
    saveOdontologyPatientBackgroundSingle(item: BOOdontologyPatientBackground)
    {
      console.log("Entra a SAVEODONTPBACKGROUND, ITEM ES:", item);
      this._odontologyPatientBackgroundService.createOrUpdateOdontologyPatientBackgroundSingle(
        this.clinicHistory.patient.id, item).subscribe({
        next: (result) => {
          // Resultado exitoso
          this.odontologyPatientBackgroundsList.push(result);
          console.log("Datos del control:", result);
          this.toastr.success("Éxito", "Se guardó el control y se incrementó la consulta");
        },
        error: (err) => {
          console.error("Error en la operación:", err);
          this.toastr.error("Error", "No se pudo completar la operación. Por favor, intente nuevamente.");
        }
      });
    }

    createNewOdontologyPatientBackgroundSingle()
    {
      let code=this.detailBackgroundFormGroup.get('itemType').value;
      let detail=this.detailBackgroundFormGroup.get('details').value;

      const [codeTemp, nameTemp] = code.split("@");

      const nr=new BOOdontologyPatientBackground();
     // nr.tempId=Utilities.generarateGUI();
      nr.personId=this.patient.id;
      nr.itemType=codeTemp;
      nr.itemName=nameTemp;
      nr.details=detail;

      // this.patientRiskFactorList.push(nr);
      this.saveOdontologyPatientBackgroundSingle(nr);

      this.detailBackgroundFormGroup.patchValue({
        itemType: null,
        details:null
      })

    }

    createEditOdontologyPatientBackgroundSingle(itemId:number, detailsSended:string)
    {
      console.log("Entra a editOdontologyPatientBackgroundSingle. itemId es:", itemId, " El array es:",this.odontologyPatientBackgroundsList );
      let elem= this.odontologyPatientBackgroundsList.find(x=>x.id==itemId);
      let details=detailsSended;

      console.log("EN EDIOPB, elem es:", elem);
      const nr=new BOOdontologyPatientBackground();
      nr.id= elem.id;
      nr.personId=elem.personId;
      nr.itemType=elem.itemType;
      nr.itemName=elem.itemName;
      nr.details=details;

      // this.patientRiskFactorList.push(nr);
      this.updateOdontologyPatientBackgroundSingle(nr);

      this.detailBackgroundFormGroup.patchValue({
        itemType: null,
        details:null
      })

    }

    updateOdontologyPatientBackgroundSingle(item: BOOdontologyPatientBackground) {

        this._odontologyPatientBackgroundService
            .createOrUpdateOdontologyPatientBackgroundSingle(
                this.clinicHistory.patient.id,
                item
            )
            .subscribe({

                next: (result) => {

                    this.odontologyPatientBackgroundsList =
                        this.odontologyPatientBackgroundsList.map(x =>
                            x.id === result.id ? result : x
                        );

                    console.log(this.odontologyPatientBackgroundsList);

                    this.toastr.success(
                        "Éxito",
                        "Se actualizó el elemento"
                    );

                },

                error: (err) => {

                    console.error(err);

                    this.toastr.error(
                        "Error",
                        "No se pudo completar la operación."
                    );

                }

            });

    }
    deleteOdontologyPatientBackgroundSingle(itemId:number)
    {
        this._odontologyPatientBackgroundService
            .deleteOdontologyPatientBackgroundSingle(itemId)
            .subscribe({

                next: data => {

                    if(data)
                    {
                console.log("ANTES DE BORRAR this.odontologyPatientBackgroundsList es:",this.odontologyPatientBackgroundsList);

                        this.odontologyPatientBackgroundsList =
                            this.odontologyPatientBackgroundsList.filter(
                                x => x.id !== itemId
                            );
                console.log("DESPUES DE BORRAR this.odontologyPatientBackgroundsList es:",this.odontologyPatientBackgroundsList);

                        this.toastr.success(
                            "Éxito",
                            "Se borraron los datos"
                        );
                    }
                    else{

                        this.toastr.error(
                            "Fallo",
                            "No se borraron los datos"
                        );

                    }

                },

                error: err => {

                    console.error(err);

                }

            });

    }

    handlePosSendedOdontologyPatientBackgroundSingle(event: {itemId:number, tipo:string, details:string})
    {
      console.log("ENTRA EN HANDLEPSOPBACKGROUND, event es:", event);
      let confirm:boolean=false;
      if(event.tipo=='del')
      {
          this._dialogConfirm.openConfirmDialog('¿Confirma que desea borrar este item? ')
                .afterClosed().subscribe({
                  next:(res)=>
                  {
                    confirm=res;

                    if(confirm)
                    {
                    this.deleteOdontologyPatientBackgroundSingle(event.itemId)

                    }
                    else
                    {
                      this.close();
                    }
                  },
                  error:(err)=>{
                    console.log("Se produjo un error al confirmar borrado de antecedente");
                  }
                })

      }

      if(event.tipo=='edi')
      {
      this._dialogConfirm.openConfirmDialog('¿Confirma que desea editar este item? ')
            .afterClosed().subscribe({
              next:(res)=>
              {
                confirm=res;

                if(confirm)
                {
                  this.createEditOdontologyPatientBackgroundSingle(event.itemId, event.details);
                }
                else
                {
                  this.close();
                }
              },
              error:(err)=>{
                console.log("Se produjo un error al confirmar borrado de antecedente");
              }
            })
      }


    }

    trackByFnBackground(index: number, item: BOOdontologyPatientBackground): number {
      return item.id; // Angular usa esto para identificar elementos
    }

    //#endregion ODONTOLOGYPATIENTBACKGROUND

    //#region ODONTOLOGY TIESUE
    saveOdontologyTissuePatientSingle(item: BOOdontologyTissuePatient)
    {
      console.log("Entra a SAVEODONTPBACKGROUND, ITEM ES:", item);
      this._odontologyTissuePatientService.createOrUpdateOdontologyTissuePatientSingle(
        this.clinicHistory.patient.id, item).subscribe({
        next: (result) => {
          // Resultado exitoso
          this.odontologyTissuesPatientList.push(result);
          console.log("Datos del control:", result);
          this.toastr.success("Éxito", "Se guardó el item");
        },
        error: (err) => {
          console.error("Error en la operación:", err);
          this.toastr.error("Error", "No se pudo completar la operación. Por favor, intente nuevamente.");
        }
      });
    }

    createNewOdontologyTissuePatientSingle()
    {
      let code=this.detailTissueFormGroup.get('itemType').value;
      let details=this.detailTissueFormGroup.get('details').value;


      const [codeTemp, nameTemp] = code.split("@");

      const nr=new BOOdontologyTissuePatient();
     // nr.tempId=Utilities.generarateGUI();
      nr.personId=this.patient.id;
      nr.itemType=codeTemp;
      nr.itemName=nameTemp;
      nr.details=details;

      // this.patientRiskFactorList.push(nr);
      this.saveOdontologyTissuePatientSingle(nr);

      this.detailTissueFormGroup.patchValue({
        itemType: null,
        details:null
      })

    }

    createEditOdontologyTissuePatientSingle(itemId:number, detailsSended:string)
    {
      console.log("Entra a editOdontologyPatientTissueSingle. itemId es:", itemId, " El array es:",this.odontologyPatientBackgroundsList );
      let elem= this.odontologyTissuesPatientList.find(x=>x.id==itemId);
      let details=detailsSended;

      console.log("EN EDIOPB, elem es:", elem);
      const nr=new BOOdontologyTissuePatient();
      nr.id= elem.id;
      nr.personId=elem.personId;
      nr.itemType=elem.itemType;
      nr.itemName=elem.itemName;
      nr.details=details;

      // this.patientRiskFactorList.push(nr);
      this.updateOdontologyTissuePatientSingle(nr);

      this.detailTissueFormGroup.patchValue({
        itemType: null,
        details:null
      })

    }

    updateOdontologyTissuePatientSingle(item: BOOdontologyTissuePatient) {

        this._odontologyTissuePatientService
            .createOrUpdateOdontologyTissuePatientSingle(
                this.clinicHistory.patient.id,
                item
            )
            .subscribe({

                next: (result) => {

                    this.odontologyTissuesPatientList =
                        this.odontologyTissuesPatientList.map(x =>
                            x.id === result.id ? result : x
                        );

                    console.log(this.odontologyTissuesPatientList);

                    this.toastr.success(
                        "Éxito",
                        "Se actualizó el elemento"
                    );

                },

                error: (err) => {

                    console.error(err);

                    this.toastr.error(
                        "Error",
                        "No se pudo completar la operación."
                    );

                }

            });

    }

    deleteOdontologyTissuePatientSingle(itemId:number)
    {
        this._odontologyTissuePatientService
            .deleteOdontologyTissuePatientSingle(itemId)
            .subscribe({

                next: data => {

                    if(data)
                    {
                console.log("ANTES DE BORRAR this.OdontologyTissuePatientsList es:",this.odontologyTissuesPatientList);

                        this.odontologyTissuesPatientList =
                            this.odontologyTissuesPatientList.filter(
                                x => x.id !== itemId
                            );
                console.log("DESPUES DE BORRAR this.OdontologyTissuePatientsList es:",this.odontologyTissuesPatientList);

                        this.toastr.success(
                            "Éxito",
                            "Se borraron los datos"
                        );
                    }
                    else{

                        this.toastr.error(
                            "Fallo",
                            "No se borraron los datos"
                        );

                    }

                },

                error: err => {

                    console.error(err);

                }

            });

    }
    handlePosSendedOdontologyTissuePatientSingle(event: {itemId:number, tipo:string, details:string})
    {
      console.log("ENTRA EN HANDLEPSOTISSUEPATIENT, event es:", event);
      let confirm:boolean=false;
      if(event.tipo=='del')
      {
          this._dialogConfirm.openConfirmDialog('¿Confirma que desea borrar este item? ')
                .afterClosed().subscribe({
                  next:(res)=>
                  {
                    confirm=res;

                    if(confirm)
                    {
                    this.deleteOdontologyTissuePatientSingle(event.itemId)

                    }
                    else
                    {
                      this.close();
                    }
                  },
                  error:(err)=>{
                    console.log("Se produjo un error al confirmar borrado de antecedente");
                  }
                })

      }

      if(event.tipo=='edi')
      {
      this._dialogConfirm.openConfirmDialog('¿Confirma que desea editar este item? ')
            .afterClosed().subscribe({
              next:(res)=>
              {
                confirm=res;

                if(confirm)
                {
                  this.createEditOdontologyTissuePatientSingle(event.itemId, event.details);
                }
                else
                {
                  this.close();
                }
              },
              error:(err)=>{
                console.log("Se produjo un error al confirmar borrado de tejidos");
              }
            })
      }


    }

    trackByFnTissue(index: number, item: BOOdontologyTissuePatient): number {
      return item.id; // Angular usa esto para identificar elementos
    }
    //#endregion ODONTOLOGY TIESUE

    //#region ODONTOLOGY RADIOLOGIC EXAM
    saveOdontologyRadiologicExamPatientSingle(item: BOOdontologyRadiologicExamPatient)
    {
      console.log("Entra a SAVEOREPatientSingle, ITEM ES:", item);
      this._odontologyRadiologicExamPatientService.createOrUpdateOdontologyRadiologicExamPatientSingle(
        this.clinicHistory.patient.id, item).subscribe({
        next: (result) => {
          // Resultado exitoso
          this.odontologyRadiologicExamPatientList.push(result);
          console.log("Datos del control:", result);
          this.toastr.success("Éxito", "Se guardó el item");
        },
        error: (err) => {
          console.error("Error en la operación:", err);
          this.toastr.error("Error", "No se pudo completar la operación. Por favor, intente nuevamente.");
        }
      });
    }

    createNewOdontologyRadiologicExamPatientSingle()
    {
      let code=this.detailRadiologicFormGroup.get('itemType').value;
      let details=this.detailRadiologicFormGroup.get('details').value;


      const [codeTemp, nameTemp] = code.split("@");

      const nr=new BOOdontologyRadiologicExamPatient();
      nr.personId=this.patient.id;
      nr.itemType=codeTemp;
      nr.itemName=nameTemp;
      nr.details=details;

      this.saveOdontologyRadiologicExamPatientSingle(nr);

      this.detailRadiologicFormGroup.patchValue({
        itemType: null,
        details:null
      })

    }

    createEditOdontologyRadiologicExamPatientSingle(itemId:number, detailsSended:string)
    {
      console.log("Entra a editOdontologyRadiologicExamPatientSingle. itemId es:", itemId, " El array es:",this.odontologyRadiologicExamPatientList );
      let elem= this.odontologyRadiologicExamPatientList.find(x=>x.id==itemId);
      let details=detailsSended;

      console.log("EN COEOREPATIENTSINGLE, elem es:", elem);
      const nr=new BOOdontologyRadiologicExamPatient();
      nr.id= elem.id;
      nr.personId=elem.personId;
      nr.itemType=elem.itemType;
      nr.itemName=elem.itemName;
      nr.details=details;

      // this.patientRiskFactorList.push(nr);
      this.updateOdontologyRadiologicExamPatientSingle(nr);

      this.detailRadiologicFormGroup.patchValue({
        itemType: null,
        details:null
      })

    }

    updateOdontologyRadiologicExamPatientSingle(item: BOOdontologyRadiologicExamPatient) {

        this._odontologyRadiologicExamPatientService
            .createOrUpdateOdontologyRadiologicExamPatientSingle(this.clinicHistory.patient.id,item)
            .subscribe({

                next: (result) => {

                    this.odontologyRadiologicExamPatientList =
                        this.odontologyRadiologicExamPatientList.map(x =>
                            x.id === result.id ? result : x
                        );

                    console.log(this.odontologyRadiologicExamPatientList);

                    this.toastr.success(
                        "Éxito",
                        "Se actualizó el elemento"
                    );

                },

                error: (err) => {

                    console.error(err);

                    this.toastr.error(
                        "Error",
                        "No se pudo completar la operación."
                    );

                }

            });

    }

    deleteOdontologyRadiologicExamPatientSingle(itemId:number)
    {
        this._odontologyRadiologicExamPatientService
            .deleteOdontologyRadiologicExamPatientSingle(itemId)
            .subscribe({

                next: data => {

                    if(data)
                    {
                console.log("ANTES DE BORRAR this.OdontologyRadiologicExamPatientsList es:",this.odontologyRadiologicExamPatientList);

                        this.odontologyRadiologicExamPatientList =
                            this.odontologyRadiologicExamPatientList.filter(
                                x => x.id !== itemId
                            );
                console.log("DESPUES DE BORRAR this.OdontologyRadiologicExamPatientsList es:",this.odontologyRadiologicExamPatientList);

                        this.toastr.success(
                            "Éxito",
                            "Se borraron los datos"
                        );
                    }
                    else{

                        this.toastr.error(
                            "Fallo",
                            "No se borraron los datos"
                        );

                    }

                },

                error: err => {

                    console.error(err);

                }

            });

    }
    handlePosSendedOdontologyRadiologicExamPatientSingle(event: {itemId:number, tipo:string, details:string})
    {
      console.log("ENTRA EN HANDLEPSOTISSUEPATIENT, event es:", event);
      let confirm:boolean=false;
      if(event.tipo=='del')
      {
          this._dialogConfirm.openConfirmDialog('¿Confirma que desea borrar este item? ')
                .afterClosed().subscribe({
                  next:(res)=>
                  {
                    confirm=res;

                    if(confirm)
                    {
                    this.deleteOdontologyRadiologicExamPatientSingle(event.itemId)

                    }
                    else
                    {
                      this.close();
                    }
                  },
                  error:(err)=>{
                    console.log("Se produjo un error al confirmar borrado de antecedente");
                  }
                })

      }

      if(event.tipo=='edi')
      {
      this._dialogConfirm.openConfirmDialog('¿Confirma que desea editar este item? ')
            .afterClosed().subscribe({
              next:(res)=>
              {
                confirm=res;

                if(confirm)
                {
                  this.createEditOdontologyRadiologicExamPatientSingle(event.itemId, event.details);
                }
                else
                {
                  this.close();
                }
              },
              error:(err)=>{
                console.log("Se produjo un error al confirmar borrado de tejidos");
              }
            })
      }


    }

    trackByFnRadiologic(index: number, item: BOOdontologyRadiologicExamPatient): number {
      return item.id; // Angular usa esto para identificar elementos
    }
    //#endregion ODONTOLOGY RADIOLOGIC EXAM

//#region Evolution
    createNewChControlSingle()
    {
      const controlDate=this.chControlFatherFormGroup.get('controlDate').value;
      console.log("ENTRA A CREATENEWCONTROLSINGLE, controlDate es:", controlDate);
      const professionalId=this.chControlFatherFormGroup.get('professionalId').value;
      const details= this.chControlFatherFormGroup.get('details').value;
      const ch= this.clinicHistory;
      //const ctrlN=ch.controlConsultation==0?1:ch.controlConsultation+1;
      const ctrlN=ch.controlConsultation+1;
    // console.log("EN CNCSINGLE  professionalId es: ", professionalId, " y su tipo es: ", typeof professionalId);
    const ncc= new BOClinicHistoryObservations();
    ncc.clinicHistoryId=this.clinicHistory.id;
    ncc.patientId=this.patient.id;
    ncc.controlNumber=ctrlN;
    ncc.professionalId= typeof professionalId === 'string' ? parseInt(professionalId) : professionalId;
    ncc.controlDate = controlDate ? new Date(controlDate) : null;
    ncc.observation=details;
    ncc.creationUserEmail=localStorage.getItem('User');

    this.chControlFatherFormGroup.patchValue({
      controlDate: null,
      professionalId: null,
      details:null
    })
    console.log("SALE DE CREATENEWCHCONTROLSINGLE, ncc es:", ncc);
    this.saveChControlSingle(ncc);


    }

    saveChControlSingle(item: BOClinicHistoryObservations)
    {
      this._clinicHistoryObservationsService.createOrUpdateClinicHistoryObservationsSingle
      (
        this.patient.id,
        this.clinicHistory.id,
        item,
      ).subscribe({
        next: (result) => {
          // Resultado exitoso
          this.clinicHistoryObservationsList.push(result);
          // console.log("Control guardado con número:", result.controlNumber);
          // console.log("Datos del control:", result);
          this.isChEvolutionPanelOpen=false;
          this.toastr.success("Éxito", "Se guardó el control y se incrementó la consulta");
        },
        error: (err) => {
          console.error("Error en la operación:", err);
          this.toastr.error("Error", "No se pudo completar la operación. Por favor, intente nuevamente.");
        }
      });
    }


        handlePosSendedChControlSingle(event: {itemId:number})
    {
      let confirm:boolean=false;

      this._dialogConfirm.openConfirmDialog('¿Confirma que desea borrar este item? ')
            .afterClosed().subscribe({
              next:(res)=>
              {
                confirm=res;

                if(confirm)
                {
                  this.deleteChControlSingle(event.itemId)

                }
                else
                {
                  this.close();
                }
              },
              error:(err)=>{
                console.log("Se produjo un error al confirmar borrado de paciente");
              }
            })
    }

deleteChControlSingle(itemId:number)
{
//console.log("ENTRA A DELETEPATIENTFARMACOLOGRECORDSINGLE")
  this._clinicHistoryObservationsService.deleteClinicHistoryObservationsSingle(itemId).subscribe({
    next:(data)=>{
      if(data)
      {

        const pos =this.clinicHistoryObservationsList.findIndex(x=>x.id===itemId);
        if(pos !==-1)this.clinicHistoryObservationsList.splice(pos, 1);
        this.toastr.success("Éxito", "Se borraron los datos");
      }
      else
      {
        this.toastr.error("Fallo", "No se borraron los datos");
      }
    },
    error:(err)=>{
      console.log("Se produjo en error al eliminar registros de alergias");
    }
  })
}





//#endregion Evolution

    passNext(next:boolean):void{
      if(next){
        this.activeTab(this.stepper.selectedIndex+1);
         this.stepper.next();
      }
      else this.close();

    }

    loadFormDataType(target: IBasicDataType[], formArray: FormArray ) {
        target.forEach(item => {
          formArray.push(
            this._formBuilder.group({
              id: [item.id],
              name: [item.name],
              answer: [false],
              observations: [''],
              showDetails: [false]
            })
          );
        });
    }

    createTempArray( selectedItems:IBasicData[], source:IBasicData[]):IBasicData[]{
          let tempArray:IBasicData[]=[];
          if (selectedItems.length === 0 && source.length > 0)
          {

              tempArray = source.map(item => {
              return {
                ...item,
                isTrue: false,
                observations: '',
                showDetails: false
              };
            });
          }
          else
          {
            // Create a map of backgroundIds from selectedItems for faster lookup
            const selectedBackgroundIds = new Map();
            selectedItems.forEach(item => {
              selectedBackgroundIds.set(item.typeItemId, item);
            });

            // Create a map of existing items in database for faster lookup
            const existingBackgroundIds = new Map();
        //   this.odontologyPatientBackgroundsList.forEach(item => {
            source.forEach(item => {
              existingBackgroundIds.set(item.typeItemId, item);
            });

            // 1. Process items from Array A (database)
          // this.odontologyPatientBackgroundsList.forEach(item => {

            source.forEach(item => {

              const selectedItem = selectedBackgroundIds.get(item.typeItemId);

              if (selectedItem) {
                // Item exists in both arrays - preserve id from database
                tempArray.push({
                  ...selectedItem,
                  id: item.id // Keep the original id from database
                });
              } else {
                // Item only in database - set isTrue to false
                tempArray.push({
                  ...item,
                  isTrue: false,
                  observations: '',
                  showDetails: false
                });
              }
            });

            // 2. Add items from Array B that don't exist in Array A
            selectedItems.forEach(selectedItem => {
              if (!existingBackgroundIds.has(selectedItem.typeItemId)) {
                tempArray.push({
                  ...selectedItem,
                  isTrue: true
                });
              }
            });
          }
          return tempArray;

    }


    initializeFormFromList(targetList:IBasicData[], formArray:FormArray)
    {
                  targetList.forEach(item=>{
                  for (let i = 0; i < formArray.length; i++) {
                    const formGroup = formArray.at(i) as FormGroup;
                    let fgId=formGroup.get('id').value;
                    let fgIdNumber=parseInt(fgId);

                    if(fgIdNumber==item.typeItemId)
                    {
                      formGroup.get('answer').setValue(true);
                      formGroup.get('observations').setValue(item.observations);

                    }
                  }
                });


    }

    navigateToOdontogramaFromCreate():void
    {
      this._odontogramaService.createOdontograma(this.clinicHistory.id, this.clinicHistory.patient.id)
          .subscribe(data=>{
            console.log('subscribe de  navigateToOdontogramaFromCreate');
      // Navegar con query params
          this._router.navigate(['/dental-Admins/odontograma'], {

            queryParams: {
              clinicHistory: this.clinicHistory.id,
              personId:this.clinicHistory.patient.id,
            }
          });

      })

    }

    onDataUpdate(data:number):void{
    this.clinicHistoryAsignedToSell=data;
    this.clinicHistory.isPaidMethod=1;
    }

    // Método para verificar la posición del scroll y mostrar/ocultar flecha
    private checkScrollPosition() {
        if (this.clinicHistoryContainer?.nativeElement) {
            const element = this.clinicHistoryContainer.nativeElement;
            const scrollTop = element.scrollTop;
            const scrollHeight = element.scrollHeight;
            const clientHeight = element.clientHeight;

            // Mostrar flecha si no está cerca del final (últimos 100px)
            this.showScrollDownArrow = (scrollTop + clientHeight) < (scrollHeight - 100);
        }
    }

    // Método para hacer scroll hacia abajo a los botones
    public scrollToBottom(event?: Event) {

          if (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
    }
        if (this.clinicHistoryContainer?.nativeElement) {
            const element = this.clinicHistoryContainer.nativeElement;
            const target = element.scrollHeight - element.clientHeight;
            this.smoothScrollTo(element, target, 800);
            //element.scrollTop = target;
        }

        // También hacer scroll en modal-body si es necesario
        const modalBody = document.querySelector('.modal.show .modal-body');
        if (modalBody) {
            const target = modalBody.scrollHeight - modalBody.clientHeight;
            this.smoothScrollTo(modalBody as HTMLElement, target, 500);
          // modalBody.scrollTop = target;
        }
    }

    private closeAndSave():void{
      this.updateClinicHistoryUpNavigation(8, true);
     // this.next(false);
     this.close();
    }

    goToScreen(target:number):void
    {

      this.currentScreen = target;
      this.stepper.linear = false; // Desactiva el modo lineal
      let currentStepper=this.stepper.selectedIndex;
       this.stepper.selectedIndex=target;
       const birthday=this.patient.birthDate? new Date(this.patient.birthDate):null;

        switch (this.stepper.selectedIndex) {
            case 0:
              this.firstFormGroup.patchValue({
                firstCtrl: this.patient.firstName,
                secondCtrl: this.patient.secondName,
                threeCtrl: this.patient.firtsSurName,
                fourCtrl: this.patient.secondSurName,
                fifthCtrl: this.idTypeList.find(x => x.code == this.patient.idType).code,
                sixCtrl: this.patient.personId,
                sevenCtrl: this.patient.email,
                nineCtrl: this.patient.address,
                eightCtrl: this.patient.cellPhoneNumber,
                tenCtrl: this.patient.emergencyContact,
                twelveCtrl: this.patient.emergencyContactName,
                // elevenCtrl: this.patient.birthDate.toString(), //Fecha nacimiento
                elevenCtrl: birthday
                });
                this.saveBackStepper(currentStepper);
              break;
            case 1:
              this.secondFormGroup.patchValue({
              firstCtrl: this.patientInformation.sexType,
              secondCtrl: this.patientInformation.genderIdentity,
              threeCtrl: this.patientInformation.disabilityCategory != null ? this.patientInformation.disabilityCategory : "08",
              fourCtrl: this.patientInformation.ethnicity,
              fifthCtrl: this.patientInformation.ethnicCommunity,
              sixCtrl: this.patientInformation.residenceZone,
              sevenCtrl: this.epsList.find(x => x.id == this.patientInformation.epsId)?.code,
              nineCtrl: this.personOcupationList.find(p => p.id == this.patientInformation.personOcupationId)?.code,
              eightCtrl: this.countries.find(c => c.id == this.patientInformation.birthCountryId)?.code,
              tenCtrl: this.countries.find(co => co.id == this.patientInformation.residenceCountryId)?.code,
              elevenCtrl: this.cities.find(ci => ci.id == this.patientInformation.residenceCityId)?.code,
              twelveCtrl: this.cities.find(ci => ci.id == this.patientInformation.residenceCityId)?.code.substring(0, 2),
              thirteen: this.patientInformation.organDonor?.organDonorAnswer,
              fourtheen: this.patientInformation.organDonor?.organDonorDocumentDate?.toString().split('T')[0],
              fiftheen: this.patientInformation.advancedDirectiveDocument?.advancedDirectiveDocumentAnswer,
              sixteen: this.patientInformation.advancedDirectiveDocument?.advancedDirectiveDocumentDate?.toString().split('T')[0]
              });
              this.saveBackStepper(currentStepper);
              break;
            case 2:
                this.thirdFormGroup.patchValue({
                firstCtrl: this.clinicHistory.consultationDate?.toString(),
                secondCtrl: this.ipsList.find(x => x.id == this.clinicHistory.ipsId)?.code,
                threeCtrl: this.clinicHistory.serviceGroups,
                fourCtrl: this.clinicHistory.healthTechnologyModality,
                fifthCtrl: this.clinicHistory.placeOfAttention,
                sixCtrl: this.clinicHistory.routeOfEntry,
                sevenCtrl: this.clinicHistory.consultationCause,
                eightCtrl: this.clinicHistory.triageDate,
                nineCtrl: this.clinicHistory.triageType,
                thirteenCtrl: this.clinicHistory.serviceType,
                fourteenCtrl: this.clinicHistory.servicePrice,
                fifteenCtrl: this.clinicHistory.procedureDescription,
                });
                this.saveBackStepper(currentStepper);


              break;
            case 3:
              break;
            case 4:
                this.saveBackStepper(currentStepper);
              break;
            case 5:
             this.saveBackStepper(currentStepper);
              break;
            case 6:
                this.saveBackStepper(currentStepper);
              break;
            case 7:
              this.saveBackStepper(currentStepper);
              break;
           case 8:
              this.saveBackStepper(currentStepper);
              break;

        }
    }
// goToScreen(target: number): void
// {
//   // --- Validación de linealidad solo para 'cmg' en tabs 0,1,2 ---
//   if (this.categoryService == 'cmg' && this.isLinearBlocked(target)) {
//     return; // Bloquea la navegación
//   }

//   this.currentScreen = target;

//   this.stepper.linear = false; // Desactiva el modo lineal
//   let currentStepper = this.stepper.selectedIndex;
//   this.stepper.selectedIndex = target;
//   const birthday = this.patient.birthDate ? new Date(this.patient.birthDate) : null;

//   switch (this.stepper.selectedIndex) {
//     // ... tu switch existente, sin cambios
//   }

//   //setTimeout(() => this.tabNavBar?.realignInkBar());
// }





//#region Metodos navegación


    saveBackStepper(backStepper:number):void
    {
          switch (backStepper) {
            case 0:
                this.updatePerson();
              break;
            case 1:
                this.updatePatientInformation();

              break;
            case 2:
                this.updateClinicHistoryBodyUpNavigation(2);

              break;

            case 3:
              // this.stepper.linear = false;
             // this.updateOdontogramaState();
              break;


            // case 4:
            //     return this.fifthFormGroup.valid;
            case 4:

      //      this.updateOdontologyPatientBackgrounds();

              break;

            case 5:

               //this.updateOdontologyTissuePatient();

              break;
            case 6:
              //this.updateOdontologyRadiologicExamPatient();
              break;
            case 7:
                this.updateClinicHistoryBodyUpNavigation(7);
              break;
           case 8:
                this.updateClinicHistoryBodyUpNavigation(8);
              break;
        }





    }

    updatePerson(): void
    {
      let secondNameTested="";
      let secondNameTest=this.firstFormGroup.get('secondCtrl')!.value;
      if(typeof secondNameTest=="string") secondNameTest.trim();
      secondNameTest==null
        || secondNameTest==""
        || secondNameTest==undefined?secondNameTested="":(secondNameTested=secondNameTest.toUpperCase()).trim();

      let secondSurNameTest=(this.firstFormGroup.get('fourCtrl')!.value);
      if(typeof secondSurNameTest=="string") secondSurNameTest.trim();

      let secondSurNameTested="";
      secondSurNameTest ==null
        || secondSurNameTest ==""
        || secondSurNameTest==undefined?secondSurNameTested="":(secondSurNameTested=secondSurNameTest.toUpperCase()).trim();

        this.patient.id = this.patient.id;

        this.patient.firstName = this.firstFormGroup.get('firstCtrl')!.value;
        this.patient.firstName=this.patient.firstName.toUpperCase().trim();
        this.patient.secondName = secondNameTested;

        this.patient.firtsSurName = this.firstFormGroup.get('threeCtrl')!.value;
        this.patient.firtsSurName=this.patient.firtsSurName.toUpperCase().trim();

        this.patient.secondSurName = secondSurNameTested;
        this.patient.idType = this.firstFormGroup.get('fifthCtrl')!.value;
        this.patient.personId = this.firstFormGroup.get('sixCtrl')!.value;
        this.patient.email = (this.firstFormGroup.get('sevenCtrl')!.value).trim().toLowerCase();
        this.patient.address = this.firstFormGroup.get('nineCtrl')!.value;
        this.patient.cellPhoneNumber = String(this.firstFormGroup.get('eightCtrl')!.value);
        this.patient.emergencyContact = String(this.firstFormGroup.get('tenCtrl')!.value);
        this.patient.emergencyContactName = String(this.firstFormGroup.get('twelveCtrl')!.value);
        this.patient.birthDate = new Date(this.firstFormGroup.get('elevenCtrl')!.value);
        this.patient.personType = 3;
        this.patient.isClient = true;
        this.busy = this._personService.addOrUpdatePerson(this.patient).subscribe(data =>{
        })
    }

    updatePatientInformation(): void
    {
        const patientInformationInput: BOPatientInformation =
        {
            id: this.patientInformation.id,
            sexType: this.secondFormGroup.get('firstCtrl')!.value,
            genderIdentity: this.secondFormGroup.get('secondCtrl').value,
            disabilityCategory: this.secondFormGroup.get('threeCtrl').value,
            ethnicity: this.secondFormGroup.get('fourCtrl').value,
            ethnicCommunity: this.secondFormGroup.get('fifthCtrl').value,
            residenceZone: this.secondFormGroup.get('sixCtrl').value,
            epsId: this.secondFormGroup.get('sevenCtrl').value != undefined ? this.epsList.find(e => e.code == this.secondFormGroup.get('sevenCtrl').value)?.id : undefined,
            birthCountryId: this.secondFormGroup.get('eightCtrl').value != undefined ? this.countries.find(e => e.code == this.secondFormGroup.get('eightCtrl').value)?.id : undefined,
            personOcupationId: this.secondFormGroup.get('nineCtrl').value != undefined ? this.personOcupationList.find(e => e.code == this.secondFormGroup.get('nineCtrl').value)?.id : undefined,
            residenceCountryId: this.secondFormGroup.get('tenCtrl').value != undefined ? this.countries.find(e => e.code == this.secondFormGroup.get('tenCtrl').value)?.id : undefined,
            residenceCityId: this.secondFormGroup.get('elevenCtrl').value != undefined ? this.cities.find(e => e.code == this.secondFormGroup.get('elevenCtrl').value)?.id : undefined
        };

        if (this.patientInformation.organDonor != null) {
            patientInformationInput.organDonor = this.patientInformation.organDonor;
            patientInformationInput.organDonor.organDonorAnswer = this.secondFormGroup.get('thirteen').value;
            patientInformationInput.organDonor.organDonorDocumentDate = this.secondFormGroup.get('fourtheen').value != undefined ? new Date(this.secondFormGroup.get('fourtheen').value) : null;
        }
        else {
            patientInformationInput.organDonor = new BOOrganDonor();
            patientInformationInput.organDonor.id = 0;
            patientInformationInput.organDonor.organDonorAnswer = this.secondFormGroup.get('thirteen').value;
            patientInformationInput.organDonor.organDonorDocumentDate = this.secondFormGroup.get('fourtheen').value != undefined ? new Date(this.secondFormGroup.get('fourtheen').value) : null;
        }
        if (this.patientInformation.advancedDirectiveDocument != null) {
            patientInformationInput.advancedDirectiveDocument = this.patientInformation.advancedDirectiveDocument;
            patientInformationInput.advancedDirectiveDocument.advancedDirectiveDocumentAnswer = this.secondFormGroup.get('fiftheen').value;
            patientInformationInput.advancedDirectiveDocument.advancedDirectiveDocumentDate = this.secondFormGroup.get('sixteen').value != undefined ? new Date(this.secondFormGroup.get('sixteen').value) : null;
        }
        else
        {
            patientInformationInput.advancedDirectiveDocument = new BOAdvancedDirectiveDocument();
            patientInformationInput.advancedDirectiveDocument.id = 0;
            patientInformationInput.advancedDirectiveDocument.advancedDirectiveDocumentAnswer = this.secondFormGroup.get('fiftheen').value;
            patientInformationInput.advancedDirectiveDocument.advancedDirectiveDocumentDate = this.secondFormGroup.get('sixteen').value != undefined ? new Date(this.secondFormGroup.get('sixteen').value) : null;
        }

        this.busy = this._patientInformationService.addOrUpdatePatientInformation(patientInformationInput).subscribe(data =>
        {
          this._patientInformationService.getPatientInformation(data).subscribe(data=>{
            this.patientInformation=data;
              this.secondFormGroup.patchValue({
              firstCtrl: this.patientInformation.sexType,
              secondCtrl: this.patientInformation.genderIdentity,
              threeCtrl: this.patientInformation.disabilityCategory != null ? this.patientInformation.disabilityCategory : "08",
              fourCtrl: this.patientInformation.ethnicity,
              fifthCtrl: this.patientInformation.ethnicCommunity,
              sixCtrl: this.patientInformation.residenceZone,
              sevenCtrl: this.epsList.find(x => x.id == this.patientInformation.epsId)?.code,
              nineCtrl: this.personOcupationList.find(p => p.id == this.patientInformation.personOcupationId)?.code,
              eightCtrl: this.countries.find(c => c.id == this.patientInformation.birthCountryId)?.code,
              tenCtrl: this.countries.find(co => co.id == this.patientInformation.residenceCountryId)?.code,
              elevenCtrl: this.cities.find(ci => ci.id == this.patientInformation.residenceCityId)?.code,
              twelveCtrl: this.cities.find(ci => ci.id == this.patientInformation.residenceCityId)?.code.substring(0, 2),
              thirteen: this.patientInformation.organDonor?.organDonorAnswer,
              fourtheen: this.patientInformation.organDonor?.organDonorDocumentDate?.toString().split('T')[0],
              fiftheen: this.patientInformation.advancedDirectiveDocument?.advancedDirectiveDocumentAnswer,
              sixteen: this.patientInformation.advancedDirectiveDocument?.advancedDirectiveDocumentDate?.toString().split('T')[0]
              });

          })
          this._cdr.detectChanges();

        });
    }

//#endregion

    getBase64ImageFromURL(url) {
      return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
          var canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;

          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          var dataURL = canvas.toDataURL("image/png");

          resolve(dataURL);
        };

        img.onerror = error => {
          reject(error);
        };

        img.src = url;
      });
    }


    readAsDataURL = async (url) => {

        const response = await fetch(url);

        const blob = await response.blob();

        return new Promise((resolve, reject) => {

        let fileReader = new FileReader();

        fileReader.onload = function () {

        return resolve(fileReader.result);

        };

        fileReader.readAsDataURL(blob);

        });

    }

    deleteObservationClinicHistoryByIndex(index: number): void {
      if (index >= 0 && index < this.clinicHistory.clinicHistoryObservations.length) {
        this.clinicHistory.clinicHistoryObservations.splice(index, 1);
      }
    }


    navigateToQuote(clinicHistoryId:number, personId:number, personName:string, isQuoteWithOdontograma?:boolean)
      {

          this._router.navigate(['/dental-Admins/quote'], {
            queryParams: {
              clinicHistory: clinicHistoryId,
              personId: personId,
              userName:personName,
              isQuoteWithOdontograma:isQuoteWithOdontograma
            }
          });
    }

    auxGetNameFromPersonFromUtilities(person:BOPerson):string
    {
      let result=Utilities.getNameFromPerson(person);
      return result;
    }

    populateFormArray(backgroundTypes: any[]) {
      const itemsArray = this.odontologyBackgroundForm.get('items') as FormArray;
      itemsArray.clear();

      backgroundTypes.forEach(type => {
        itemsArray.push(
          this._formBuilder.group({
            name: [type.name],
            answer: [false],
            showDetails: [false],
            observations: ['']
          })
        );
      });

    }

    populateFormData(backgroundData: any[])
    {
      if (!backgroundData || !Array.isArray(backgroundData)) {
        console.warn('Datos no válidos para poblar el formulario');
        return;
      }

      this.odontologyBackgroundTypesList = backgroundData;
      this.populateFormArray(backgroundData);
    }

    populateFormArrays(formTarget: FormGroup, backgroundTypes: any[]) {
      const itemsArray = formTarget.get('items') as FormArray;
      itemsArray.clear();

      backgroundTypes.forEach(type => {
        itemsArray.push(
          this._formBuilder.group({
            id:[type.id],
            name: [type.name],
            answer: [false],
            showDetails: [false],
            observations: ['']
          })
        );
      });

    }
    populateFormDatas(list: any[],backgroundData: any[], formTarget: FormGroup)
    {
      if (!backgroundData || !Array.isArray(backgroundData)) {
        console.warn('Datos no válidos para poblar el formulario');
        return;
      }

      list = backgroundData;
      this.populateFormArrays(formTarget,backgroundData);
    }

    hasCheckboxError(formGroup: FormGroup, controlName: string): boolean {
      if (!formGroup || !controlName) return false;

      const control = formGroup.get(controlName);
      return control?.errors?.atLeastOneCheckboxRequired || false;
    }

    obtenerTotalCotizacion(quote: BOToothQuote): number {
      if (quote.total !== undefined && quote.total !== null) {
        return quote.total;
      }

      if (quote.toothQuoteDetails && quote.toothQuoteDetails.length > 0) {
        return quote.toothQuoteDetails.reduce((sum, detail) => {
          const price = typeof detail.price === 'number' ? detail.price : 0;
          return sum + price;
        }, 0);
      }

      return 0;
    }

    handleCallPatientName():string
    {
      const name=Utilities.getNameFromPerson(this.clinicHistory.patient);
      return name;
    }

    activeTab(index: number): void {
      console.log("ENTRA A ACTIVETAB");
      if (!this.tabLinks)
        {
          this.toastr.error("FALLO EN ACTIVE TABS", "Fallo");
          return;
        }

      this.currentScreen = index;

      let i = 0;
      this.tabLinks.forEach((link) => {
        link.active = (i === index);
        i++;
      });
          this._cdr.detectChanges();
    }

    compareToothStateCategory(o1: BOToothStateCategory, o2: BOToothStateCategory): boolean
    {
      return o1 && o2 ? o1.id === o2.id : o1 === o2;
    }

      compareToothStateType(o1: BOToothStateType, o2: BOToothStateType): boolean
    {
      return o1 && o2 ? o1.id === o2.id : o1 === o2;
    }


  onOptionCategorySelected(item: any)
  {
        this.toothStateTypeListShort=[];
        this.toothStateTypeListShort=Utilities.getToothStatesTypeaByCategory(item, this.toothStateTypeList);
        this.toothStateTypeFormGroup.patchValue({ toothStateId: null });
  // Forzamos a Angular a actualizar el DOM AHORA MISMO
       this._cdr.detectChanges();
       this.onClickCategorySelected(item);
  }


onClickCategorySelected(item: any): void {
  this.selectedCategory = item;

  this.toothStateTypeListShort = [];
  this.toothStateTypeListShort = Utilities.getToothStatesTypeaByCategory(item, this.toothStateTypeList);

  this.toothStateTypeFormGroup.patchValue({ toothStateId: null });
  this.toothStateTypeFormGroup.patchValue({ toothStateCategoryId: item });

  // No necesitas detectChanges() aquí; el binding de Angular lo hace solo
}


  onOptionDiagnosticSelected(item: any)
  {
    // this.toothStateTypeFormGroup.patchValue({
    //   observations:item.shortName
    // });
    this. onClickDiagnosticSelected(item);
  }

  onClickDiagnosticSelected(item: any)
  {
     this.selectedDiagnostic = item;
    // this.toothStateTypeFormGroup.patchValue({
    //   observations:item.shortName
    // });
        this.toothStateTypeFormGroup.patchValue({ toothStateId: item });

  }

  toothStateDetailIdTemp=2000;


  getCheckboxesTooth():BOToothStateDetailToothFace[]
  {
    const cbTemp:BOToothStateDetailToothFace[]=[];
    const ts=this.toothStateTypeFormGroup.get('toothStateId').value;

    this.checkboxes.forEach((checkbox, index)=>
    {
      if(checkbox.checked)
      {
        const ttf=new BOToothStateDetailToothFace();
        ttf.toothStateDetailId=0;
        ttf.toothFaceId=parseInt(checkbox.id);
        ttf.toothStateId=ts.id;
        ttf.color='red';
        ttf.strokeColor='black';
        cbTemp.push(ttf);
      }
    });

    return cbTemp;
  }

  //#region TOOTSTATEDETAIL
  createNewToothStateDetail():BOToothStateDetail
  {
    let tt=this.toothTypeList.find(x=>x.id==this.toothSelected);
    let ts=this.toothStateTypeFormGroup.get('toothStateId').value;
    let tsName=this.toothStateTypeList.find(x=>x.id==ts.id).name;
    console.log("EN CNTSD ts es:", ts, "y tsName es:", tsName);

    const cbFaces=this.getCheckboxesTooth();
    const observationsTemp=this.toothStateTypeFormGroup.get('observations').value;
    const facesLetter=this.getFacesLetterById(cbFaces);
    const fixTemp=this.toothStateTypeFormGroup.get('fixed').value;
    console.log("Pasa fixed");
    const st=new BOToothStateDetail();
    st.id=0;
    st.toothStateDetailIdTemp=this.toothStateDetailIdTemp+1;
     st.toothTypeId=tt.id;
    st.toothStateId=ts.id;
    st.toothStateCategoryId=ts.toothStateCategoryId;
    st.personId=this.clinicHistory.patient.id;
    st.odontogramaId= this.clinicHistory.isOdontograma;
    st.date= new Date();
    st.clinicHistoryOdontologyId=this.clinicHistory.id;
    st.observations=tsName +": "+observationsTemp +"---SUPERFICIES:"+ facesLetter ;
    st.fixed=fixTemp;
    st.toothFaces=cbFaces;

    st.price=this.toothStateTypeFormGroup.get('price').value;
    st.verticalPosition=tt.positionInMouth;
    st.icd10Code=ts.code;
    st.icd10Name=ts.name;
    st.icd11Code=ts.icd11Code;
    st.icd11Name=ts.icd11Name;

    //this.toothStateDetailList
      // Verifica duplicados antes de llamar al servidor
      const exists = this.toothStateDetailList.some(elem => elem.toothStateId === st.toothStateId && elem.toothTypeId==st.toothTypeId);
      if (exists)
      {
        this.toastr.error("Fallo", "Ya existe este diagnóstico");
        return;
      }
    this.saveToothStateDetail(st);


    return st;
  }
  saveToothStateDetail(item:BOToothStateDetail)
  {
     this._toothStateDetailsService.createOrUpdateToothStateDetailSingle(item).subscribe({
      next:(data)=>
      {
        if(data)
        {
          this.toothStateDetailIdTemp=data.id;
          this.toothStateDetailList=[...this.toothStateDetailList, data];
          this.toothStateDetailList.sort((a,b)=>a.toothTypeId - b.toothTypeId);

              this.cleanToothStateTypeFormGroup();

          this.toastr.success("Éxito", "Se guardó el dato");

        }
        else
        {
            this.toastr.error("Fallo", "No se guardó el dato");
        }
      },
      error:(err)=>
      {
          console.log("Se produjo en error en guardar o actualizar datos");
      }
     })
  }

  createNewToothStateDetailDataList()
  {

     this.isLoading = true;    // ← 2. Inicia spinner

    try
    {
        this.stateSended=[];
        const ts=this.toothStateTypeFormGroup.get('toothStateId').value;
        if (!ts || !ts.id)
        {
            this.isLoading = false;                      // ← Detén spinner
            this.toastr.warning('Advertencia', 'Seleccione un estado');
            return;
        }

        const stateType = this.toothStateTypeList.find(x => x.id === ts.id);
        if (!stateType) {
          this.isLoading = false;                      // ← Detén spinner
          this.toastr.error('Error', 'Estado no encontrado');
          return;
        }

        if(this.selectedTooth.length==0)
        {
          this.isLoading = false;                      // ← Detén spinner
          this.toastr.error('Error', 'Estado debe escoger al menos un diente');
          return;
        }

        const tsName = stateType.name;
        console.log("EN CNTSD ts es:", ts, "y tsName es:", tsName);

        const cbFaces=this.getCheckboxesTooth();
        const observationsTemp=this.toothStateTypeFormGroup.get('observations').value;
        const facesLetter=this.getFacesLetterById(cbFaces);
        const fixTemp=this.toothStateTypeFormGroup.get('fixed').value;
        console.log("Pasa fixed");

        this.selectedTooth.forEach(elm=>
        {
            const st=new BOToothStateDetail();
            st.id=0;
            st.toothStateDetailIdTemp=this.toothStateDetailIdTemp+1;
            st.toothTypeId=elm.id;
            st.toothStateId=ts.id;
            st.toothStateCategoryId=ts.toothStateCategoryId;
            st.personId=this.clinicHistory.patient.id;
            st.odontogramaId= this.clinicHistory.isOdontograma;
            st.date= new Date();
            st.clinicHistoryOdontologyId=this.clinicHistory.id;
            st.observations=tsName +": "+observationsTemp +"---:"+ facesLetter;
            st.fixed=fixTemp;
            st.toothFaces=cbFaces;

            st.price=this.toothStateTypeFormGroup.get('price').value;
            st.verticalPosition=elm.positionInMouth;
            st.icd10Code=ts.code;
            st.icd10Name=ts.name;
            st.icd11Code=ts.icd11Code;
            st.icd11Name=ts.icd11Name;
          this.stateSended.push(st);
      });

      this.saveToothStateDetailDataList(this.stateSended);

    }
    catch (err)
    {
   this.isLoading = false;
      console.error('Error inesperado:', err);
      this.toastr.error('Error', 'Ocurrió un error inesperado');
    }

  }

  saveToothStateDetailDataList(item:BOToothStateDetail[])
  {
     this._toothStateDetailsService.CreateOrUpdateToothStateDetailDataList(item)
      .pipe(
        finalize(() => {
          // ← 3. Esto se ejecuta SIEMPRE al completar o fallar el observable
          this.isLoading = false;
        })
      )
     .subscribe({
      next:(data)=>
      {
        if(data)
        {

          data.forEach(d=>{
            this.toothStateDetailList.push(d);
          })
          //this.toothStateDetailIdTemp=data.id;
          //this.toothStateDetailList=[...this.toothStateDetailList, data];
          this.toothStateDetailList.sort((a,b)=>a.toothTypeId - b.toothTypeId);

              this.cleanToothStateTypeFormGroup();

          this.toastr.success("Éxito", "Se guardó el dato");

        }
        else
        {
            this.toastr.error("Fallo", "No se guardó el dato");
        }
      },
      error:(err)=>
      {
          this.toastr.error("Fallo", "No se guardó el dato");
          console.log("Se produjo en error en guardar o actualizar datos");
      }
     })
  }




  createEditToothStateDetailSingle(item:BOToothStateDetail)
  {
    console.log("Entra a CREATEEDITTOOTHSTATEDETAIL SINGLE")
    const elm= this.toothStateDetailList.find(x=>x.id==item.id);
    this.toothStateDetailList.sort((a,b)=>a.toothTypeId - b.toothTypeId);

    const details=item.observations;

    const st=new BOToothStateDetail();
    st.id=0;
    st.toothStateDetailIdTemp=this.toothStateDetailIdTemp+1;
    st.toothTypeId=elm.toothTypeId;
    st.toothStateId=elm.toothStateId;
    st.toothStateCategoryId=elm.toothStateCategoryId;

    st.personId=this.clinicHistory.patient.id;
    st.odontogramaId= this.clinicHistory.isOdontograma;
    st.date= new Date();
    st.clinicHistoryOdontologyId=this.clinicHistory.id;
    st.observations=details;
    st.fixed=elm.fixed;
    st.toothFaces=elm.toothFaces;
    st.price=elm.price;
    st.verticalPosition=elm.verticalPosition;
    st.icd10Code=elm.icd10Code;
    st.icd10Name=elm.icd10Name;
    st.icd11Code=elm.icd11Code;
    st.icd11Name=elm.icd11Name;

    this.updateToothStateSingle(st);
  }
  updateToothStateSingle(item: BOToothStateDetail)
  {
    this._toothStateDetailsService
      .createOrUpdateToothStateDetailSingle(item).subscribe({
        next:(data)=>
        {
          this.toothStateDetailList=
          this.toothStateDetailList.map(x=>
            x.id==data.id? data:x
          );
          this.toothStateDetailList.sort((a,b)=>a.toothTypeId - b.toothTypeId);

                     console.log("toothStateList actualizada es:",this.toothStateDetailList);

                    this.toastr.success(
                        "Éxito",
                        "Se actualizó el elemento"
                    );
        },
        error:(err)=>
        {


        }
      })
  }

  // handledPosSendedToothStateDetailSingle(event: {itemId:number, tipo:string, details:string})
  // {
  //     let confirm:boolean=false;
  //     if(event.tipo=='del')
  //     {
  //         this._dialogConfirm.openConfirmDialog('¿Confirma que desea borrar este item? ')
  //               .afterClosed().subscribe({
  //                 next:(res)=>
  //                 {
  //                   confirm=res;

  //                   if(confirm)
  //                   {
  //                   this.deleteToothStateDetailSingle(event.itemId)

  //                   }
  //                   else
  //                   {
  //                     this.close();
  //                   }
  //                 },
  //                 error:(err)=>{
  //                   console.log("Se produjo un error al confirmar borrado de antecedente");
  //                 }
  //               })

  //     }

  //     if(event.tipo=='edi')
  //     {
  //       this._dialogConfirm.openConfirmDialog('¿Confirma que desea editar este item? ')
  //             .afterClosed().subscribe({
  //               next:(res)=>
  //               {
  //                 confirm=res;

  //                 if(confirm)
  //                 {
  //                   this.createEditToothStateDetailSingle(event.itemId, event.details);
  //                 }
  //                 else
  //                 {
  //                   this.close();
  //                 }
  //               },
  //               error:(err)=>{
  //                 console.log("Se produjo un error al confirmar borrado de estados");
  //               }
  //             })
  //     }
  // }
  handledPosSendedToothStateDetailSingle(event: {item:BOToothStateDetail, tipo:string})
  {
      let confirm:boolean=false;
      if(event.tipo=='del')
      {
          this._dialogConfirm.openConfirmDialog('¿Confirma que desea borrar este item? ')
                .afterClosed().subscribe({
                  next:(res)=>
                  {
                    confirm=res;

                    if(confirm)
                    {
                    this.deleteToothStateDetailSingle(event.item.id)

                    }
                    else
                    {
                      this.close();
                    }
                  },
                  error:(err)=>{
                    console.log("Se produjo un error al confirmar borrado de antecedente");
                  }
                })

      }

      if(event.tipo=='edi')
      {
        this._dialogConfirm.openConfirmDialog('¿Confirma que desea editar este item? ')
              .afterClosed().subscribe({
                next:(res)=>
                {
                  confirm=res;

                  if(confirm)
                  {
                    this.createEditToothStateDetailSingle(event.item);
                  }
                  else
                  {
                    this.close();
                  }
                },
                error:(err)=>{
                  console.log("Se produjo un error al confirmar borrado de estados");
                }
              })
      }
  }


  deleteToothStateDetailSingle(itemId:number)
  {
        this._toothStateDetailsService
            .deleteToothStateDetailSingle(itemId)
            .subscribe({

                next: data => {

                    if(data)
                    {
                console.log("ANTES DE BORRAR this.ToothStateDetailList es:",this.toothStateDetailList);

                        this.toothStateDetailList =
                            this.toothStateDetailList.filter(
                                x => x.id !== itemId
                            );
                console.log("DESPUES DE BORRAR this.OdontologyTissuePatientsList es:",this.toothStateDetailList);

                        this.toastr.success(
                            "Éxito",
                            "Se borraron los datos"
                        );
                    }
                    else{

                        this.toastr.error(
                            "Fallo",
                            "No se borraron los datos"
                        );

                    }

                },

                error: err => {

                    console.error(err);

                }

            });


  }

  trackByFnToothStateDetail(index: number, item: BOToothStateDetail): number {
    return item.id; // Angular usa esto para identificar elementos
  }

  trackByFnClinicHistoryObservations(index: number, item: BOClinicHistoryObservations): number {
    return item.id; // Angular usa esto para identificar elementos
  }

  cleanToothStateTypeFormGroup()
  {
    this.toothStateTypeFormGroup.patchValue({
      //toothTypeId:  '',
      //toothStateId: '',
      //toothStateCategoryId:'',
      observations: '',
      fixed:        false,
      price:        0,
      vestibular:   false,
      medial:       false,
      distal:       false,
      palatino:     false,
      center:       false,
      lingual:      false,
      incisal:      false,
    })


  }
  //#endregion TOOTSTATEDETAIL
  navigateToQuoteFromClinicHistory(clinicHistoryId:number, personId:number, personName:string, isQuoteWithOdontograma?:boolean, personDocumentId?:number)
  {

      this._router.navigate(['/dental-Admins/quote'], {

        state: {
          clinicHistoryId: clinicHistoryId,
          personId: personId,
          userName:personName,
         isQuoteWithOdontograma:isQuoteWithOdontograma,
         action: 'openToothQuote',  // ← trigger para ejecutar
         personDocumentId:personDocumentId
        }

      });

  }

  onOptionToothTypeIdSelected(item:any)
  {
    if(item.positionInMouth=='md-up' || item.positionInMouth=='mi-up')
    {
      this.isLingual=false;
      this.isPalatino=true;
    }
    else
    {
          this.isLingual=true;
          this.isPalatino=false;
    }

    let test= this.existIncisal(item.id);
    console.log( "EN OPTIONTOOTHTYPEIDSELECTED exists es:", test);
    if(this.existIncisal(item.id))
    {
      this.isIncisal=true;
      this.isOclusal=false;

    }
    else
    {
      this.isIncisal=false;
      this.isOclusal=true;

    }


  }

  existIncisal(num:string):boolean
  {
    const nc=Number(num);
    const exists= this.incisal.includes(nc);
    return exists;
  }




  // selectToothFromSvg(item:any)
  // {
  //   this.toothSelected=item.id;
  //   this.toothStateTypeFormGroup.get('toothTypeId')?.setValue(item);

  //   let result=this.toothStateTypeFormGroup.get('toothStateId').value;

  //   this._cdr.detectChanges();

  //   if(item.positionInMouth=='md-up' || item.positionInMouth=='mi-up')
  //   {
  //     this.isLingual=false;
  //     this.isPalatino=true;
  //   }
  //   else
  //   {
  //         this.isLingual=true;
  //         this.isPalatino=false;

  //   }

  //   if(this.existIncisal(item.id))
  //   {
  //     this.isIncisal=true;
  //     this.isOclusal=false;

  //   }
  //   else
  //   {
  //     this.isIncisal=false;
  //     this.isOclusal=true;

  //   }

  // }


    getFacesLetterById(faces: BOToothStateDetailToothFace[]): string
      {

        let data="";

        faces.forEach(f=>{
          let lt=this.toothFaceTypeList.find(x=>x.id==f.toothFaceId).letter;
          data=data+lt+',';
        })

        if(data.length>0)
        {
          data=data.slice(0,-1);
        }
      return data;


    }

    trackByCategoryId(index: number, item: BOToothStateCategory): number {
      return item.id;
    }


    trackByDiagnosticId(index: number, item: BOToothStateType): number {
      return item.id;
    }

    getStateNameForChild(stateId:number):string
    {
    let result= Utilities.getStateName(stateId, this.toothStateTypeList);
    return result;

    }

//   formatToDDMMYYYY(dateInput: string | Date | null): string
//   {
//     if (!dateInput) return '';

//     const date = new Date(dateInput);
//     const day = String(date.getUTCDate()).padStart(2, '0');
//     const month = String(date.getUTCMonth() + 1).padStart(2, '0');
//     const year = date.getUTCFullYear();

//     return `${day}/${month}/${year}`;
// }
 formatToDDMMYYYY(dateString: string): string {
  if (!dateString) {
    return '';
  }

  const [datePart] = dateString.split('T');
  const [year, month, day] = datePart.split('-');

  return `${day}/${month}/${year}`;
}
/**
   * Click normal: reemplaza toda la selección por este único diente
   * (sea que el array esté vacío, tenga uno o varios elementos).
   * Ctrl/Cmd + Click: alterna (agrega si no está, quita si ya está)
   * sin afectar al resto de seleccionados.
   */
  selectToothFromSvg(tooth: BOToothType, event: MouseEvent): void {
    event.stopPropagation(); // evita que dispare el listener del document

    const isCtrlPressed = event.ctrlKey || event.metaKey;
    const index = this.selectedTooth.findIndex(t => t.id === tooth.id);

    if (isCtrlPressed) {
      if (index > -1) {
        this.selectedTooth.splice(index, 1);
      } else {
        this.selectedTooth.push(tooth);
      }
    } else {
      this.selectedTooth = [tooth];
    }

    this.onOptionToothTypeIdSelected(tooth);


  }

  isSelected(tooth: BOToothType): boolean {
    return this.selectedTooth.some(t => t.id === tooth.id);
  }

  /**
   * Click fuera de un svg -> deselecciona todo y vacía el array.
   * Excepción: si el click es sobre #btnCrear, no se toca la selección
   * y se deja correr su propio (click) handler.
   */
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    if (target.closest('.excludeClick')) {
      return; // excepción: no limpiar selección
    }

      // NUEVA excepción: si el usuario seleccionó texto (drag sobre un input,
  // textarea o cualquier texto), no deseleccionar los botones.
  const selection = window.getSelection();
  if (selection && selection.toString().length > 0) {
    return;
  }

    if (!target.closest('.svg-layer')) {
      this.selectedTooth = [];
    }
  }

  // Mismo comportamiento para doble click fuera de un svg
  @HostListener('document:dblclick', ['$event'])
  onDocumentDblClick(event: MouseEvent): void {
    this.onDocumentClick(event);
  }

  goToEvolutions(clinicHistoryId:number)
  {
    console.log("ENTRA A GOTODIAGNOSTIC, this.clinicHistory es:", this.clinicHistory);
     this.stepper.linear = false; // Desactiva el modo lineal
     this.showOnlyObservations=false;
     this._cdr.detectChanges();
     this.stepper.selectedIndex=8;
     this.stepper.linear = true; // Reactiva el modo lineal si es necesario
  }


}
